import * as swcHelpers from '@swc/helpers';
import * as React from 'react';
import React__default, { createContext, useContext, useState, useCallback, useMemo, useEffect } from 'react';
import { getDisplayName, getLocalizedValue, convertCentsToDecimalString, isNil, useEventListener, useInterval, optionalKey, parseHtml, useDynamicModule, useDebouncedEffect, isNotNull, QueryString } from '@grandvisionhq/utils';
import { ExpressPaymentMethod, AdyenBrands, PaymentMethod, Hooks as Hooks$1, useAdyen, CreditCard, AdyenPaymentType, Ideal as Ideal$1, Mbway as Mbway$1, Oney as Oney$1, Sepa as Sepa$1, PaymentServiceProvider, ApplePayCheckoutButton } from '@grandvisionhq/payments';
import { useIntl, statusUninit, statusLoading, statusFailed, statusSuccess, useDispatch, useSelector, ApiConfigSelectors, withIntl, useApiConfig, uninitState, failedState, successState, loadingState, IntlSelectors, useFeatureToggles, useStore, connect, ReducersRegistry, SagaRegistry } from '@grandvisionhq/state';
import { toast, Alert, Card, RadioButtonGroup, Loader, Modal, Price, Button, Link, StickyCallToAction, MediaQuery, LoaderScreen, Logo, SupportFooter, Summary } from '@grandvisionhq/common';
import { cartIdVar, Context, Hooks, Operations, Cart, CartSlider, Mappers } from '@grandvisionhq/carts-v2';
import { gql, useMutation, Types as Types$1 } from '@grandvisionhq/graphql';
import { Orders, Payments, PaymentTypes, ResponseError, Carts, Products } from '@grandvisionhq/api-client';
import isEmpty from 'lodash/isEmpty';
import { pickBy, identity } from 'lodash';
import { createMemoryHistory, createBrowserHistory } from 'history';
import { createSelector } from 'reselect';
import { Util, CheckboxWithLabel, useFormContext, CheckboxList, Form } from '@grandvisionhq/forms';
import identity$1 from 'lodash/identity';
import pickBy$1 from 'lodash/pickBy';
import { combineReducers } from 'redux';
import { takeLatest, put, race, take, delay, select, call, fork, takeLeading, all } from 'redux-saga/effects';
import { GoogleAnalytics, DataLayer, calcPrice } from '@grandvisionhq/analytics';
import { Selectors, Utils, getToken, Actions, Types, useOptIns, useAvailableOptIns } from '@grandvisionhq/auth';
import { ProfileSelectors, WithUserData } from '@grandvisionhq/my-account';
import { END } from 'redux-saga';
import { setPreferredShippingMethod, useGetShippingMethods } from '@grandvisionhq/shipping';
import { AddressSearchForm, OpeningHours, usePlacePredictions } from '@grandvisionhq/locations';
import classnames from 'classnames';
import { useBloomreachPageRoutes } from '@grandvisionhq/bloomreach';
import { motion } from 'framer-motion';
import { debounce } from 'throttle-debounce';
import { createSlotsContext } from '@grandvisionhq/slots';
import { Heading, Text } from '@grandvisionhq/elements';
import { Icon } from '@grandvisionhq/icons';
import { Hooks as Hooks$2, useStoreFinderContext, Components } from '@grandvisionhq/stores-v2';
import { SplitPane } from '@grandvisionhq/layout';

const CheckoutSettingsContext = /*#__PURE__*/ createContext(null);
const CheckoutSettingsConsumer = CheckoutSettingsContext.Consumer;
CheckoutSettingsContext.displayName = 'CheckoutSettings';
const useCheckoutSettings = ()=>{
    const context = useContext(CheckoutSettingsContext);
    if (context === null) {
        throw new Error('Missing CheckoutSettings provider. You have to wrap the application with the CheckoutSettingsProvider component from the @grandvisionhq/checkout-v2 package.');
    }
    return context;
};
function withCheckoutSettings(Component) {
    const displayName = getDisplayName(Component);
    function WithCheckoutSettings(props) {
        const context = useCheckoutSettings();
        return /*#__PURE__*/ React__default.createElement(Component, swcHelpers.extends({}, props, {
            checkoutSettings: context
        }));
    }
    WithCheckoutSettings.displayName = `WithCheckoutSettings(${displayName})`;
    return WithCheckoutSettings;
}

const defaultSettings = {
    account: {
        createAccountRequired: false,
        implicitAccountCreation: false
    },
    consent: {
        implicitTermsAndConditions: false
    }
};
const CheckoutSettingsProvider = ({ children , settings  })=>{
    const value = React.useMemo(()=>swcHelpers.objectSpread({}, defaultSettings, settings)
    , [
        settings
    ]);
    return /*#__PURE__*/ React.createElement(CheckoutSettingsContext.Provider, {
        value: value
    }, children);
};

var index$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  useCheckoutSettings: useCheckoutSettings,
  CheckoutSettingsConsumer: CheckoutSettingsConsumer,
  withCheckoutSettings: withCheckoutSettings,
  CheckoutSettingsProvider: CheckoutSettingsProvider
});

const useExpressCheckoutLabels = ()=>{
    const { getLabel  } = useIntl();
    const getTitle = React__default.useCallback((type)=>{
        switch(type){
            case ExpressPaymentMethod.APPLE_PAY:
                return getLabel('checkout.express.apple.pay.header.title');
            default:
                return `Checkout with ${type}`;
        }
    }, [
        getLabel
    ]);
    return {
        getTitle
    };
};

var CheckoutCustomerType;
(function(CheckoutCustomerType) {
    CheckoutCustomerType["B2B"] = "B2B";
    CheckoutCustomerType["B2C"] = "B2C";
})(CheckoutCustomerType || (CheckoutCustomerType = {}));
var CheckoutState$1;
(function(CheckoutState) {
    CheckoutState["Finalized"] = "Finalized";
    CheckoutState["InProgress"] = "InProgress";
    CheckoutState["ReadyToOrder"] = "ReadyToOrder";
})(CheckoutState$1 || (CheckoutState$1 = {}));

const INIT = 'checkout/INIT';
const GO_TO_STEP = 'checkout/GO_TO_STEP';
const TOGGLE_ACCOUNT_CREATION = 'checkout/my-account/TOGGLE_ACCOUNT_CREATION';
const SET_CHANGED_OPT_INS = 'checkout/my-account/SET_CHANGED_OPT_INS';
const ACCOUNT_CREATE_SUCCESS = 'checkout/my-account/ACCOUNT_CREATE_SUCCESS';
const UPDATE_CART_STATE = 'checkout/cart/UPDATE_CART_STATE';
const CART_UPDATE_FAILED = 'checkout/cart/CART_UPDATE_FAILED';
const CART_RESTORE = 'checkout/cart/CART_RESTORE';
const INIT_ORDER = 'checkout/order/INIT_ORDER';
const ORDER_CREATE = 'checkout/order/CREATE_ORDER';
const ORDER_CREATE_SUCCESS = 'checkout/order/ORDER_CREATE_SUCCESS';
const ORDER_CREATE_FAILED = 'checkout/order/ORDER_CREATE_FAILED';
const ORDER_SET = 'checkout/order/ORDER_SET';
const ORDER_CLEAR = 'checkout/order/ORDER_CLEAR';
const ORDER_GET_BY_TOKEN = 'checkout/order/GET_ORDER_BY_TOKEN';
const ORDER_GET_BY_TOKEN_SUCCESS = 'checkout/order/GET_ORDER_BY_TOKEN_SUCCESS';
const ORDER_GET_BY_TOKEN_FAILED = 'checkout/order/GET_ORDER_BY_TOKEN_FAILED';
const POST_PAYMENT_TO_PSP = 'checkout/order/POST_PAYMENT_TO_PSP';
const GET_ADDITIONAL_COSTS = 'checkout/GET_ADDITIONAL_COSTS';
const GET_ADDITIONAL_COSTS_SUCCESS = 'checkout/GET_ADDITIONAL_COSTS_SUCCESS';
const GET_ADDITIONAL_COSTS_FAILED = 'checkout/GET_ADDITIONAL_COSTS_FAILED';
const REFRESH_PAYMENT_FOR_ORDER = 'checkout/REFRESH_PAYMENT_FOR_ORDER';
const PAYMENT_SUCCESS_FOR_ORDER = 'checkout/PAYMENT_SUCCESS_FOR_ORDER';
const CLEAR_ERROR = 'checkout/error/CLEAR_ERROR';
const init = (payload)=>({
        type: INIT,
        payload
    })
;
const goToStep = (payload)=>({
        type: GO_TO_STEP,
        payload
    })
;
const updateCartState = (payload)=>({
        type: UPDATE_CART_STATE,
        payload
    })
;
const restoreCart = (payload)=>({
        type: CART_RESTORE,
        payload
    })
;
const initOrder = ()=>({
        type: INIT_ORDER
    })
;
const createOrder = (payload)=>({
        type: ORDER_CREATE,
        payload
    })
;
const createOrderSuccess = (payload)=>({
        type: ORDER_CREATE_SUCCESS,
        payload
    })
;
const createOrderFailed = (error)=>({
        type: ORDER_CREATE_FAILED,
        error
    })
;
const clearError = ()=>({
        type: CLEAR_ERROR
    })
;
const setOrder = (payload)=>({
        type: ORDER_SET,
        payload
    })
;
const getOrderByToken = (payload)=>({
        type: ORDER_GET_BY_TOKEN,
        payload
    })
;
const getOrderByTokenSucces = (payload)=>({
        type: ORDER_GET_BY_TOKEN_SUCCESS,
        payload
    })
;
const getOrderByTokenFailed = (error)=>({
        type: ORDER_GET_BY_TOKEN_FAILED,
        error
    })
;
const postPaymentToPsp = (payload)=>({
        type: POST_PAYMENT_TO_PSP,
        payload
    })
;
const toggleAccountCreation = (payload)=>({
        type: TOGGLE_ACCOUNT_CREATION,
        payload
    })
;
const setChangedOptIns = (payload)=>({
        type: SET_CHANGED_OPT_INS,
        payload
    })
;
const getAdditionalCosts = ()=>({
        type: GET_ADDITIONAL_COSTS
    })
;
const getAdditionalCostsSuccess = (payload)=>({
        type: GET_ADDITIONAL_COSTS_SUCCESS,
        payload
    })
;
const getAdditionalCostsFailed = (error)=>({
        type: GET_ADDITIONAL_COSTS_FAILED,
        error
    })
;
const refreshPaymentForOrder = (payload)=>({
        type: REFRESH_PAYMENT_FOR_ORDER,
        payload
    })
;
const paymentSuccessForOrder = ()=>({
        type: PAYMENT_SUCCESS_FOR_ORDER
    })
;

/**
 * Backend response from api-client is an enum value
 * The FE wants to use string constants for easier checks and handling
 *
 * This abstraction also makes it possible to migrate to grapqhl later on
 */ const mapPaymentState = (paymentState)=>{
    switch(paymentState.paymentState){
        case Orders.PaymentState.Pending:
            return 'Pending';
        case Orders.PaymentState.Paid:
            return 'Paid';
        case Orders.PaymentState.Failed:
            return 'Failed';
        case Orders.PaymentState.BalanceDue:
            return 'BalanceDue';
        case Orders.PaymentState.CreditOwed:
            return 'CreditOwed';
        default:
            return undefined;
    }
};

const mapShippingMethods = ({ asides , locale , logos , shippingMethodInfo , shippingMethods  })=>{
    const initialState = {
        isLoading: false,
        hasError: false,
        items: []
    };
    if (!shippingMethods || statusUninit(shippingMethods) || statusLoading(shippingMethods)) {
        return swcHelpers.objectSpread({}, initialState, {
            isLoading: true
        });
    }
    if (statusFailed(shippingMethods)) {
        return swcHelpers.objectSpread({}, initialState, {
            hasError: true
        });
    }
    if (statusSuccess(shippingMethods)) {
        if (!shippingMethods.result || !shippingMethods.result.length) {
            return swcHelpers.objectSpread({}, initialState, {
                hasError: true
            });
        }
        const availableShippingMethods = shippingMethods.result;
        const items = availableShippingMethods.map((method)=>{
            const label = method.localizedDescription ? getLocalizedValue(method.localizedDescription, locale) : '';
            return {
                value: method.key,
                label,
                id: method.id,
                subtext: asides && asides[method.key],
                aside: shippingMethodInfo({
                    price: method.price,
                    logo: logos && logos[method.key],
                    isFree: Boolean(method.isFree)
                })
            };
        });
        return swcHelpers.objectSpread({}, initialState, {
            items
        });
    }
    return initialState;
};

const errorsMapping = {
    SOMETHING_WENT_WRONG: 'checkout.errors.somethingWentWrong',
    ORDER_NOT_FOUND: 'checkout.errors.orderNotFound'
};
const cartUpdateErrorsMapping = {
    UnknownUpdateCartFailure: 'checkout.errors.cartUpdateFailed',
    ShippingMethodDoesNotMatchCartFailure: 'checkout.errors.shippingMethodNotMatched',
    ShipmentMethodNotFoundFailure: 'checkout.errors.shippingMethodNotFound'
};
const ExpressCheckoutErrorMapping = {
    ExpressCheckoutOrderFailed: 'errors.order.message',
    SomethingWentWrong: 'checkout.errors.form.general',
    TryAgain: 'common.errors.recoverable.generic',
    CartNotFound: 'cart.errors.cartNotFound',
    CartIdNotFound: 'cart.errors.missingCartID',
    PaymentMethodNotFound: 'checkout.errors.paymentMethods.title',
    CreateOrderFailed: 'checkout.errors.order.message'
};
const ApplePaySessionErrors = {
    ApplePaySessionUnsupported: 'checkout.express.apple.pay.errors.unsupported',
    ApplePaySessionFailed: 'checkout.express.apple.pay.errors.failed',
    ApplePayPaymentFailed: 'checkout.express.apple.pay.errors.payment.failed',
    ApplePayInvalidAddress: 'checkout.express.apple.pay.errors.invalid.address'
};

const checkoutMutationResult = gql`
  fragment CheckoutMutationResultFragment on CheckoutMutationResponse {
    code
    success
    message
    checkoutState
    __typename
  }
`;

const shipmentMethodNotFoundFailure = gql`
  fragment ShipmentMethodNotFoundFailureFragment on UpdateCartFailure {
    ... on ShipmentMethodNotFoundFailure {
      cartId
      message
      code
      reason
    }
  }
`;
const shipmentMethodDoesNotMatchCartFailure = gql`
  fragment ShipmentMethodDoesNotMatchCartFailureFragment on UpdateCartFailure {
    ... on ShippingMethodDoesNotMatchCartFailure {
      cartId
      message
      code
      reason
    }
  }
`;
const unknownUpdateCartFailure = gql`
  fragment UnknownUpdateCartFailureFragment on UpdateCartFailure {
    ... on UnknownUpdateCartFailure {
      cartId
      message
      code
      reason
    }
  }
`;

const SET_CUSTOMER_DETAILS = gql`
  mutation SetCustomerDetails($customerDetailsInput: CheckoutSetCustomerDetailsInput!) {
    setCustomerDetails(customerDetailsInput: $customerDetailsInput) {
      ...CheckoutMutationResultFragment
      failures {
        ...UnknownUpdateCartFailureFragment
      }
    }
  }
  ${checkoutMutationResult}
  ${unknownUpdateCartFailure}
`;

const SET_SHIPPING_METHOD = gql`
  mutation SetShippingMethod($shippingMethodInput: ShippingMethodInput!) {
    setShippingMethod(shippingMethodInput: $shippingMethodInput) {
      ...CheckoutMutationResultFragment
      failures {
        ...ShipmentMethodNotFoundFailureFragment
        ...ShipmentMethodDoesNotMatchCartFailureFragment
        ...UnknownUpdateCartFailureFragment
      }
    }
  }
  ${checkoutMutationResult}
  ${shipmentMethodDoesNotMatchCartFailure}
  ${unknownUpdateCartFailure}
  ${shipmentMethodNotFoundFailure}
`;

const SET_STORE = gql`
  mutation SetStore($storeInput: CheckoutStoreInput!) {
    setStore(storeInput: $storeInput) {
      ...CheckoutMutationResultFragment
      failures {
        ...UnknownUpdateCartFailureFragment
      }
    }
  }
  ${checkoutMutationResult}
  ${unknownUpdateCartFailure}
`;

const createApplePaySessionResult = gql`
  fragment CreateApplePaySessionResultFragment on ApplePaySession {
    data
    __typename
  }
`;

const CREATE_APPLE_PAY_SESSION = gql`
  mutation CreateApplePaySession($applePaySessionInput: CreateApplePaySessionInput!) {
    createApplePaySession(input: $applePaySessionInput) {
      ...CreateApplePaySessionResultFragment
    }
  }
  ${createApplePaySessionResult}
`;

// graphql endpoint wants iso format (yyyy-mm-dd)
const convertToGqlDateFormat = (date)=>{
    const [year, month, day] = date.split('-');
    return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`;
};

const mapConsentsToOrderModel = (consents)=>{
    if (isEmpty(consents)) {
        return undefined;
    }
    const consentsGiven = consents.filter((consent)=>consent.isChecked === true
    );
    return consentsGiven.reduce((result, consent)=>swcHelpers.objectSpread({}, result, {
            [consent.value]: {
                uiType: 'checkbox',
                literalText: consent.title
            }
        })
    , {});
};

const getFlattenedCartFailureErrorCodes = (failureList)=>{
    let errorCodes = [];
    if (failureList && failureList.length) {
        errorCodes = failureList.reduce((pre, next)=>[
                ...pre,
                cartUpdateErrorsMapping[next.__typename]
            ]
        , errorCodes);
    }
    return errorCodes;
};

var PaymentFlow;
(function(PaymentFlow) {
    PaymentFlow["REDIRECT"] = 'Redirect';
    PaymentFlow["ACTIONLESS"] = 'Actionless';
    PaymentFlow["QR_CODE"] = 'QrCode';
    PaymentFlow["UNDEFINED"] = 'Undefined';
})(PaymentFlow || (PaymentFlow = {}));

var AddressLineFormat;
(function(AddressLineFormat) {
    AddressLineFormat["streetName_streetNumber"] = "streetName_streetNumber";
    AddressLineFormat["streetNumber_streetName"] = "streetNumber_streetName";
})(AddressLineFormat || (AddressLineFormat = {}));

var ShippingMethod;
(function(ShippingMethod) {
    ShippingMethod["Delivery"] = 'home-delivery';
    ShippingMethod["DeliveryExpress"] = 'home-delivery-express';
    ShippingMethod["NearestPickup"] = 'nearest-pick-up';
    ShippingMethod["Pickup"] = 'pick-up';
    ShippingMethod["PickupPoint"] = 'pick-up-point';
})(ShippingMethod || (ShippingMethod = {}));

var StepNames;
(function(StepNames) {
    StepNames["Login"] = 'login';
    StepNames["Shipping"] = 'shipping';
    StepNames["Overview"] = 'overview';
    StepNames["Payment"] = 'payment';
    StepNames["Callback"] = 'callback';
    StepNames["Completed"] = 'completed';
})(StepNames || (StepNames = {}));

/**
 * Shipping method helpers
 */ const isDelivery = (method)=>method === ShippingMethod.Delivery
;
const isDeliveryExpress = (method)=>method === ShippingMethod.DeliveryExpress
;
const isNearestPickup = (method)=>method === ShippingMethod.NearestPickup
;
const isPickupStore = (method)=>method === ShippingMethod.Pickup
;
const isPickupPoint = (method)=>method === ShippingMethod.PickupPoint
;

const createAddress = (data)=>{
    const { title , salutation , firstName , lastName , middleName , additionalAddressInfo , streetName , streetNumber , additionalStreetInfo , city , company , postalCode , region , state , phone , email , externalId , countryCode ,  } = data;
    const address = swcHelpers.objectSpread({
        title,
        salutation,
        firstName,
        lastName,
        middleName
    }, !isEmpty(additionalAddressInfo) ? {
        additionalAddressInfo
    } : null, {
        streetName,
        streetNumber: streetNumber !== null && streetNumber !== void 0 ? streetNumber : undefined
    }, !isEmpty(additionalStreetInfo) ? {
        additionalStreetInfo
    } : null, {
        company: company !== null && company !== void 0 ? company : undefined,
        countryCode,
        city,
        postalCode,
        state,
        region,
        phone,
        email,
        externalId
    });
    return pickBy(address, identity);
};
const convertStoreToAddress = (store)=>{
    const { code , name , streetName , streetNumber , additionalStreetInfo , postalCode , town , emailAddress , phone ,  } = store;
    return {
        externalId: code.toString() || '',
        company: name,
        city: town,
        email: emailAddress !== null && emailAddress !== void 0 ? emailAddress : undefined,
        phone,
        streetName,
        streetNumber: streetNumber !== null && streetNumber !== void 0 ? streetNumber : undefined,
        additionalStreetInfo: additionalStreetInfo !== null && additionalStreetInfo !== void 0 ? additionalStreetInfo : undefined,
        postalCode: postalCode !== null && postalCode !== void 0 ? postalCode : undefined
    };
};
const convertPickupPointToAddress = (pickupPoint)=>{
    const { code , name , streetName , streetNumber , additionalStreetInfo , postalCode , town ,  } = pickupPoint;
    return {
        externalId: code.toString() || '',
        company: name,
        city: town,
        streetName,
        streetNumber: streetNumber !== null && streetNumber !== void 0 ? streetNumber : undefined,
        additionalStreetInfo: additionalStreetInfo !== null && additionalStreetInfo !== void 0 ? additionalStreetInfo : '',
        postalCode: postalCode !== null && postalCode !== void 0 ? postalCode : undefined
    };
};
var InvoiceFieldMapForPayload;
(function(InvoiceFieldMapForPayload) {
    InvoiceFieldMapForPayload["secondaryEmail"] = 'certifiedEmail';
    InvoiceFieldMapForPayload["customerCode"] = "customerCode";
    InvoiceFieldMapForPayload["fiscalNumber"] = 'customerCode';
    InvoiceFieldMapForPayload["recipientCode"] = 'certifiedRecipientCode';
    InvoiceFieldMapForPayload["customerVatId"] = 'vatId';
})(InvoiceFieldMapForPayload || (InvoiceFieldMapForPayload = {}));
const createInvoice = (invoiceDetails)=>{
    if (!invoiceDetails) return true;
    const invoice = Object.entries(invoiceDetails).reduce((result, [key, value])=>{
        return InvoiceFieldMapForPayload[key] ? Object.assign(result, swcHelpers.objectSpread({}, result, {
            [InvoiceFieldMapForPayload[key]]: value
        })) : result;
    }, {});
    return invoice;
};
const getCustomerDetailsPayload = ({ shippingDetails , countryCode , locale , isMultilingualEnabled , selectedPickupPoint , selectedShippingMethod , selectedStore  })=>{
    const customerDetailsPayload = swcHelpers.objectSpread({}, isMultilingualEnabled && locale ? {
        locale
    } : null);
    const { billingAddress , deliveryAddress , contactDetails , invoice , company  } = shippingDetails;
    let phone;
    // Extract and set customer details
    if (contactDetails) {
        phone = contactDetails.phone ? contactDetails.phone : null;
        let dateOfBirth = contactDetails.dateOfBirth || contactDetails.customerDateOfBirth || contactDetails.customerDOB || '';
        dateOfBirth = dateOfBirth === '' ? null : dateOfBirth;
        customerDetailsPayload.customerDetails = swcHelpers.objectSpread({
            email: contactDetails.email
        }, phone ? {
            phone
        } : null, contactDetails.secretIBAN ? {
            IBAN: contactDetails.secretIBAN
        } : null, dateOfBirth ? {
            dateOfBirth: convertToGqlDateFormat(dateOfBirth)
        } : null, {
            customerType: company ? CheckoutCustomerType.B2B : CheckoutCustomerType.B2C
        });
    }
    // Extract and set invoice details
    const invoiceDetails = invoice && createInvoice(invoice);
    if (invoiceDetails) {
        customerDetailsPayload.invoiceDetails = invoiceDetails;
    }
    // PT opcos deviate from the pattern. They have the customerVatId in ContactDetails.
    if (contactDetails === null || contactDetails === void 0 ? void 0 : contactDetails.customerVatId) {
        customerDetailsPayload.invoiceDetails = createInvoice(swcHelpers.objectSpread({}, invoice ? invoice : {}, {
            customerVatId: contactDetails === null || contactDetails === void 0 ? void 0 : contactDetails.customerVatId
        }));
    }
    /**
   * We should always have a billing address when delivery
   * Extract and set billing details
   */ //
    customerDetailsPayload.billingAddress = createAddress(swcHelpers.objectSpread({
        countryCode
    }, billingAddress));
    // Extract and set shipping details
    customerDetailsPayload.shippingAddress = deliveryAddress ? createAddress(swcHelpers.objectSpread({
        countryCode
    }, deliveryAddress)) : customerDetailsPayload.billingAddress;
    if (company) {
        customerDetailsPayload.invoiceDetails = createInvoice(company);
        customerDetailsPayload.billingAddress.company = company.name;
        customerDetailsPayload.shippingAddress.company = company.name;
    }
    if (customerDetailsPayload.invoiceDetails && customerDetailsPayload.invoiceDetails.certifiedEmail === '') {
        customerDetailsPayload.invoiceDetails.certifiedEmail = null;
    }
    if ((isDelivery(selectedShippingMethod.method) || isDeliveryExpress(selectedShippingMethod.method)) && phone) {
        customerDetailsPayload.shippingAddress.phone = phone;
    }
    if (isNearestPickup(selectedShippingMethod.method)) {
        // Use the billing address as the shipping address
        customerDetailsPayload.shippingAddress = swcHelpers.objectSpread({}, customerDetailsPayload.billingAddress, phone ? {
            phone
        } : null);
    }
    // If shipping method is pickup we need to fabricate an address with the data that we do have
    if (isPickupStore(selectedShippingMethod.method)) {
        if (selectedStore) {
            const storeAddress = convertStoreToAddress(selectedStore);
            customerDetailsPayload.shippingAddress = swcHelpers.objectSpread({}, storeAddress, {
                countryCode,
                firstName: customerDetailsPayload.billingAddress.firstName,
                lastName: customerDetailsPayload.billingAddress.lastName
            });
        }
    }
    if (isPickupPoint(selectedShippingMethod.method)) {
        // Set store as delivery address
        if (selectedPickupPoint) {
            const pickupPointAddress = convertPickupPointToAddress(selectedPickupPoint);
            customerDetailsPayload.shippingAddress = swcHelpers.objectSpread({}, pickupPointAddress, {
                countryCode,
                firstName: customerDetailsPayload.billingAddress.firstName,
                lastName: customerDetailsPayload.billingAddress.lastName
            });
        }
    }
    if (phone) {
        customerDetailsPayload.billingAddress.phone = phone;
    }
    return customerDetailsPayload;
};

// Sometimes a form has only optional fields. This function checks if at least one of the fields
// was filled out so we don't render an empty summary block for it
const optionalFormContainsData = (formData)=>formData && Object.values(formData).some((value)=>!!value
    )
;

const redirect = (route)=>window && window.location.replace(route)
;

function removeCartFromLocalStorage() {
    localStorage && localStorage.removeItem('stored_cart');
}

const isFinishedCheckout = (currentStep)=>{
    // Regular flow to make sure all old logic still works
    const isCompletedStep = currentStep === StepNames.Completed;
    const isCallbackStep = currentStep === StepNames.Callback;
    return isCompletedStep || isCallbackStep;
};

const createReverseRouteLookup = (routes)=>{
    return Object.entries(routes || {}).reduce((reverse, [name, route])=>{
        if (route === null || route === void 0 ? void 0 : route.path) {
            return swcHelpers.objectSpread({}, reverse, {
                [route.path]: name
            });
        }
        return reverse;
    }, {});
};

/**
 * Wrapper around the history package to memoize and create server-side polyfill
 */ let _history;
const history = ()=>{
    if (!_history) {
        _history = typeof window === 'undefined' ? createMemoryHistory() : createBrowserHistory();
    }
    return _history;
};

/**
 * Simple helper function to generate some summary info for the completed and overview steps.
 * This avoids some code duplication in these steps
 */ function getShippingMethodInfo(labels, shippingMethod, asides = {}) {
    if (isDelivery(shippingMethod)) {
        return {
            label: labels.delivery,
            aside: asides[ShippingMethod.Delivery]
        };
    }
    if (isDeliveryExpress(shippingMethod)) {
        return {
            label: labels.deliveryExpress,
            aside: asides[ShippingMethod.DeliveryExpress]
        };
    }
    if (isPickupStore(shippingMethod)) {
        return {
            label: labels.pickupStore,
            aside: asides[ShippingMethod.Pickup]
        };
    }
    if (isPickupPoint(shippingMethod)) {
        return {
            label: labels.pickupPoint,
            aside: asides[ShippingMethod.PickupPoint]
        };
    }
    if (isNearestPickup(shippingMethod)) {
        return {
            label: labels.nearestPickup,
            aside: asides[ShippingMethod.NearestPickup]
        };
    }
    return {
        label: '',
        aside: null
    };
}

const isQuotationLocation = (routes)=>{
    var ref;
    if (window === null || window === void 0 ? void 0 : (ref = window.location) === null || ref === void 0 ? void 0 : ref.pathname) {
        var ref1;
        const pathName = window === null || window === void 0 ? void 0 : (ref1 = window.location) === null || ref1 === void 0 ? void 0 : ref1.pathname;
        const reverseRouteLookup = createReverseRouteLookup(routes);
        const legacyCurrentStep = reverseRouteLookup[pathName] || '';
        return [
            StepNames.Payment,
            StepNames.Completed
        ].includes(legacyCurrentStep);
    }
    return false;
};

const useMutationConfig = ({ onError , onCompleted  } = {})=>{
    /**
   *  Callback to handle mutation error
   */ const handleMutationError = React__default.useCallback((error)=>{
        onError === null || onError === void 0 ? void 0 : onError({
            reason: 'MUTATION',
            error
        });
    }, [
        onError
    ]);
    /**
   *  Configuration to call mutation
   *  of GQL
   */ const mutationOptions = React__default.useMemo(()=>{
        return {
            onError: handleMutationError,
            onCompleted: (data)=>{
                onCompleted === null || onCompleted === void 0 ? void 0 : onCompleted(data);
            }
        };
    }, [
        handleMutationError,
        onCompleted
    ]);
    return {
        mutationOptions
    };
};

const useSetCustomerDetails = ({ onError , onCompleted  } = {})=>{
    const dispatch = useDispatch();
    /**
   * Handle success and error response from mutation operation
   * @param responseData
   */ const handleOnCompleted = React__default.useCallback((responseData)=>{
        let result;
        if ('setCustomerDetails' in responseData) {
            var ref;
            result = responseData.setCustomerDetails;
            if ((ref = result.failures) === null || ref === void 0 ? void 0 : ref.length) {
                const errorCodes = getFlattenedCartFailureErrorCodes(result.failures);
                onError === null || onError === void 0 ? void 0 : onError({
                    reason: 'MUTATION'
                });
                /**
           *  Notify user about all failures
           *  To handle granular errors return from mutation operation
           */ errorCodes.forEach((error)=>toast.failed(error)
                );
            }
            if (result.success) {
                onCompleted === null || onCompleted === void 0 ? void 0 : onCompleted('MUTATION');
                dispatch(updateCartState({
                    cartState: result.checkoutState
                }));
            }
        }
    }, [
        dispatch,
        onCompleted,
        onError
    ]);
    const handleOnError = React__default.useCallback(()=>{
        onError === null || onError === void 0 ? void 0 : onError({
            reason: 'MUTATION'
        });
        // General error for apollo error response
        toast.failed(errorsMapping.SOMETHING_WENT_WRONG);
    }, [
        onError
    ]);
    const cartId = cartIdVar();
    const { mutationOptions  } = useMutationConfig({
        onError: handleOnError,
        onCompleted: handleOnCompleted
    });
    const [mutationCallback, mutation] = useMutation(SET_CUSTOMER_DETAILS, mutationOptions);
    /**
   *  Customer details data update operation
   */ const setCustomerDetails = React__default.useCallback(function() {
        var _ref = swcHelpers.asyncToGenerator(function*(customerDetails) {
            if (!cartId) {
                throw new Error('Need to have valid cart to update!');
            }
            yield mutationCallback({
                variables: {
                    customerDetailsInput: swcHelpers.objectSpread({}, customerDetails, {
                        checkoutId: cartId
                    })
                }
            });
        });
        return function(customerDetails) {
            return _ref.apply(this, arguments);
        };
    }(), [
        cartId,
        mutationCallback
    ]);
    return {
        setCustomerDetails,
        isUpdating: mutation.loading,
        updateError: mutation.error
    };
};

var PrefillSources;
(function(PrefillSources) {
    PrefillSources["Cart"] = 'cart';
    PrefillSources["UserData"] = 'userData';
    PrefillSources["AddressBook"] = 'addressBook';
    PrefillSources["AutoComplete"] = 'autoComplete';
})(PrefillSources || (PrefillSources = {}));

const SELECT_SHIPPING_METHOD = 'checkout/shipping/SELECT_SHIPPING_METHOD';
const SELECT_STORE = 'checkout/shipping/SELECT_STORE';
const SELECT_SERVICE_STORE = 'checkout/shipping/SELECT_SERVICE_STORE';
const SELECT_PICKUP_POINT = 'checkout/shipping/SELECT_PICKUP_POINT';
const SET_CONSENTS = 'checkout/shipping/SET_CONSENTS';
const TOGGLE_CONSENT = 'checkout/shipping/TOGGLE_CONSENT';
const TOGGLE_DELIVERY_ADDRESS = 'checkout/shipping/TOGGLE_DELIVERY_ADDRESS,';
const TOGGLE_IS_COMPANY = 'checkout/shipping/TOGGLE_IS_COMPANY';
const TOGGLE_INVOICE = 'checkout/shipping/TOGGLE_INVOICE';
const UPDATE_SHIPPING_DETAILS = 'checkout/shipping/UPDATE_SHIPPING_DETAILS';
const TOGGLE_PREFILL = 'checkout/shipping/TOGGLE_PREFILL';
const TOGGLE_PREFILL_SUCCESS = 'checkout/shipping/TOGGLE_PREFILL_SUCCESS';
const TOGGLE_PREFILL_FAILED = 'checkout/shipping/TOGGLE_PREFILL_FAILED';
const ADDRESS_BOOK_PREFILL_VALIDATION_FAILED = 'checkout/shipping/ADDRESS_BOOK_PREFILL_VALIDATION_FAILED';
const ADDRESS_BOOK_PREFILL_VALIDATION_SUCCESS = 'checkout/shipping/ADDRESS_BOOK_PREFILL_VALIDATION_SUCCESS';
const MARK_FIELDS_TOUCHED = 'checkout/shipping/MARK_FIELDS_TOUCHED';
const SET_MY_ACCOUNT_VALIDATION = 'checkout/shipping/SET_MY_ACCOUNT_VALIDATION';
const SET_SERVICE_STORE_VALIDATION = 'checkout/shipping/SET_SERVICE_STORE_VALIDATION';
const RESET_EXPRESS_CHECKOUT = 'checkout/shipping/RESET_EXPRESS_CHECKOUT';
const resetExpressCheckout = ()=>({
        type: RESET_EXPRESS_CHECKOUT
    })
;
const selectShippingMethod = (payload)=>({
        type: SELECT_SHIPPING_METHOD,
        payload
    })
;
const selectStore = (payload)=>({
        type: SELECT_STORE,
        payload
    })
;
const selectServiceStore = (payload)=>({
        type: SELECT_SERVICE_STORE,
        payload
    })
;
const selectPickupPoint = (payload)=>({
        type: SELECT_PICKUP_POINT,
        payload
    })
;
const toggleDeliveryAddress = (payload)=>({
        type: TOGGLE_DELIVERY_ADDRESS,
        payload
    })
;
const setConsents = (payload)=>({
        type: SET_CONSENTS,
        payload
    })
;
const toggleConsent = (payload)=>({
        type: TOGGLE_CONSENT,
        payload
    })
;
const toggleIsCompany = (payload)=>({
        type: TOGGLE_IS_COMPANY,
        payload
    })
;
const toggleInvoice = (payload)=>({
        type: TOGGLE_INVOICE,
        payload
    })
;
const togglePrefill = (payload)=>{
    return {
        type: TOGGLE_PREFILL,
        payload
    };
};
const togglePrefillSuccess = (payload)=>({
        type: TOGGLE_PREFILL_SUCCESS,
        payload
    })
;
const togglePrefillFailed = (payload)=>({
        type: TOGGLE_PREFILL_FAILED,
        payload
    })
;
const addressBookPrefillValidationFailed = (payload)=>({
        type: ADDRESS_BOOK_PREFILL_VALIDATION_FAILED,
        payload
    })
;
const addressBookPrefillValidationSuccess = ()=>({
        type: ADDRESS_BOOK_PREFILL_VALIDATION_SUCCESS
    })
;
const updateShippingDetails = (payload)=>({
        type: UPDATE_SHIPPING_DETAILS,
        payload
    })
;
const markFieldsTouched = ()=>({
        type: MARK_FIELDS_TOUCHED
    })
;
const setMyAccountValidation = ()=>({
        type: SET_MY_ACCOUNT_VALIDATION
    })
;
const setServiceStoreValidation = ()=>({
        type: SET_SERVICE_STORE_VALIDATION
    })
;

var ShippingObjectTypes;
(function(ShippingObjectTypes) {
    ShippingObjectTypes["BillingAddress"] = 'billingAddress';
    ShippingObjectTypes["DeliveryAddress"] = 'deliveryAddress';
    ShippingObjectTypes["ContactDetails"] = 'contactDetails';
    ShippingObjectTypes["Company"] = 'company';
    ShippingObjectTypes["Invoice"] = 'invoice';
    ShippingObjectTypes["ExpressCheckout"] = 'expressCheckout';
})(ShippingObjectTypes || (ShippingObjectTypes = {}));
var CheckoutState;
(function(CheckoutState) {
    CheckoutState["Uninitialized"] = 'uninitialized';
    CheckoutState["Initialized"] = 'initialized';
    CheckoutState["Completed"] = 'completed';
    CheckoutState["Callback"] = 'callback';
    CheckoutState["Failed"] = 'failed';
})(CheckoutState || (CheckoutState = {}));
/**
 * Checkout state guards
 */ const isState = (stateName)=>(state)=>state.root.state === stateName
;
const isUninitialized = isState(CheckoutState.Uninitialized);
isState(CheckoutState.Initialized);
const isCompleted$1 = isState(CheckoutState.Completed);
isState(CheckoutState.Callback);
const isFailed$1 = isState(CheckoutState.Failed);

const getCheckout = (state)=>state.checkout
;
const isInitialized = createSelector(getCheckout, (checkout)=>checkout && !isUninitialized(checkout)
);
const isCompleted = createSelector(getCheckout, (checkout)=>checkout && isCompleted$1(checkout)
);
const isFailed = createSelector(getCheckout, (checkout)=>checkout && isFailed$1(checkout)
);
/**
 *  Return checkout cart state
 */ const getCartState = createSelector(getCheckout, (checkout)=>checkout && !isUninitialized(checkout) && checkout.root ? checkout.root.cartState : undefined
);
/**
 * Routes, selfUrl
 */ const getRoutes = createSelector(getCheckout, (checkout)=>checkout && !isUninitialized(checkout) && checkout.root ? checkout.root.routes : undefined
);
const getSelfUrl = createSelector(getCheckout, (checkout)=>checkout && !isUninitialized(checkout) && checkout.root ? checkout.root.selfUrl : undefined
);
/**
 * Order - available after completion
 */ const getOrder = createSelector(getCheckout, (checkout)=>checkout && !isUninitialized(checkout) && checkout.order ? checkout.order : undefined
);
const getPaymentResponse = createSelector(getOrder, (order)=>order && order.paymentResponse ? order.paymentResponse : undefined
);
const getOrderResponse = createSelector(getOrder, (order)=>order && order.order ? order.order : undefined
);
const getOrderShippingData = createSelector(getOrderResponse, (order)=>{
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7;
    var ref8;
    return order && {
        billingAddress: order.billingAddress,
        deliveryAddress: order.shippingAddress,
        contactDetails: {
            email: order.customerEmail,
            phone: (ref8 = (ref = order.billingAddress) === null || ref === void 0 ? void 0 : ref.phone) !== null && ref8 !== void 0 ? ref8 : order === null || order === void 0 ? void 0 : (ref1 = order.shippingAddress) === null || ref1 === void 0 ? void 0 : ref1.phone
        },
        company: {
            customerVatId: (ref2 = order.custom) === null || ref2 === void 0 ? void 0 : ref2.fields.customerVatId,
            name: (ref3 = order.billingAddress) === null || ref3 === void 0 ? void 0 : ref3.company,
            secondaryEmail: (ref4 = order.custom) === null || ref4 === void 0 ? void 0 : ref4.fields.secondaryEmail
        },
        invoice: {
            customerCode: (ref5 = order.custom) === null || ref5 === void 0 ? void 0 : ref5.fields.customerCode,
            recipientCode: (ref6 = order.custom) === null || ref6 === void 0 ? void 0 : ref6.fields.recipientCode,
            secureEmail: (ref7 = order.custom) === null || ref7 === void 0 ? void 0 : ref7.fields.secondaryEmail
        }
    };
});
const getPostPaymentToPsp = createSelector(getOrder, (order)=>order && order.postPaymentToPsp ? order.postPaymentToPsp : undefined
);
const getCallbackResultCode = createSelector(getOrder, (order)=>order && order.callbackResultCode ? order.callbackResultCode : undefined
);
/**
 * Error - available when a critical error occured during checkout
 */ const getError = createSelector(getCheckout, (checkout)=>checkout && isFailed$1(checkout) && checkout.error ? checkout.error : undefined
);
/**
 * Additional cart costs
 */ const getAdditionalCartCosts = createSelector(getCheckout, (checkout)=>checkout && !isUninitialized(checkout) ? checkout.additionalCosts : undefined
);
/**
 * My account
 */ const getMyAccount = createSelector(getCheckout, (checkout)=>checkout && !isUninitialized(checkout) && checkout.myAccount ? checkout.myAccount : undefined
);
const shouldCreateAccount = createSelector(getCheckout, (checkout)=>checkout && !isUninitialized(checkout) && checkout.myAccount ? !!checkout.myAccount.shouldCreateAccount : false
);

var selectors = /*#__PURE__*/Object.freeze({
  __proto__: null,
  getCheckout: getCheckout,
  isInitialized: isInitialized,
  isCompleted: isCompleted,
  isFailed: isFailed,
  getCartState: getCartState,
  getRoutes: getRoutes,
  getSelfUrl: getSelfUrl,
  getOrder: getOrder,
  getPaymentResponse: getPaymentResponse,
  getOrderResponse: getOrderResponse,
  getOrderShippingData: getOrderShippingData,
  getPostPaymentToPsp: getPostPaymentToPsp,
  getCallbackResultCode: getCallbackResultCode,
  getError: getError,
  getAdditionalCartCosts: getAdditionalCartCosts,
  getMyAccount: getMyAccount,
  shouldCreateAccount: shouldCreateAccount
});

const { getValuesFromState  } = Util;
/**
 * Get state for shipping step
 */ const getShipping = createSelector(getCheckout, (checkout)=>checkout && !isUninitialized(checkout) && checkout.shipping ? checkout.shipping : undefined
);
/**
 * Get user selections
 */ const getSelectedShippingMethod = createSelector(getShipping, (shipping)=>shipping && shipping.selectedShippingMethod
);
const getSelectedStore = createSelector(getShipping, (shipping)=>shipping && shipping.selectedStore ? shipping.selectedStore : undefined
);
const getServiceStore = createSelector(getShipping, (shipping)=>shipping && (shipping.serviceStore || shipping.serviceStore === null) ? shipping.serviceStore : undefined
);
const getSelectedPickupPoint = createSelector(getShipping, (shipping)=>shipping && shipping.selectedPickupPoint ? shipping.selectedPickupPoint : undefined
);
const getConsents = createSelector(getShipping, (shipping)=>shipping && shipping.consents ? shipping.consents : undefined
);
const isConsentGiven = createSelector(getConsents, (consents)=>consents && !consents.some((consent)=>consent.isChecked === false
    )
);
const getChangedOptIns = createSelector(getMyAccount, (myAccount)=>myAccount && myAccount.changedOptIns
);
const shouldValidateMyAccount = createSelector(getShipping, (shipping)=>shipping && shipping.shouldValidateMyAccount ? shipping.shouldValidateMyAccount : false
);
const shouldValidateServiceStore = createSelector(getShipping, (shipping)=>shipping && shipping.shouldValidateServiceStore ? shipping.shouldValidateServiceStore : false
);
/**
 * Get user's shipping details state
 */ const getShippingDetails = createSelector(getShipping, (shipping)=>shipping && shipping.shippingDetails
);
/**
 * These selectors either return the raw form values of the form data or undefined
 * If they return undefined it could also mean the user didn't toggle this part of the step in the checkout
 */ const dataOrUndefined = (form)=>form && form.isEnabled ? getValuesFromState(form.formData) : undefined
;
createSelector(getShippingDetails, (details)=>details && dataOrUndefined(details.contactDetails)
);
createSelector(getShippingDetails, (details)=>details && dataOrUndefined(details.expressCheckout)
);
const getBillingAddress = createSelector(getShippingDetails, (details)=>details && dataOrUndefined(details.billingAddress)
);
const getDeliveryAddress = createSelector(getShippingDetails, (details)=>details && dataOrUndefined(details.deliveryAddress)
);
const getCompany = createSelector(getShippingDetails, (details)=>details && dataOrUndefined(details.company)
);
const getInvoice = createSelector(getShippingDetails, (details)=>details && dataOrUndefined(details.invoice)
);
/**
 * Get only the values from all currently enabled shipping forms
 */ const getShippingData = createSelector(getShippingDetails, (details)=>details && Object.entries(details).reduce((filtered, [name, form])=>{
        if (form.isEnabled) {
            filtered[name] = getValuesFromState(form.formData);
        }
        return filtered;
    }, {})
);
/**
 * Shipping step validity state
 */ const isShippingStepValid = createSelector(getSelectedShippingMethod, getSelectedStore, getSelectedPickupPoint, getShippingDetails, isConsentGiven, getConsents, (shippingMethod, store, pickupPoint, details, consentGiven, consents)=>{
    return !!details && Object.values(details).filter((form)=>form.isEnabled
    ).every((form)=>form.isValid
    ) && ((shippingMethod === null || shippingMethod === void 0 ? void 0 : shippingMethod.method) === ShippingMethod.Pickup ? store !== undefined : true) && ((shippingMethod === null || shippingMethod === void 0 ? void 0 : shippingMethod.method) === ShippingMethod.PickupPoint ? pickupPoint !== undefined : true) && (consents && consentGiven ? consentGiven : false) && !!(shippingMethod === null || shippingMethod === void 0 ? void 0 : shippingMethod.isValid);
});
const isExpressCheckoutValid = createSelector(getSelectedShippingMethod, getSelectedStore, getSelectedPickupPoint, isConsentGiven, getShippingDetails, getConsents, (shippingMethod, store, pickupPoint, consentGiven, details, consents)=>{
    var ref;
    return !!details && ((ref = details.expressCheckout) === null || ref === void 0 ? void 0 : ref.isValid) && ((shippingMethod === null || shippingMethod === void 0 ? void 0 : shippingMethod.method) === ShippingMethod.Pickup ? store !== undefined : true) && ((shippingMethod === null || shippingMethod === void 0 ? void 0 : shippingMethod.method) === ShippingMethod.PickupPoint ? pickupPoint !== undefined : true) && (consents && consentGiven ? consentGiven : false) && !!(shippingMethod === null || shippingMethod === void 0 ? void 0 : shippingMethod.isValid);
});
const isUserDataPrefilled = createSelector(getShipping, (shipping)=>{
    return (shipping === null || shipping === void 0 ? void 0 : shipping.isUserDataPrefilled) || false;
});
createSelector(getShipping, (shipping)=>{
    return (shipping === null || shipping === void 0 ? void 0 : shipping.isAddressBookDataPrefilled) || false;
});
const getAddressBookPrefillValidationResult = createSelector(getShipping, (shipping)=>{
    return shipping === null || shipping === void 0 ? void 0 : shipping.addressBookPrefillValidationResult;
});

const redirectToOrderConfirmationPage = (orderToken, cartId)=>{
    window.location.assign(`${window.location.origin}/order/confirm?orderData=${orderToken}&cartId=${cartId}`);
};

const mapCartAndTokenToPaymentDraft = (paymentToken, intl, cartId, totalPrice)=>{
    const paymentDraft = {
        countryCode: intl.country,
        paymentMethod: Payments.PaymentMethod.ApplePay,
        paymentServiceProvider: Payments.PaymentServiceProvider.Adyen,
        paymentDetails: {
            token: paymentToken
        },
        amount: {
            currency: intl.currency,
            value: totalPrice,
            fractionDigits: 2
        },
        returnUrl: 'https://not-needed-but-required-by-adyen.com'
    };
    const orderDraft = {
        cartId,
        paymentRequest: paymentDraft
    };
    return orderDraft;
};

const getUpdatedUrlWithCartIdAndHash = (cartId, cartHash)=>{
    const url = new URL(window.location.href);
    const params = url.searchParams;
    cartId && params.set('cartId', cartId);
    cartHash && params.set('cartHash', cartHash);
    return url.toString();
};

const updateUrlWithoutReload = (url)=>{
    if (window.history) {
        window.history.replaceState({
            path: url
        }, window.document.title, url);
    }
};

var CreateExpressCheckoutOrderErrors;
(function(CreateExpressCheckoutOrderErrors) {
    CreateExpressCheckoutOrderErrors["PAYMENT_FAILED"] = "PAYMENT_FAILED";
    CreateExpressCheckoutOrderErrors["ORDER_CREATION_CALL_FAILED"] = "ORDER_CREATION_CALL_FAILED";
})(CreateExpressCheckoutOrderErrors || (CreateExpressCheckoutOrderErrors = {}));
const useCreateExpressCheckoutOrder = ()=>{
    const [orderData1, setOrderData] = React.useState();
    const [error, setError] = React.useState();
    const [loading, setLoading] = React.useState(true);
    const intl = useIntl();
    const apiConfig = useSelector(ApiConfigSelectors.getApiConfig);
    const { cart  } = Context.useCart();
    const { fetchByCartId  } = Hooks.useGetCart();
    const createOrder = React.useCallback(function() {
        var _ref = swcHelpers.asyncToGenerator(function*(paymentToken) {
            const cartId = cartIdVar();
            if (!cart || !apiConfig || !cartId) {
                toast.failed(ExpressCheckoutErrorMapping.CartNotFound);
                throw CreateExpressCheckoutOrderErrors.ORDER_CREATION_CALL_FAILED;
            }
            const orderDraft = mapCartAndTokenToPaymentDraft(paymentToken, intl, cartId, cart.prices.totalPrice);
            return Orders.create(apiConfig.ordersUrl, orderDraft).then((data)=>{
                var ref, ref1, ref2, ref3;
                let orderData;
                // Verify pending. Pending should be treated as success.
                if ((data === null || data === void 0 ? void 0 : (ref = data.paymentResponse) === null || ref === void 0 ? void 0 : (ref1 = ref.result) === null || ref1 === void 0 ? void 0 : ref1.status) === 'success' || (data === null || data === void 0 ? void 0 : (ref2 = data.paymentResponse) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.result) === null || ref3 === void 0 ? void 0 : ref3.status) === 'pending') {
                    if (!data.orderDataToken) {
                        throw CreateExpressCheckoutOrderErrors.ORDER_CREATION_CALL_FAILED;
                    }
                    orderData = {
                        orderToken: data === null || data === void 0 ? void 0 : data.orderDataToken,
                        cartId
                    };
                    setOrderData(orderData);
                    setLoading(false);
                } else {
                    if (data === null || data === void 0 ? void 0 : data.cartId) {
                        fetchByCartId(data === null || data === void 0 ? void 0 : data.cartId, data === null || data === void 0 ? void 0 : data.cartHash);
                        setLoading(false);
                        updateUrlWithoutReload(getUpdatedUrlWithCartIdAndHash(data === null || data === void 0 ? void 0 : data.cartId, data === null || data === void 0 ? void 0 : data.cartHash));
                    } else {
                        throw CreateExpressCheckoutOrderErrors.PAYMENT_FAILED;
                    }
                }
                setLoading(false);
                return orderData;
            }).catch((e)=>{
                const status = e.status || e.statusCode;
                setLoading(false);
                if (status === 400) {
                    toast.failed(ExpressCheckoutErrorMapping.TryAgain);
                    setError(ExpressCheckoutErrorMapping.TryAgain);
                    throw CreateExpressCheckoutOrderErrors.ORDER_CREATION_CALL_FAILED;
                } else if (status === 500) {
                    toast.failed(ExpressCheckoutErrorMapping.SomethingWentWrong);
                    setError(ExpressCheckoutErrorMapping.SomethingWentWrong);
                    throw ExpressCheckoutErrorMapping.SomethingWentWrong;
                } else if (e === CreateExpressCheckoutOrderErrors.PAYMENT_FAILED) {
                    setError(CreateExpressCheckoutOrderErrors.PAYMENT_FAILED);
                    toast.failed(ApplePaySessionErrors.ApplePayPaymentFailed);
                    throw CreateExpressCheckoutOrderErrors.PAYMENT_FAILED;
                } else {
                    setError(CreateExpressCheckoutOrderErrors.ORDER_CREATION_CALL_FAILED);
                    toast.failed(ExpressCheckoutErrorMapping.CreateOrderFailed);
                    throw CreateExpressCheckoutOrderErrors.ORDER_CREATION_CALL_FAILED;
                }
            });
        });
        return function(paymentToken) {
            return _ref.apply(this, arguments);
        };
    }(), [
        apiConfig,
        cart,
        fetchByCartId,
        intl
    ]);
    return [
        createOrder,
        {
            loading,
            error,
            orderData: orderData1
        }, 
    ];
};

const useCreateApplePaySession = ({ onError , onCompleted ,  } = {})=>{
    var ref5, ref1, ref2, ref3;
    const [session1, setSession] = React__default.useState(null);
    const { mutationOptions  } = useMutationConfig({
        onError,
        onCompleted
    });
    const [mutationCallback, mutation] = useMutation(CREATE_APPLE_PAY_SESSION, mutationOptions);
    React__default.useEffect(()=>{
        var ref, ref4;
        const merchantSessionData = mutation === null || mutation === void 0 ? void 0 : (ref = mutation.data) === null || ref === void 0 ? void 0 : (ref4 = ref.createApplePaySession) === null || ref4 === void 0 ? void 0 : ref4.data;
        if (session1 && merchantSessionData) {
            const decodedMerchantSession = atob(merchantSessionData);
            const decodedAndParsedMerchantSession = JSON.parse(decodedMerchantSession);
            try {
                session1.completeMerchantValidation(decodedAndParsedMerchantSession);
            } catch (e) {
                // Swallow InvalidAccessError
                if (!(e instanceof Error && e.name === 'InvalidAccessError')) {
                    console.error(e);
                    toast.failed(ExpressCheckoutErrorMapping.SomethingWentWrong);
                    throw e;
                }
            }
        }
    }, [
        session1,
        mutation === null || mutation === void 0 ? void 0 : (ref5 = mutation.data) === null || ref5 === void 0 ? void 0 : (ref1 = ref5.createApplePaySession) === null || ref1 === void 0 ? void 0 : ref1.data,
        mutation === null || mutation === void 0 ? void 0 : (ref2 = mutation.data) === null || ref2 === void 0 ? void 0 : ref2.createApplePaySession,
        mutation === null || mutation === void 0 ? void 0 : mutation.data, 
    ]);
    // The domainName should be always determined likes this. Therefore exposing it as a variable is unnecessary.
    const domainName = typeof window !== 'undefined' && (window === null || window === void 0 ? void 0 : (ref3 = window.location) === null || ref3 === void 0 ? void 0 : ref3.hostname);
    const createApplePaySession = React__default.useCallback(function() {
        var _ref = swcHelpers.asyncToGenerator(function*(session) {
            setSession(session);
            yield mutationCallback({
                variables: {
                    applePaySessionInput: {
                        domainName
                    }
                }
            });
        });
        return function(session) {
            return _ref.apply(this, arguments);
        };
    }(), [
        domainName,
        mutationCallback
    ]);
    return {
        createApplePaySession,
        isLoading: mutation.loading,
        updateError: mutation.error
    };
};

var AppleBrands;
(function(AppleBrands) {
    AppleBrands["DISCOVER"] = 'discover';
    AppleBrands["VISA"] = 'visa';
    AppleBrands["MASTERCARD"] = 'masterCard';
    AppleBrands["AMEX"] = 'amex';
})(AppleBrands || (AppleBrands = {}));
const BrandsMap = {
    [AdyenBrands.VISA]: AppleBrands.VISA,
    [AdyenBrands.MASTERCARD]: AppleBrands.MASTERCARD,
    [AdyenBrands.AMEX]: AppleBrands.AMEX
};
const mapCartPaymentMethods = (cartPaymentMethods)=>{
    if (cartPaymentMethods.length === 0) return [];
    const creditCardMethod = cartPaymentMethods === null || cartPaymentMethods === void 0 ? void 0 : cartPaymentMethods.find((paymentMethod)=>{
        return (paymentMethod === null || paymentMethod === void 0 ? void 0 : paymentMethod.name) === PaymentMethod.CREDITCARD;
    });
    if ((creditCardMethod === null || creditCardMethod === void 0 ? void 0 : creditCardMethod.name) === PaymentMethod.CREDITCARD) {
        return creditCardMethod.brands.map((adyenBrand)=>BrandsMap[adyenBrand]
        ).filter((brand)=>!!brand
        );
    }
    return [];
};

const mapCartAddressToApplePaymentContact = (cartAddress)=>{
    if (!cartAddress || isEmpty(cartAddress)) return undefined;
    const addressLines = [];
    if (cartAddress.streetName) addressLines.push(cartAddress.streetName);
    if (cartAddress.streetNumber) addressLines.push(cartAddress.streetNumber);
    return swcHelpers.objectSpread({
        addressLines,
        givenName: cartAddress.firstName,
        familyName: cartAddress.lastName,
        locality: cartAddress.city,
        countryCode: cartAddress.countryCode,
        postalCode: cartAddress.postalCode
    }, !!(cartAddress === null || cartAddress === void 0 ? void 0 : cartAddress.region) ? {
        subAdministrativeArea: cartAddress.region
    } : {});
};

var ApplePayShippingTypes;
(function(ApplePayShippingTypes) {
    ApplePayShippingTypes["SHIPPING"] = 'shipping';
    ApplePayShippingTypes["DELIVERY"] = 'delivery';
    ApplePayShippingTypes["STORE_PICKUP_UP"] = 'storePickup';
    ApplePayShippingTypes["SERVICE_PICKUP"] = 'servicePickup';
})(ApplePayShippingTypes || (ApplePayShippingTypes = {}));
const mapper = {
    [ShippingMethod.Delivery]: ApplePayShippingTypes.DELIVERY,
    [ShippingMethod.DeliveryExpress]: ApplePayShippingTypes.DELIVERY,
    [ShippingMethod.Pickup]: ApplePayShippingTypes.STORE_PICKUP_UP,
    [ShippingMethod.PickupPoint]: ApplePayShippingTypes.SERVICE_PICKUP,
    [ShippingMethod.NearestPickup]: ApplePayShippingTypes.SERVICE_PICKUP
};
const mapGVShippingMethodToApplePayShippingType = (shippingMethod)=>mapper[shippingMethod]
;

const mapPickupPointToApplePayShippingContact = (pickupPoint)=>{
    const addressLines = [];
    if (pickupPoint.streetName) addressLines.push(pickupPoint.streetName);
    if (pickupPoint.streetNumber) addressLines.push(pickupPoint.streetNumber);
    return {
        addressLines,
        postalCode: pickupPoint.postalCode || '',
        locality: pickupPoint.town || '',
        countryCode: pickupPoint.country,
        familyName: pickupPoint.name
    };
};

const mapStoreToApplePayShippingContact = (store)=>{
    const addressLines = [];
    if (store.streetName) addressLines.push(store.streetName);
    if (store.streetNumber) {
        if (store.additionalStreetInfo) addressLines.push(`${store.streetNumber} ${store.additionalStreetInfo}`);
        else addressLines.push(store.streetNumber);
    }
    return {
        addressLines,
        postalCode: store.postalCode || '',
        locality: store.town || '',
        countryCode: store.country || '',
        familyName: store.name || '',
        subAdministrativeArea: store.province || ''
    };
};

var ShippingContactEditingMode$1;
(function(ShippingContactEditingMode) {
    ShippingContactEditingMode["STORE_PICKUP"] = 'storePickup';
    ShippingContactEditingMode["DEFAULT"] = 'enabled';
})(ShippingContactEditingMode$1 || (ShippingContactEditingMode$1 = {}));
const useMapShippingContact = (cart)=>{
    const selectedPickupPoint = useSelector(getSelectedPickupPoint);
    const selectedServiceStore = useSelector(getSelectedStore);
    const shippingMethod = cart === null || cart === void 0 ? void 0 : cart.shippingMethod.key;
    const isPickupPointSelected = shippingMethod === ShippingMethod.PickupPoint && !!selectedPickupPoint;
    const isStorePickUpSelected = shippingMethod === ShippingMethod.Pickup && !!selectedServiceStore;
    let shippingContact;
    if (!isPickupPointSelected && !isStorePickUpSelected) shippingContact = mapCartAddressToApplePaymentContact(cart === null || cart === void 0 ? void 0 : cart.shippingAddress);
    else if (isPickupPointSelected) shippingContact = mapPickupPointToApplePayShippingContact(selectedPickupPoint);
    else if (isStorePickUpSelected) shippingContact = mapStoreToApplePayShippingContact(selectedServiceStore);
    return {
        shippingContact,
        shippingContactEditingMode: isPickupPointSelected || isStorePickUpSelected ? ShippingContactEditingMode$1.STORE_PICKUP : ShippingContactEditingMode$1.DEFAULT,
        shippingType: mapGVShippingMethodToApplePayShippingType(shippingMethod)
    };
};

const useRequiredContactFields = ()=>{
    const { features  } = useCheckoutSettings();
    let requiredContactFields = [
        'email',
        'postalAddress',
        'name',
        'phone', 
    ];
    // Phone number is required by default. Just like in the regular checkout.
    if (typeof (features === null || features === void 0 ? void 0 : features.phoneNumberRequired) === 'boolean' && !(features === null || features === void 0 ? void 0 : features.phoneNumberRequired)) {
        requiredContactFields = requiredContactFields.filter((formField)=>formField !== 'phone'
        );
    }
    return requiredContactFields;
};

var ShippingContactEditingMode;
(function(ShippingContactEditingMode) {
    ShippingContactEditingMode["STORE_PICKUP"] = 'storePickup';
    ShippingContactEditingMode["DEFAULT"] = 'enabled';
})(ShippingContactEditingMode || (ShippingContactEditingMode = {}));
const useCreatePaymentRequest = ()=>{
    var ref4, ref1;
    const { country , currency  } = useIntl();
    const [getPaymentMethods, paymentMethodsResult] = Hooks$1.useGetCartPaymentMethods();
    const { cart  } = Context.useCart();
    const requiredContactFields = useRequiredContactFields();
    const { shippingContact , shippingContactEditingMode , shippingType  } = useMapShippingContact(cart);
    const { payments  } = useCheckoutSettings();
    const [error, setError] = React.useState(undefined);
    const shippingMethod = cart === null || cart === void 0 ? void 0 : cart.shippingMethod.key;
    React.useEffect(()=>{
        if (cart === null || cart === void 0 ? void 0 : cart.id) {
            getPaymentMethods(cart.id);
        }
    }, [
        cart === null || cart === void 0 ? void 0 : cart.id,
        getPaymentMethods
    ]);
    const createPaymentRequest = React.useCallback(()=>{
        var ref, ref2, ref3;
        if (!(cart === null || cart === void 0 ? void 0 : cart.id)) {
            console.error('No cart available.');
            setError(ExpressCheckoutErrorMapping.CartIdNotFound);
            toast.failed(ExpressCheckoutErrorMapping.CartIdNotFound);
            return;
        }
        if (!paymentMethodsResult.data) {
            console.error('No payment methods available.');
            setError(ExpressCheckoutErrorMapping.PaymentMethodNotFound);
            toast.failed(ExpressCheckoutErrorMapping.PaymentMethodNotFound);
            return;
        }
        if (!(payments === null || payments === void 0 ? void 0 : (ref = payments.applePay) === null || ref === void 0 ? void 0 : ref.merchantName)) {
            console.error('No merchant name available.');
        }
        const totalPrice = (ref2 = cart.prices) === null || ref2 === void 0 ? void 0 : ref2.totalPrice;
        const total = {
            label: (payments === null || payments === void 0 ? void 0 : (ref3 = payments.applePay) === null || ref3 === void 0 ? void 0 : ref3.merchantName) || 'GrandVision N.V.',
            amount: convertCentsToDecimalString(totalPrice),
            type: 'final'
        };
        const merchantCapabilities = new Array('supports3DS');
        var _billingAddress;
        const paymentRequest = {
            requiredShippingContactFields: !isNearestPickup(shippingMethod) ? requiredContactFields : requiredContactFields.filter((field)=>field !== 'postalAddress'
            ),
            requiredBillingContactFields: requiredContactFields,
            countryCode: country,
            currencyCode: currency,
            merchantCapabilities,
            total,
            supportedNetworks: mapCartPaymentMethods(paymentMethodsResult.data),
            billingContact: mapCartAddressToApplePaymentContact((_billingAddress = cart.billingAddress) !== null && _billingAddress !== void 0 ? _billingAddress : cart.shippingAddress),
            shippingContact,
            shippingType,
            shippingContactEditingMode
        };
        // remove all undefined properties and return
        return pickBy$1(paymentRequest, identity$1);
    }, [
        cart === null || cart === void 0 ? void 0 : cart.id,
        cart === null || cart === void 0 ? void 0 : (ref4 = cart.prices) === null || ref4 === void 0 ? void 0 : ref4.totalPrice,
        cart === null || cart === void 0 ? void 0 : cart.billingAddress,
        cart === null || cart === void 0 ? void 0 : cart.shippingAddress,
        paymentMethodsResult.data,
        payments === null || payments === void 0 ? void 0 : (ref1 = payments.applePay) === null || ref1 === void 0 ? void 0 : ref1.merchantName,
        shippingMethod,
        requiredContactFields,
        country,
        currency,
        shippingContact,
        shippingType,
        shippingContactEditingMode, 
    ]);
    return [
        createPaymentRequest,
        {
            error,
            loading: paymentMethodsResult.loading || false
        }, 
    ];
};

// We need to dynamically verify the address we get back from apple. A failing streetnumber is OK, since it can be contained in the first address line
// On all other validation errors, the payment should be aborted.
const mapApplePayContactAddress = (paymentContact)=>{
    var ref, ref1;
    return swcHelpers.objectSpread({
        firstName: paymentContact.givenName || '',
        lastName: paymentContact.familyName || '',
        streetName: ((ref = paymentContact.addressLines) === null || ref === void 0 ? void 0 : ref[0]) || '',
        streetNumber: ((ref1 = paymentContact.addressLines) === null || ref1 === void 0 ? void 0 : ref1[1]) || '',
        postalCode: (paymentContact === null || paymentContact === void 0 ? void 0 : paymentContact.postalCode) || '',
        city: (paymentContact === null || paymentContact === void 0 ? void 0 : paymentContact.locality) || '',
        countryCode: paymentContact.countryCode || ''
    }, paymentContact.phoneNumber ? {
        phone: paymentContact.phoneNumber
    } : {}, paymentContact.emailAddress ? {
        email: paymentContact.emailAddress
    } : {}, paymentContact.administrativeArea ? {
        region: paymentContact.administrativeArea
    } : {}, paymentContact.subAdministrativeArea ? {
        region: paymentContact.subAdministrativeArea
    } : {});
};

const getDateOfBirth = (expressCheckoutData)=>{
    if (!expressCheckoutData) return null;
    const expressCheckoutForm = expressCheckoutData.formData['express-checkout-dob'];
    if (expressCheckoutForm && expressCheckoutForm.value && expressCheckoutForm.value !== '') return convertToGqlDateFormat(expressCheckoutForm.value);
    return null;
};

const mapAndMergeApplePayShippingContactWithBillingContact = (shippingContact, billingContact)=>{
    var ref, ref1;
    // Apple Pay doesn't provide a company field.
    // The docs suggest to use the familyname as company name: https://developer.apple.com/documentation/passkit/pkpaymentrequest/displaying_a_read-only_pickup_address
    const isOnlyCompanyNameProvided = !!shippingContact.familyName && !shippingContact.givenName;
    const isContactProvidedExplicityInPaymentSheet = !!shippingContact.givenName && !!shippingContact.familyName;
    const configurableFields = {
        firstName: '',
        lastName: ''
    };
    if (isContactProvidedExplicityInPaymentSheet) {
        configurableFields.firstName = shippingContact.givenName;
        configurableFields.lastName = shippingContact.familyName;
    } else {
        configurableFields.firstName = billingContact.givenName;
        configurableFields.lastName = billingContact.familyName;
    }
    if (isOnlyCompanyNameProvided) {
        configurableFields.company = shippingContact.familyName;
    }
    return swcHelpers.objectSpread({
        streetName: ((ref = shippingContact.addressLines) === null || ref === void 0 ? void 0 : ref[0]) || '',
        streetNumber: ((ref1 = shippingContact.addressLines) === null || ref1 === void 0 ? void 0 : ref1[1]) || '',
        postalCode: (shippingContact === null || shippingContact === void 0 ? void 0 : shippingContact.postalCode) || '',
        city: (shippingContact === null || shippingContact === void 0 ? void 0 : shippingContact.locality) || '',
        countryCode: shippingContact.countryCode || ''
    }, configurableFields, shippingContact.phoneNumber ? {
        phone: shippingContact.phoneNumber
    } : {}, (shippingContact === null || shippingContact === void 0 ? void 0 : shippingContact.subAdministrativeArea) ? {
        region: shippingContact === null || shippingContact === void 0 ? void 0 : shippingContact.subAdministrativeArea
    } : {});
};

const useMapShippingAddress = ()=>{
    const { country , getLabel  } = useIntl();
    const { cart  } = Context.useCart();
    const selectedPickupPoint = useSelector(getSelectedPickupPoint);
    return React__default.useCallback((applePayment)=>{
        // A billing address is always required
        if (!applePayment.billingContact) return;
        const isNearestPickup$1 = isNearestPickup(cart === null || cart === void 0 ? void 0 : cart.shippingMethod.key);
        const isPickupPoint$1 = isPickupPoint(cart === null || cart === void 0 ? void 0 : cart.shippingMethod.key);
        const isStorePickUp = isPickupStore(cart === null || cart === void 0 ? void 0 : cart.shippingMethod.key);
        if (isNearestPickup$1) {
            if (applePayment.billingContact.countryCode !== country) {
                toast.failed(ApplePaySessionErrors.ApplePayInvalidAddress);
                throw getLabel(ApplePaySessionErrors.ApplePayInvalidAddress);
            }
            return mapApplePayContactAddress(applePayment.billingContact);
        }
        // Only in the case of isNearestPickup a shipping address is optional
        if (!(applePayment === null || applePayment === void 0 ? void 0 : applePayment.shippingContact)) return;
        if (isPickupPoint$1 || isStorePickUp) {
            const mappedAndMergedShippingAddress = mapAndMergeApplePayShippingContactWithBillingContact(applePayment.shippingContact, applePayment.billingContact);
            // In case of pickup, the deliverer needs a pickup 'code'.
            if (mappedAndMergedShippingAddress && !!(selectedPickupPoint === null || selectedPickupPoint === void 0 ? void 0 : selectedPickupPoint.code)) {
                mappedAndMergedShippingAddress.externalId = selectedPickupPoint === null || selectedPickupPoint === void 0 ? void 0 : selectedPickupPoint.code.toString();
            }
            return mappedAndMergedShippingAddress;
        }
        // Default
        return mapApplePayContactAddress(applePayment === null || applePayment === void 0 ? void 0 : applePayment.shippingContact);
    }, [
        cart === null || cart === void 0 ? void 0 : cart.shippingMethod.key,
        country,
        getLabel,
        selectedPickupPoint === null || selectedPickupPoint === void 0 ? void 0 : selectedPickupPoint.code
    ]);
};

var UseApplePayError;
(function(UseApplePayError) {
    UseApplePayError["UNSUPPORTED"] = "UNSUPPORTED";
    UseApplePayError["CANCELLED"] = "CANCELLED";
    UseApplePayError["FAILED"] = "FAILED";
})(UseApplePayError || (UseApplePayError = {}));
const useApplePay = ()=>{
    const { createApplePaySession , isLoading: createApplePaySessionIsLoading , updateError: createApplePaySessionError ,  } = useCreateApplePaySession();
    const [error, setError] = React.useState();
    const shippingDetails = useSelector(getShippingDetails);
    const { setCustomerDetails  } = useSetCustomerDetails();
    const mapShippingAddress = useMapShippingAddress();
    const { country , getLabel  } = useIntl();
    const dispatch = useDispatch();
    const [createOrder, { error: createOrdererror , loading: createOrderLoading  }, ] = useCreateExpressCheckoutOrder();
    const [createPaymentRequest, { error: paymentRequestError , loading: paymentRequestLoading  }, ] = useCreatePaymentRequest();
    if (typeof ApplePaySession === 'undefined' && error !== UseApplePayError.UNSUPPORTED) {
        console.error('Apple pay can only be used on Safari.');
        setError(UseApplePayError.UNSUPPORTED);
        toast.failed(ApplePaySessionErrors.ApplePaySessionUnsupported);
        return [
            undefined,
            {
                loading: false,
                error
            }
        ];
    }
    const payCartWithApplePay = ()=>{
        const paymentRequest = createPaymentRequest();
        if (!paymentRequest) return;
        const session = new ApplePaySession(12, paymentRequest);
        session.onvalidatemerchant = ()=>{
            createApplePaySession(session);
        };
        session.onshippingcontactselected = (e)=>{
            if (e.shippingContact.countryCode !== country) {
                session.completeShippingContactSelection({
                    newTotal: paymentRequest.total,
                    errors: [
                        new ApplePayError('shippingContactInvalid', 'country', getLabel(ApplePaySessionErrors.ApplePayInvalidAddress)), 
                    ]
                });
                return;
            }
            session.completeShippingContactSelection({
                newTotal: paymentRequest.total
            });
            return;
        };
        session.onpaymentauthorized = function() {
            var _ref = swcHelpers.asyncToGenerator(function*(e) {
                const token = btoa(JSON.stringify(e.payment.token.paymentData));
                try {
                    if (e.payment.shippingContact && e.payment.billingContact) {
                        var ref, ref1, ref2;
                        const dateOfBirth = getDateOfBirth(shippingDetails === null || shippingDetails === void 0 ? void 0 : shippingDetails.expressCheckout);
                        const phone = (ref = e.payment) === null || ref === void 0 ? void 0 : (ref1 = ref.shippingContact) === null || ref1 === void 0 ? void 0 : ref1.phoneNumber;
                        yield setCustomerDetails({
                            customerDetails: swcHelpers.objectSpread({
                                customerType: CheckoutCustomerType.B2C,
                                email: (ref2 = e.payment.shippingContact) === null || ref2 === void 0 ? void 0 : ref2.emailAddress
                            }, dateOfBirth ? {
                                dateOfBirth
                            } : {}, phone ? {
                                phone
                            } : {}),
                            billingAddress: mapApplePayContactAddress(e.payment.billingContact),
                            shippingAddress: mapShippingAddress(e.payment)
                        });
                    }
                    const { orderToken , cartId  } = yield createOrder(token);
                    if (orderToken && cartId) {
                        dispatch(resetExpressCheckout());
                        session.completePayment(ApplePaySession.STATUS_SUCCESS);
                        redirectToOrderConfirmationPage(orderToken, cartId);
                    }
                } catch (e1) {
                    session.completePayment(ApplePaySession.STATUS_FAILURE);
                }
            });
            return function(e) {
                return _ref.apply(this, arguments);
            };
        }();
        session.oncancel = ()=>{
            try {
                session.abort();
            } catch (e) {
                // Swallow InvalidAccessError
                if (!(e instanceof Error && e.name === 'InvalidAccessError')) throw e;
            }
        };
        session.begin();
    };
    return [
        payCartWithApplePay,
        {
            error: error || paymentRequestError || createApplePaySessionError || createOrdererror,
            loading: paymentRequestLoading || createApplePaySessionIsLoading || createOrderLoading
        }, 
    ];
};

const Bancontact = ({ onChange  })=>{
    const { config  } = useAdyen();
    const handleChange = React.useCallback((state)=>{
        let paymentMethodType;
        if (state.cardBrand === 'visa' || state.cardBrand === 'maestro') {
            paymentMethodType = PaymentTypes.PaymentMethod.Creditcard;
        }
        onChange(state.data, state.isValid, paymentMethodType);
    }, [
        onChange
    ]);
    return /*#__PURE__*/ React.createElement(CreditCard, {
        onChange: handleChange,
        additionalOptions: config === null || config === void 0 ? void 0 : config.bancontactCard,
        type: AdyenPaymentType.Bancontact
    });
};

const AdyenPaymentCardSummary = ({ info , intl  })=>{
    if (!info || !('creditcardBin' in info) || typeof info.creditcardBin !== 'string') {
        return null;
    }
    return /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement("div", {
        className: "checkout-payment-info__label"
    }, intl.getLabel('checkout.creditcard.cardNumber')), /*#__PURE__*/ React.createElement("div", {
        className: "checkout-payment-info__value"
    }, info.creditcardBin.substr(0, 4), " **** **** ****"));
};
var CardSummary = withIntl(AdyenPaymentCardSummary);

const BancontactSummary = (props)=>/*#__PURE__*/ React.createElement(CardSummary, swcHelpers.extends({}, props))
;

const Creditcard = ({ onChange  })=>{
    const { config  } = useAdyen();
    const handleChange = React.useCallback((state)=>{
        let paymentMethodType;
        if (state.cardBrand === 'bcmc') {
            paymentMethodType = PaymentTypes.PaymentMethod.BancontactCard;
        }
        // Once Cartes Bancaires is added/requested add transformation here
        onChange(state.data, state.isValid, paymentMethodType);
    }, [
        onChange
    ]);
    return /*#__PURE__*/ React.createElement(CreditCard, {
        onChange: handleChange,
        additionalOptions: config === null || config === void 0 ? void 0 : config.creditcard
    });
};

const CreditcardSummary = (props)=>/*#__PURE__*/ React.createElement(CardSummary, swcHelpers.extends({}, props))
;

const getPaymentSelectOptions = (config)=>{
    if (config && 'items' in config && Array.isArray(config.items)) {
        return config.items.reduce((items, item)=>{
            if (item && typeof item.key === 'string' && typeof item.value === 'string') {
                return swcHelpers.objectSpread({}, items, {
                    [item.value]: {
                        label: item.value,
                        value: item.key
                    }
                });
            }
            return items;
        }, {});
    }
    return {};
};

const Ideal = ({ config , onChange  })=>{
    const selectItems = React.useMemo(()=>getPaymentSelectOptions(config)
    , [
        config
    ]);
    const onHandleChange = React.useCallback((selectedBank)=>{
        if (selectedBank.label && selectedBank.value) {
            onChange({
                issuer: selectedBank.value,
                issuerName: selectedBank.label
            }, true);
        } else {
            onChange({}, false);
        }
    }, [
        onChange
    ]);
    return /*#__PURE__*/ React.createElement(Ideal$1, {
        items: selectItems,
        onChange: onHandleChange
    });
};

const isMbwayDetails = (details)=>{
    if (!details || typeof details !== 'object') {
        return false;
    }
    return 'telephoneNumber' in details && !!details.telephoneNumber;
};

const Mbway = ({ details , onChange  })=>{
    const initialValue = isMbwayDetails(details) ? details.telephoneNumber : '+351';
    return /*#__PURE__*/ React.createElement(Mbway$1, {
        initialValue: initialValue,
        onChange: onChange
    });
};

const MbwaySummary = ({ details  })=>{
    const { getLabel  } = useIntl();
    const labels = React.useMemo(()=>({
            phoneNumber: getLabel('checkout.contact.phoneNumber'),
            hintTitle: getLabel('checkout.completed.paymentDetails.mbway.hint.title'),
            hintMessage: getLabel('checkout.completed.paymentDetails.mbway.hint.message')
        })
    , [
        getLabel
    ]);
    if (!isMbwayDetails(details)) {
        return null;
    }
    return /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement("div", {
        className: "checkout-payment-info__label"
    }, labels.phoneNumber), /*#__PURE__*/ React.createElement("div", {
        className: "checkout-payment-info__value"
    }, details.telephoneNumber), /*#__PURE__*/ React.createElement(Alert, {
        className: "checkout-payment-info__alert",
        title: labels.hintTitle,
        message: labels.hintMessage
    }));
};

const MultibancoSummary = ({ labels , paymentExternalId , paymentExternalReference  })=>/*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement("div", {
        className: "checkout-payment-info__label"
    }, labels.multibancoEntity), /*#__PURE__*/ React.createElement("div", {
        className: "checkout-payment-info__value"
    }, paymentExternalId), /*#__PURE__*/ React.createElement("div", {
        className: "checkout-payment-info__label"
    }, labels.multibancoReference), /*#__PURE__*/ React.createElement("div", {
        className: "checkout-payment-info__value"
    }, paymentExternalReference), /*#__PURE__*/ React.createElement(Alert, {
        className: "checkout-payment-info__alert",
        title: labels.multibancoTitle,
        message: labels.multibancoMessage
    }))
;

const isMultibancoResult = (result)=>{
    if (!result || typeof result !== 'object') {
        return false;
    }
    return 'paymentExternalReference' in result && typeof result.paymentExternalReference === 'string' && 'paymentExternalId' in result && typeof result.paymentExternalId === 'string';
};
const Multibanco = ({ result  })=>{
    const { getLabel  } = useIntl();
    const labels = React.useMemo(()=>({
            multibancoEntity: getLabel('checkout.completed.paymentDetails.multibanco.entity'),
            multibancoReference: getLabel('checkout.completed.paymentDetails.multibanco.reference'),
            multibancoMessage: getLabel('checkout.completed.paymentDetails.multibanco.hint.message'),
            multibancoTitle: getLabel('checkout.completed.paymentDetails.multibanco.hint.title')
        })
    , [
        getLabel
    ]);
    return isMultibancoResult(result) ? /*#__PURE__*/ React.createElement(MultibancoSummary, {
        labels: labels,
        paymentExternalId: result.paymentExternalId,
        paymentExternalReference: result.paymentExternalReference
    }) : null;
};

const Oney = ({ config , onChange  })=>{
    const oneyOptions = React.useMemo(()=>getPaymentSelectOptions(config)
    , [
        config
    ]);
    const onHandleChange = React.useCallback((selectedInstalment)=>{
        if (selectedInstalment.label && selectedInstalment.value) {
            onChange({
                type: selectedInstalment.value
            }, true);
        } else {
            onChange({}, false);
        }
    }, [
        onChange
    ]);
    return /*#__PURE__*/ React.createElement(Oney$1, {
        options: oneyOptions,
        onChange: onHandleChange
    });
};

const Sepa = ({ onChange  })=>{
    const handleChange = React.useCallback((state)=>{
        onChange(state.data, state.isValid);
    }, [
        onChange
    ]);
    return /*#__PURE__*/ React.createElement(Sepa$1, {
        onChange: handleChange
    });
};

const SepaSummary = ({ info  })=>{
    const { getLabel  } = useIntl();
    if (!info || !('iban' in info) || typeof info.iban !== 'string') {
        return null;
    }
    return /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement("div", {
        className: "checkout-payment-info__label"
    }, getLabel('ibanNumber')), /*#__PURE__*/ React.createElement("div", {
        className: "checkout-payment-info__value"
    }, info.iban));
};

const Fake = ({ details , label , onChange  })=>{
    const initialState = details && typeof details.alwaysFail === 'boolean' ? details.alwaysFail : false;
    const [isChecked, setIsChecked] = React.useState(initialState);
    const convertStateToPaymentDetails = (state)=>({
            alwaysFail: state,
            chanceToFailRegistration: false
        })
    ;
    const handleOnChange = ({ checked  })=>{
        setIsChecked(checked);
        onChange(convertStateToPaymentDetails(checked), true);
    };
    React.useEffect(()=>{
        if (!details) {
            onChange(convertStateToPaymentDetails(isChecked), true);
        }
    }, [
        details,
        isChecked,
        onChange
    ]);
    return /*#__PURE__*/ React.createElement(CheckboxWithLabel, {
        className: "fake-payment ",
        id: "fakePayment",
        value: "fail",
        checked: isChecked,
        onChange: handleOnChange,
        label: label || '🧨 Fail to register payment'
    });
};

const P = PaymentServiceProvider;
const M = PaymentMethod;
const providers = {
    [P.FAKE]: {
        [M.FAKE]: {
            type: M.FAKE,
            provider: P.FAKE,
            form: Fake
        }
    },
    [P.ADYEN]: {
        [M.IDEAL]: {
            type: M.IDEAL,
            provider: P.ADYEN,
            form: Ideal
        },
        [M.BANCONTACT_CARD]: {
            type: M.BANCONTACT_CARD,
            provider: P.ADYEN,
            form: Bancontact,
            summary: BancontactSummary
        },
        [M.CREDITCARD]: {
            type: M.CREDITCARD,
            provider: P.ADYEN,
            form: Creditcard,
            summary: CreditcardSummary
        },
        [M.PAYPAL]: {
            type: M.PAYPAL,
            provider: P.ADYEN
        },
        [M.APPLE_PAY]: {
            type: M.APPLE_PAY,
            provider: P.ADYEN
        },
        [M.MOBILE_PAY]: {
            type: M.MOBILE_PAY,
            provider: P.ADYEN
        },
        [M.KLARNA]: {
            type: M.KLARNA,
            provider: P.ADYEN,
            addCartToPayment: true
        },
        [M.KLARNA_ACCOUNT]: {
            type: M.KLARNA_ACCOUNT,
            provider: P.ADYEN,
            addCartToPayment: true
        },
        [M.MULTIBANCO]: {
            type: M.MULTIBANCO,
            provider: P.ADYEN,
            summary: Multibanco
        },
        [M.MBWAY]: {
            type: M.MBWAY,
            provider: P.ADYEN,
            form: Mbway,
            summary: MbwaySummary
        },
        [M.SEPA_DIRECT_DEBIT]: {
            type: M.SEPA_DIRECT_DEBIT,
            provider: P.ADYEN,
            form: Sepa,
            summary: SepaSummary
        },
        [M.ONEY]: {
            type: M.ONEY,
            provider: P.ADYEN,
            form: Oney
        },
        [M.SWISH]: {
            type: M.SWISH,
            provider: P.ADYEN
        },
        [M.BANCONTACT_MOBILE]: {
            type: M.BANCONTACT_MOBILE,
            provider: P.ADYEN
        }
    },
    [P.CASH_ON_DELIVERY]: {
        [M.CASH_ON_DELIVERY]: {
            type: M.CASH_ON_DELIVERY,
            provider: P.CASH_ON_DELIVERY,
            addCartToPayment: true
        }
    }
};
const getPaymentImplementation = (provider, paymentMethod)=>{
    const providerMap = providers[provider];
    if (!providerMap) {
        return undefined;
    }
    return providerMap[paymentMethod];
};
const getPaymentMethodSettings = (provider, paymentMethod, paymentMethodsSettings)=>{
    if (!paymentMethodsSettings) {
        return undefined;
    }
    const paymentMethods = paymentMethodsSettings[provider];
    if (!paymentMethods) {
        return undefined;
    }
    return paymentMethods[paymentMethod];
};

/**
 * The getRestPaymentMethodName function is being used to CONVERT the name of
 * the `payment method`, that is fetched by the getCartPaymentMethods query
 * TO the `payment method` name of the legacy api-client.
 *
 * @param {PaymentMethod} name - The name of the payment method.
 */ const getRestPaymentMethodName = (name)=>{
    switch(name){
        case PaymentMethod.BANCONTACT_CARD:
            return PaymentTypes.PaymentMethod.BancontactCard;
        case PaymentMethod.BANCONTACT_MOBILE:
            return PaymentTypes.PaymentMethod.BancontactMobile;
        case PaymentMethod.CASH_ON_DELIVERY:
            return PaymentTypes.PaymentMethod.CashOnDelivery;
        case PaymentMethod.CREDITCARD:
            return PaymentTypes.PaymentMethod.Creditcard;
        case PaymentMethod.FAKE:
            return PaymentTypes.PaymentMethod.Fake;
        case PaymentMethod.IDEAL:
            return PaymentTypes.PaymentMethod.Ideal;
        case PaymentMethod.KLARNA:
            return PaymentTypes.PaymentMethod.Klarna;
        case PaymentMethod.KLARNA_ACCOUNT:
            return PaymentTypes.PaymentMethod.KlarnaAccount;
        case PaymentMethod.MBWAY:
            return PaymentTypes.PaymentMethod.MBway;
        case PaymentMethod.MOBILE_PAY:
            return PaymentTypes.PaymentMethod.MobilePay;
        case PaymentMethod.MULTIBANCO:
            return PaymentTypes.PaymentMethod.Multibanco;
        case PaymentMethod.ONEY:
            return PaymentTypes.PaymentMethod.Oney;
        case PaymentMethod.PAYPAL:
            return PaymentTypes.PaymentMethod.Paypal;
        case PaymentMethod.SEPA_DIRECT_DEBIT:
            return PaymentTypes.PaymentMethod.SepaDirectDebit;
        case PaymentMethod.SWISH:
            return PaymentTypes.PaymentMethod.Swish;
        case PaymentMethod.APPLE_PAY:
            return PaymentTypes.PaymentMethod.ApplePay;
        default:
            return undefined;
    }
};
/**
 * The getGraphQLPaymentMethodName function is being used to CONVERT the name of
 * the `payment method`, that is received by the `createOrder` POST request
 * TO the `payment method` name of new getCartPaymentMethods query.
 *
 * @param {PaymentMethod} name - The name of the payment method.
 */ const getGraphQLPaymentMethodName = (name)=>{
    switch(name){
        case PaymentTypes.PaymentMethod.BancontactCard:
            return PaymentMethod.BANCONTACT_CARD;
        case PaymentTypes.PaymentMethod.BancontactMobile:
            return PaymentMethod.BANCONTACT_MOBILE;
        case PaymentTypes.PaymentMethod.CashOnDelivery:
            return PaymentMethod.CASH_ON_DELIVERY;
        case PaymentTypes.PaymentMethod.Creditcard:
            return PaymentMethod.CREDITCARD;
        case PaymentTypes.PaymentMethod.Fake:
            return PaymentMethod.FAKE;
        case PaymentTypes.PaymentMethod.Ideal:
            return PaymentMethod.IDEAL;
        case PaymentTypes.PaymentMethod.Klarna:
            return PaymentMethod.KLARNA;
        case PaymentTypes.PaymentMethod.KlarnaAccount:
            return PaymentMethod.KLARNA_ACCOUNT;
        case PaymentTypes.PaymentMethod.MBway:
            return PaymentMethod.MBWAY;
        case PaymentTypes.PaymentMethod.MobilePay:
            return PaymentMethod.MOBILE_PAY;
        case PaymentTypes.PaymentMethod.Multibanco:
            return PaymentMethod.MULTIBANCO;
        case PaymentTypes.PaymentMethod.Oney:
            return PaymentMethod.ONEY;
        case PaymentTypes.PaymentMethod.Paypal:
            return PaymentMethod.PAYPAL;
        case PaymentTypes.PaymentMethod.SepaDirectDebit:
            return PaymentMethod.SEPA_DIRECT_DEBIT;
        case PaymentTypes.PaymentMethod.Swish:
            return PaymentMethod.SWISH;
        case PaymentTypes.PaymentMethod.ApplePay:
            return PaymentMethod.APPLE_PAY;
        default:
            return undefined;
    }
};

/**
 * The getRestPaymentProviderName function is being used to CONVERT the name of
 * the `payment service provider`, that is fetched by the getCartPaymentMethods query
 * TO the `payment service provider` name of the legacy api-client.
 *
 * @param {PaymentServiceProvider} name - The name of the payment service provider.
 */ const getRestPaymentProviderName = (name)=>{
    switch(name){
        case PaymentServiceProvider.ADYEN:
            return PaymentTypes.PaymentServiceProvider.Adyen;
        case PaymentServiceProvider.CASH_ON_DELIVERY:
            return PaymentTypes.PaymentServiceProvider.CashOnDelivery;
        case PaymentServiceProvider.FAKE:
            return PaymentTypes.PaymentServiceProvider.Fake;
        default:
            return undefined;
    }
};
/**
 * The getGraphQLPaymentProviderName function is being used to CONVERT the name of
 * the `payment service provider`, that is received by the `createOrder` POST request
 * TO the `payment service provider` name of new getCartPaymentMethods query.
 *
 * @param {PaymentMethod} name - The name of the payment service provider.
 */ const getGraphQLPaymentProviderName = (name)=>{
    switch(name){
        case PaymentTypes.PaymentServiceProvider.Adyen:
            return PaymentServiceProvider.ADYEN;
        case PaymentTypes.PaymentServiceProvider.CashOnDelivery:
            return PaymentServiceProvider.CASH_ON_DELIVERY;
        case PaymentTypes.PaymentServiceProvider.Fake:
            return PaymentServiceProvider.FAKE;
        default:
            return undefined;
    }
};

const findAdditionalCostForPayment = (additionalCosts, paymentMethod)=>{
    return additionalCosts.find((p)=>p.key === paymentMethod
    );
};
const useAddAdditionalCosts = ()=>{
    var ref, ref1, ref2;
    const [removeCartItems, removeCartLineItemsMutation] = useMutation(Operations.Mutations.REMOVE_CART_LINE_ITEMS);
    const dispatch = useDispatch();
    const { data: data1  } = Hooks.useGetCart();
    const [addToCart, addToCartMutation] = Hooks.useAddToCart();
    const additionalCosts = useSelector(getAdditionalCartCosts);
    const currentAdditionalCostsForPaymentLineItem = data1 === null || data1 === void 0 ? void 0 : (ref = data1.getCart) === null || ref === void 0 ? void 0 : (ref1 = ref.cart) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.additionalCartCostLineItems) === null || ref2 === void 0 ? void 0 : ref2[0];
    React__default.useEffect(()=>{
        if ((additionalCosts === null || additionalCosts === void 0 ? void 0 : additionalCosts.length) === 0) {
            dispatch(getAdditionalCosts());
        }
    }, [
        dispatch,
        additionalCosts === null || additionalCosts === void 0 ? void 0 : additionalCosts.length
    ]);
    const removeFromCart = React__default.useCallback((lineItemId)=>{
        const cartId = data1 === null || data1 === void 0 ? void 0 : data1.getCart.cart.id;
        if (isNil(cartId)) {
            console.error('No cart ID available');
            return;
        }
        removeCartItems({
            variables: {
                cartInput: {
                    cartId,
                    lineItems: [
                        {
                            id: lineItemId
                        }, 
                    ]
                }
            },
            update (cache, { data  }) {
                if (data && data.removeCartLineItems.success) {
                    const newCart = data.removeCartLineItems.cart;
                    cache.writeQuery({
                        query: Operations.Queries.GET_CART,
                        variables: {
                            id: cartId
                        },
                        data: newCart
                    });
                }
            }
        });
    }, [
        data1 === null || data1 === void 0 ? void 0 : data1.getCart.cart.id,
        removeCartItems
    ]);
    const addAdditionalPaymentCostsIfApplicable = React__default.useCallback((selectedPaymentMethod)=>{
        const selectedPaymentImplementation = selectedPaymentMethod && getPaymentImplementation(selectedPaymentMethod === null || selectedPaymentMethod === void 0 ? void 0 : selectedPaymentMethod.provider, selectedPaymentMethod === null || selectedPaymentMethod === void 0 ? void 0 : selectedPaymentMethod.type);
        const selectedAddtionalCartCosts = additionalCosts && selectedPaymentImplementation && findAdditionalCostForPayment(additionalCosts, getRestPaymentMethodName(selectedPaymentImplementation.type));
        const isReselectingAdditionalCosts = selectedAddtionalCartCosts && currentAdditionalCostsForPaymentLineItem;
        let applicable = true;
        if (!selectedPaymentMethod || !selectedPaymentImplementation || isReselectingAdditionalCosts || !additionalCosts || !(additionalCosts === null || additionalCosts === void 0 ? void 0 : additionalCosts.length)) {
            applicable = false;
        }
        if (!applicable) return;
        if (selectedAddtionalCartCosts) {
            addToCart([
                {
                    sku: selectedAddtionalCartCosts.masterVariant.sku || '',
                    quantity: 1,
                    type: 'regular'
                }, 
            ]);
        }
        if (currentAdditionalCostsForPaymentLineItem) {
            removeFromCart(currentAdditionalCostsForPaymentLineItem.id);
        }
    }, [
        additionalCosts,
        currentAdditionalCostsForPaymentLineItem,
        addToCart,
        removeFromCart
    ]);
    return {
        addAdditionalPaymentCostsIfApplicable,
        additionalCosts,
        error: {
            addAdditonalCartCostError: addToCartMutation === null || addToCartMutation === void 0 ? void 0 : addToCartMutation.error,
            removeAdditionalCartCostError: removeCartLineItemsMutation === null || removeCartLineItemsMutation === void 0 ? void 0 : removeCartLineItemsMutation.error
        }
    };
};

const cartChangEventType = 'cart.change';
const dispatchCartChangeEvent = (cartId)=>{
    if (window) {
        window.dispatchEvent(new CustomEvent(cartChangEventType, {
            detail: {
                cartId
            }
        }));
    }
};
const useCartChangeListener = (handler)=>{
    return useEventListener(cartChangEventType, handler);
};

const usePaymentMethodLabelsMap = ()=>{
    const { getLabel  } = useIntl();
    return React__default.useMemo(()=>({
            [PaymentMethod.APPLE_PAY]: getLabel('checkout.payment.method.applepay'),
            [PaymentMethod.BANCONTACT_CARD]: getLabel('checkout.payment.method.bancontactCard'),
            [PaymentMethod.BANCONTACT_MOBILE]: getLabel('checkout.payment.method.bancontactMobile'),
            [PaymentMethod.CASH_ON_DELIVERY]: getLabel('checkout.payment.method.cashOnDelivery'),
            [PaymentMethod.CREDITCARD]: getLabel('checkout.payment.method.creditcard'),
            [PaymentMethod.FAKE]: 'Fake payment',
            [PaymentMethod.IDEAL]: getLabel('checkout.payment.method.ideal'),
            [PaymentMethod.KLARNA_ACCOUNT]: getLabel('checkout.payment.method.klarna_account'),
            [PaymentMethod.KLARNA]: getLabel('checkout.payment.method.klarna'),
            [PaymentMethod.MBWAY]: getLabel('checkout.payment.method.mbway'),
            [PaymentMethod.MOBILE_PAY]: getLabel('checkout.payment.method.mobilepay'),
            [PaymentMethod.MULTIBANCO]: getLabel('checkout.payment.method.multibanco'),
            [PaymentMethod.ONEY]: getLabel('checkout.payment.method.oney'),
            [PaymentMethod.PAYPAL]: getLabel('checkout.payment.method.paypal'),
            [PaymentMethod.SEPA_DIRECT_DEBIT]: getLabel('checkout.payment.method.sepadirectdebit'),
            [PaymentMethod.SWISH]: getLabel('checkout.payment.method.swish')
        })
    , [
        getLabel
    ]);
};

/**
 * Continuously polls the backend for the payment state of the order
 * Polling will stop once an endstate is found. This can be either 'Paid' or 'Failed'
 *
 * There are two additional states called 'BalanceDue' and 'CreditOwed'. These are not used, but do require polling.
 *
 * The default polling interval is 5 seconds. This can be changed by setting the `pollInterval` option.
 */ const usePaymentState = (orderId, pollInterval = 5000)=>{
    const [state, setState] = useState(undefined);
    const [error1, setError] = useState();
    const routes = useApiConfig();
    const handler = useCallback(swcHelpers.asyncToGenerator(function*() {
        if (!orderId) {
            return;
        }
        try {
            const response = yield Orders.getPaymentState(routes.ordersUrl, {
                orderId
            });
            setState(mapPaymentState(response));
        } catch (error) {
            if (error instanceof ResponseError && error.statusCode === 404) {
                setError(errorsMapping.ORDER_NOT_FOUND);
            } else {
                setError(errorsMapping.SOMETHING_WENT_WRONG);
            }
        }
    }), [
        routes.ordersUrl,
        orderId
    ]);
    const options = useMemo(()=>({
            when: state !== 'Paid' && state !== 'Failed' && isNil(error1),
            startImmediate: true
        })
    , [
        state,
        error1
    ]);
    useInterval(handler, pollInterval, options);
    return [
        state,
        error1
    ];
};

const SELECT_PAYMENT_METHOD = 'checkout/payment/SELECT_PAYMENT_METHOD';
const UPDATE_PAYMENT_DETAILS = 'checkout/payment/UPDATE_PAYMENT_DETAILS';
const COMPLETE_ADYEN_REDIRECT_PAYMENT = 'checkout/payment/COMPLETE_ADYEN_REDIRECT_PAYMENT';
const SET_PAYMENT_FLOW = 'checkout/SET_PAYMENT_FLOW';
const CLEAR_PAYMENT_FLOW = 'checkout/CLEAR_PAYMENT_FLOW';
const selectPaymentMethod = (payload)=>({
        type: SELECT_PAYMENT_METHOD,
        payload
    })
;
const updatePaymentDetails = (payload)=>({
        type: UPDATE_PAYMENT_DETAILS,
        payload
    })
;
const completeAdyenRedirectPayment = (payload)=>({
        type: COMPLETE_ADYEN_REDIRECT_PAYMENT,
        payload
    })
;
const setPaymentFlow = (payload)=>({
        type: SET_PAYMENT_FLOW,
        payload
    })
;
const clearPaymentFlow = ()=>({
        type: CLEAR_PAYMENT_FLOW
    })
;

const getPayment = createSelector(getCheckout, (checkout)=>checkout && !isUninitialized(checkout) && checkout.payment ? checkout.payment : undefined
);
const getSelectedPaymentMethod = createSelector(getPayment, (payment)=>payment && payment.selectedPaymentMethod ? payment.selectedPaymentMethod : undefined
);
const getPaymentDetails = createSelector(getPayment, (payment)=>payment && payment.paymentDetails ? payment.paymentDetails : undefined
);
const getSelectedPaymentDetails = createSelector(getPaymentDetails, getSelectedPaymentMethod, (paymentDetails, paymentMethod)=>{
    if (!paymentMethod || !paymentDetails) {
        return undefined;
    }
    const { provider  } = paymentMethod;
    if (!provider) {
        return undefined;
    }
    const paymentMethods = paymentDetails[provider];
    if (!paymentMethods) {
        return undefined;
    }
    return paymentMethods;
});
const getPaymentFlow = createSelector(getCheckout, (checkout)=>checkout && !isUninitialized(checkout) && checkout.payment.paymentFlow ? checkout.payment.paymentFlow : undefined
);

const useQrPaymentState = ({ paymentState , returnUrl , orderId: orderId1 , error ,  })=>{
    const [isQrCodeModalOpen, setIsQrCodeModalOpen] = useState(false);
    const [isQrCodeExpired, setIsQrCodeExpired] = useState(false);
    const [isQrRefreshLoading, setIsQrRefreshLoading] = useState(false);
    const [qrCode, setQrCode] = useState('');
    const [qrCodeExpireIn, setQrCodeExpireIn] = useState(0);
    const [externalUrl, setExternalUrl] = useState('');
    const paymentResponse = useSelector(getPaymentResponse);
    const paymentFlow = useSelector(getPaymentFlow);
    const dispatch = useDispatch();
    const { cart  } = Context.useCart();
    /*
   *  When user cancels payment or payment fails
   *  actions: 1. Reset payment flow
   *           2. Replicate & restore cart
   *           3. Close QR modal
   */ const cancelPayment = useCallback((orderId)=>{
        dispatch(clearPaymentFlow());
        dispatch(restoreCart({
            orderId
        }));
        setIsQrCodeModalOpen(false);
    }, [
        dispatch
    ]);
    /*
   *  Listen for QR code payment status
   *  if paymentState is 'Paid' then call paymentSuccessOrder saga
   *  if PaymentState is 'Failed' or any error occured replicate and restore cart
   */ useEffect(()=>{
        if (paymentState === 'Paid') {
            dispatch(paymentSuccessForOrder());
        }
        if (paymentState === 'Failed' || error) {
            cancelPayment(orderId1);
        }
    }, [
        paymentState,
        error,
        cancelPayment,
        dispatch,
        orderId1,
        paymentResponse
    ]);
    /*
   *  Reset QR code timeout
   *  Refresh QR code image
   */ useEffect(()=>{
        if (qrCodeExpireIn) {
            const timeoutId = setTimeout(()=>{
                setIsQrCodeExpired(true);
                setQrCodeExpireIn(0);
            }, qrCodeExpireIn);
            return ()=>clearTimeout(timeoutId)
            ;
        }
    }, [
        qrCodeExpireIn
    ]);
    /*
   *  Set/Update properties when QR code is updated
   */ useEffect(()=>{
        var ref, ref1, ref2;
        setQrCodeExpireIn(Number(paymentResponse === null || paymentResponse === void 0 ? void 0 : (ref = paymentResponse.resultDetails) === null || ref === void 0 ? void 0 : ref.qrCodeExpiresIn) * 1000);
        setQrCode(String(paymentResponse === null || paymentResponse === void 0 ? void 0 : (ref1 = paymentResponse.resultDetails) === null || ref1 === void 0 ? void 0 : ref1.qrCodeUrl));
        setExternalUrl(String(paymentResponse === null || paymentResponse === void 0 ? void 0 : (ref2 = paymentResponse.resultDetails) === null || ref2 === void 0 ? void 0 : ref2.url));
        setIsQrCodeExpired(false);
        setIsQrRefreshLoading(false);
    }, [
        paymentResponse
    ]);
    // Open QR code modal only when PaymentFlow is QR_Code
    useEffect(()=>{
        if (paymentFlow === PaymentFlow.QR_CODE) {
            setIsQrCodeModalOpen(true);
        }
    }, [
        paymentFlow
    ]);
    /*
   *  On refreshQr replicate cart
   *  Get latest QR code
   */ const handleRefreshQrCode = useCallback(()=>{
        cart && dispatch(refreshPaymentForOrder({
            returnUrl,
            cartCentAmount: cart.prices.totalPrice
        }));
        setIsQrRefreshLoading(true);
    }, [
        cart,
        dispatch,
        returnUrl
    ]);
    return useMemo(()=>({
            externalUrl,
            isOpen: isQrCodeModalOpen,
            isQrCodeExpired,
            isQrRefreshLoading,
            onCancel: ()=>cancelPayment(orderId1)
            ,
            qrCodeUrl: qrCode,
            refreshQrCode: ()=>handleRefreshQrCode()
        })
    , [
        cancelPayment,
        externalUrl,
        handleRefreshQrCode,
        isQrCodeExpired,
        isQrCodeModalOpen,
        isQrRefreshLoading,
        orderId1,
        qrCode, 
    ]);
};

const useSetShippingMethod = ({ onError , onCompleted  } = {})=>{
    const [{ cartId  }] = Hooks.useCartStorage();
    const [selectedShippingMethod, setSelectedShippingMethod] = React__default.useState(undefined);
    const dispatch = useDispatch();
    /**
   * Handle success and error response from mutation operation
   * @param responseData
   */ const handleOnCompleted = React__default.useCallback((responseData)=>{
        let result;
        if ('setShippingMethod' in responseData) {
            var ref;
            result = responseData.setShippingMethod;
            if ((ref = result.failures) === null || ref === void 0 ? void 0 : ref.length) {
                const errorCodes = getFlattenedCartFailureErrorCodes(result.failures);
                onError === null || onError === void 0 ? void 0 : onError({
                    reason: 'MUTATION'
                });
                /**
           *  Notify user about all failures
           *  To handle granular errors return from mutation operation
           */ errorCodes.forEach((error)=>toast.failed(error)
                );
            }
            if (result.success) {
                dispatch(selectShippingMethod({
                    shippingMethod: {
                        method: selectedShippingMethod,
                        isValid: true,
                        isTouched: true
                    }
                }));
                onCompleted === null || onCompleted === void 0 ? void 0 : onCompleted('MUTATION');
            }
        }
    }, [
        dispatch,
        onCompleted,
        onError,
        selectedShippingMethod
    ]);
    const handleOnError = React__default.useCallback(()=>{
        onError === null || onError === void 0 ? void 0 : onError({
            reason: 'MUTATION'
        });
        // General error for apollo error response
        toast.failed(errorsMapping.SOMETHING_WENT_WRONG);
    }, [
        onError
    ]);
    const { mutationOptions  } = useMutationConfig({
        onError: handleOnError,
        onCompleted: handleOnCompleted
    });
    const [mutationCallback, mutation] = useMutation(SET_SHIPPING_METHOD, mutationOptions);
    /**
   *  Shipping method data update operation
   *  @param: shippingMethodId(UUID)
   */ const setShippingMethod = React__default.useCallback(function() {
        var _ref = swcHelpers.asyncToGenerator(function*(shippingMethodId) {
            yield mutationCallback({
                variables: {
                    shippingMethodInput: {
                        shippingMethodId,
                        checkoutId: cartId
                    }
                }
            });
        });
        return function(shippingMethodId) {
            return _ref.apply(this, arguments);
        };
    }(), [
        mutationCallback,
        cartId
    ]);
    return {
        setShippingMethod,
        isUpdating: mutation.loading,
        updateError: mutation.error,
        setSelectedShippingMethod
    };
};

const useSetStore = ({ onError , onCompleted  } = {})=>{
    const cartId = cartIdVar();
    /**
   * Handle success and error response from mutation operation
   * @param responseData
   */ const handleOnCompleted = React__default.useCallback((responseData)=>{
        let result;
        if ('setStore' in responseData) {
            var ref;
            result = responseData.setStore;
            if ((ref = result.failures) === null || ref === void 0 ? void 0 : ref.length) {
                const errorCodes = getFlattenedCartFailureErrorCodes(result.failures);
                onError === null || onError === void 0 ? void 0 : onError({
                    reason: 'MUTATION'
                });
                /**
           *  Notify user about all failures
           *  To handle granular errors return from mutation operation
           */ errorCodes.forEach((error)=>toast.failed(error)
                );
            }
            if (result.success) {
                onCompleted === null || onCompleted === void 0 ? void 0 : onCompleted('MUTATION');
            }
        }
    }, [
        onCompleted,
        onError
    ]);
    const handleOnError = React__default.useCallback(()=>{
        onError === null || onError === void 0 ? void 0 : onError({
            reason: 'MUTATION'
        });
        // General error for apollo error response
        toast.failed(errorsMapping.SOMETHING_WENT_WRONG);
    }, [
        onError
    ]);
    const { mutationOptions  } = useMutationConfig({
        onError: handleOnError,
        onCompleted: handleOnCompleted
    });
    const [mutationCallback, mutation] = useMutation(SET_STORE, mutationOptions);
    /**
   *  Store data update operation
   *  @param storeCode: number
   */ const setStore = React__default.useCallback(function() {
        var _ref = swcHelpers.asyncToGenerator(function*(storeCode) {
            yield mutationCallback({
                variables: {
                    storeInput: {
                        code: storeCode,
                        checkoutId: cartId
                    }
                }
            });
        });
        return function(storeCode) {
            return _ref.apply(this, arguments);
        };
    }(), [
        mutationCallback,
        cartId
    ]);
    return {
        setStore,
        isUpdating: mutation.loading,
        updateError: mutation.error
    };
};

var index = /*#__PURE__*/Object.freeze({
  __proto__: null,
  useApplePay: useApplePay,
  usePaymentState: usePaymentState,
  useQrPaymentState: useQrPaymentState,
  useMutationConfig: useMutationConfig,
  useSetCustomerDetails: useSetCustomerDetails,
  useSetShippingMethod: useSetShippingMethod,
  useSetStore: useSetStore,
  useCartChangeListener: useCartChangeListener,
  useAddAdditionalCosts: useAddAdditionalCosts,
  usePaymentMethodLabelsMap: usePaymentMethodLabelsMap
});

const PARSE_ADYEN_CALLBACK = 'checkout/PARSE_ADYEN_CALLBACK';
const PARSE_CALLBACK_SUCCESS = 'checkout/PARSE_CALLBACK_SUCCESS';
const PARSE_CALLBACK_FAILED = 'checkout/PARSE_CALLBACK_FAILED';
const parseAdyenCallback = (payload)=>({
        type: PARSE_ADYEN_CALLBACK,
        payload
    })
;
const parseCallbackSucess = (payload)=>({
        type: PARSE_CALLBACK_SUCCESS,
        payload
    })
;
const parseCallbackFailed = (error)=>({
        type: PARSE_CALLBACK_FAILED,
        error
    })
;

const initialState$2 = {
    paymentDetails: {},
    paymentFlow: PaymentFlow.UNDEFINED
};
function paymentReducer(state = initialState$2, action) {
    switch(action.type){
        case SELECT_PAYMENT_METHOD:
            return swcHelpers.objectSpread({}, state, {
                paymentDetails: {},
                selectedPaymentMethod: swcHelpers.objectSpread({}, action.payload)
            });
        case UPDATE_PAYMENT_DETAILS:
            const { type , provider , data , info , result , isValid  } = action.payload;
            return swcHelpers.objectSpread({}, state, {
                paymentDetails: swcHelpers.objectSpread({}, state.paymentDetails, {
                    [provider]: {
                        type,
                        data,
                        info,
                        result,
                        isValid
                    }
                })
            });
        case SET_PAYMENT_FLOW:
            return swcHelpers.objectSpread({}, state, {
                paymentFlow: action.payload.paymentFlow
            });
        case CLEAR_PAYMENT_FLOW:
            return swcHelpers.objectSpread({}, state, {
                paymentFlow: PaymentFlow.UNDEFINED
            });
        default:
            return state;
    }
}

const SHIPPING_METHODS_LOAD = 'checkout/shippingMethods/SHIPPING_METHODS_LOAD';
const SHIPPING_METHODS_SUCCESS = 'checkout/shippingMethods/SHIPPING_METHODS_SUCCESS';
const SHIPPING_METHODS_FAILED = 'checkout/shippingMethods/SHIPPING_METHODS_FAILED';
const shippingMethodsSuccess = (payload)=>({
        type: SHIPPING_METHODS_SUCCESS,
        payload
    })
;
const shippingMethodsFailed = (error)=>({
        type: SHIPPING_METHODS_FAILED,
        error
    })
;

const initialState$1 = uninitState();
function shippingMethodsReducer(state = initialState$1, action) {
    switch(action.type){
        case SHIPPING_METHODS_LOAD:
            return loadingState();
        case SHIPPING_METHODS_SUCCESS:
            return successState(action.payload.result);
        case SHIPPING_METHODS_FAILED:
            return failedState(action.error);
        default:
            return state;
    }
}

const { markFormFieldsTouched  } = Util;
// When a form is enabled it means it's active and visible for the user
const initialFormState = {
    formData: {},
    isEnabled: true,
    isValid: false
};
const initialState = {
    selectedShippingMethod: {
        method: undefined,
        isValid: false,
        isTouched: false
    },
    shippingDetails: {
        billingAddress: initialFormState,
        contactDetails: initialFormState,
        expressCheckout: swcHelpers.objectSpread({}, initialFormState, {
            isEnabled: false
        }),
        invoice: swcHelpers.objectSpread({}, initialFormState, {
            isEnabled: false
        }),
        deliveryAddress: swcHelpers.objectSpread({}, initialFormState, {
            isEnabled: false
        }),
        company: swcHelpers.objectSpread({}, initialFormState, {
            isEnabled: false
        })
    },
    isUserDataPrefilled: false,
    isAddressBookDataPrefilled: false,
    consents: []
};
/**
 * Handles all user interaction in the shipping step
 */ function shippingReducer(state = initialState, action) {
    switch(action.type){
        case SELECT_SHIPPING_METHOD:
            const { shippingMethod  } = action.payload;
            return swcHelpers.objectSpread({}, state, {
                selectedShippingMethod: {
                    method: shippingMethod.method,
                    isValid: shippingMethod.isValid,
                    isTouched: shippingMethod.isTouched
                }
            });
        case SELECT_STORE:
            const { store  } = action.payload;
            return swcHelpers.objectSpread({}, state, {
                selectedStore: store
            });
        case SELECT_SERVICE_STORE:
            const { serviceStore  } = action.payload;
            return swcHelpers.objectSpread({}, state, {
                serviceStore
            });
        case SELECT_PICKUP_POINT:
            const { pickupPoint  } = action.payload;
            return swcHelpers.objectSpread({}, state, {
                selectedPickupPoint: pickupPoint
            });
        case SET_CONSENTS:
            {
                const { consents  } = action.payload;
                return swcHelpers.objectSpread({}, state, {
                    consents
                });
            }
        case TOGGLE_CONSENT:
            {
                const { consents  } = action.payload;
                const newConsents = state.consents.map((consent)=>swcHelpers.objectSpread({}, consent, {
                        isChecked: consents.includes(consent.value)
                    })
                );
                return swcHelpers.objectSpread({}, state, {
                    consents: newConsents
                });
            }
        case TOGGLE_DELIVERY_ADDRESS:
            {
                const { enabled  } = action.payload;
                return swcHelpers.objectSpread({}, state, {
                    shippingDetails: swcHelpers.objectSpread({}, state.shippingDetails, {
                        deliveryAddress: swcHelpers.objectSpread({}, state.shippingDetails.deliveryAddress, {
                            isEnabled: enabled
                        })
                    })
                });
            }
        case TOGGLE_IS_COMPANY:
            {
                const { enabled  } = action.payload;
                return swcHelpers.objectSpread({}, state, {
                    shippingDetails: swcHelpers.objectSpread({}, state.shippingDetails, {
                        company: swcHelpers.objectSpread({}, state.shippingDetails.company, {
                            isEnabled: enabled
                        })
                    })
                });
            }
        case TOGGLE_INVOICE:
            {
                const { enabled  } = action.payload;
                return swcHelpers.objectSpread({}, state, {
                    shippingDetails: swcHelpers.objectSpread({}, state.shippingDetails, {
                        invoice: swcHelpers.objectSpread({}, state.shippingDetails.invoice, {
                            isEnabled: enabled
                        })
                    })
                });
            }
        case UPDATE_SHIPPING_DETAILS:
            const { formName , formState , formValid  } = action.payload.form;
            const { addressBookId  } = action.payload;
            return swcHelpers.objectSpread({}, state, {
                shippingDetails: swcHelpers.objectSpread({}, state.shippingDetails, {
                    [formName]: swcHelpers.objectSpread({}, state.shippingDetails[formName], {
                        formData: swcHelpers.objectSpread({}, formState),
                        isValid: formValid
                    }, addressBookId && {
                        addressBookId
                    })
                })
            });
        case TOGGLE_PREFILL_SUCCESS:
            const key = action.payload.source === PrefillSources.AddressBook ? 'isAddressBookDataPrefilled' : 'isUserDataPrefilled';
            return swcHelpers.objectSpread({}, state, {
                [key]: true
            });
        case ADDRESS_BOOK_PREFILL_VALIDATION_FAILED:
            return swcHelpers.objectSpread({}, state, {
                addressBookPrefillValidationResult: 'failed'
            });
        case ADDRESS_BOOK_PREFILL_VALIDATION_SUCCESS:
            return swcHelpers.objectSpread({}, state, {
                addressBookPrefillValidationResult: 'success'
            });
        case MARK_FIELDS_TOUCHED:
            {
                return swcHelpers.objectSpread({}, state, {
                    selectedShippingMethod: swcHelpers.objectSpread({}, state.selectedShippingMethod, {
                        isTouched: true
                    }),
                    shippingDetails: swcHelpers.objectSpread({}, state.shippingDetails, {
                        deliveryAddress: swcHelpers.objectSpread({}, state.shippingDetails.deliveryAddress, {
                            formData: markFormFieldsTouched(state.shippingDetails.deliveryAddress.formData)
                        }),
                        billingAddress: swcHelpers.objectSpread({}, state.shippingDetails.billingAddress, {
                            formData: markFormFieldsTouched(state.shippingDetails.billingAddress.formData)
                        }),
                        contactDetails: swcHelpers.objectSpread({}, state.shippingDetails.contactDetails, {
                            formData: markFormFieldsTouched(state.shippingDetails.contactDetails.formData)
                        }),
                        invoice: swcHelpers.objectSpread({}, state.shippingDetails.invoice, {
                            formData: markFormFieldsTouched(state.shippingDetails.invoice.formData)
                        }),
                        company: swcHelpers.objectSpread({}, state.shippingDetails.company, {
                            formData: markFormFieldsTouched(state.shippingDetails.company.formData)
                        }),
                        expressCheckout: swcHelpers.objectSpread({}, state.shippingDetails.expressCheckout, {
                            formData: markFormFieldsTouched(state.shippingDetails.expressCheckout.formData)
                        })
                    }),
                    consents: state.consents.map((consent)=>swcHelpers.objectSpread({}, consent, {
                            shouldValidate: !!consent.required
                        })
                    )
                });
            }
        case SET_MY_ACCOUNT_VALIDATION:
            {
                return swcHelpers.objectSpread({}, state, {
                    shouldValidateMyAccount: true
                });
            }
        case SET_SERVICE_STORE_VALIDATION:
            {
                return swcHelpers.objectSpread({}, state, {
                    shouldValidateServiceStore: true
                });
            }
        case RESET_EXPRESS_CHECKOUT:
            {
                return swcHelpers.objectSpread({}, state, {
                    selectedShippingMethod: {
                        method: undefined,
                        isValid: false,
                        isTouched: false
                    },
                    shippingDetails: swcHelpers.objectSpread({}, state.shippingDetails, {
                        expressCheckout: swcHelpers.objectSpread({}, initialFormState, {
                            isEnabled: false
                        })
                    }),
                    consents: []
                });
            }
        default:
            return state;
    }
}

const initialRootState = {
    state: CheckoutState.Uninitialized
};
/**
 * Main checkout reducer - handles actions that are not related to a specific step of the checkout
 */ function checkoutReducer(state = initialRootState, action) {
    switch(action.type){
        case INIT:
            return swcHelpers.objectSpread({
                state: CheckoutState.Initialized,
                cartState: CheckoutState$1.InProgress
            }, action.payload);
        case ORDER_CREATE_SUCCESS:
        case PARSE_CALLBACK_SUCCESS:
            return swcHelpers.objectSpread({}, state, {
                state: CheckoutState.Completed
            });
        case ORDER_GET_BY_TOKEN_SUCCESS:
            return swcHelpers.objectSpread({}, state, {
                state: CheckoutState.Callback
            });
        case ORDER_CREATE_FAILED:
        case PARSE_CALLBACK_FAILED:
            return swcHelpers.objectSpread({}, state, {
                state: CheckoutState.Failed
            });
        case UPDATE_CART_STATE:
            return swcHelpers.objectSpread({}, state, action.payload);
        case CLEAR_ERROR:
            return swcHelpers.objectSpread({}, state, {
                state: CheckoutState.Initialized
            });
        default:
            return state;
    }
}
function orderReducer(state = null, action) {
    switch(action.type){
        case INIT_ORDER:
            return null;
        case ORDER_SET:
        case ORDER_CREATE_SUCCESS:
            return swcHelpers.objectSpread({}, state, action.payload.order);
        case ORDER_CLEAR:
            return null;
        case ORDER_GET_BY_TOKEN_SUCCESS:
            return swcHelpers.objectSpread({}, state, {
                order: action.payload.order
            });
        case POST_PAYMENT_TO_PSP:
            return state && swcHelpers.objectSpread({}, state, {
                postPaymentToPsp: action.payload
            });
        case PARSE_CALLBACK_SUCCESS:
            return state && swcHelpers.objectSpread({}, state, {
                callbackResultCode: action.payload.resultCode
            });
        case PARSE_CALLBACK_FAILED:
            return state && swcHelpers.objectSpread({}, state, {
                postPaymentToPsp: undefined
            });
        default:
            return state;
    }
}
function errorReducer(state = null, action) {
    switch(action.type){
        case CART_UPDATE_FAILED:
        case ORDER_CREATE_FAILED:
        case ORDER_GET_BY_TOKEN_FAILED:
        case PARSE_CALLBACK_FAILED:
            return swcHelpers.objectSpread({}, state, action.error);
        case CLEAR_ERROR:
            return null;
        default:
            return state;
    }
}
function myAccountReducer(state = null, action) {
    switch(action.type){
        case TOGGLE_ACCOUNT_CREATION:
            const { shouldCreateAccount  } = action.payload;
            return swcHelpers.objectSpread({}, state, {
                shouldCreateAccount
            });
        case ACCOUNT_CREATE_SUCCESS:
            const { id  } = action.payload;
            return swcHelpers.objectSpread({}, state, {
                newUserId: id
            });
        case SET_CHANGED_OPT_INS:
            return swcHelpers.objectSpread({}, state, {
                changedOptIns: action.payload
            });
        default:
            return state;
    }
}
function additionalCostsReducer(state = [], action) {
    switch(action.type){
        case GET_ADDITIONAL_COSTS_SUCCESS:
            return [
                ...action.payload.result
            ];
        default:
            return state;
    }
}
/**
 * Root checkout reducer - returns complete checkout state
 */ var reducer = combineReducers({
    root: checkoutReducer,
    shippingMethods: shippingMethodsReducer,
    shipping: shippingReducer,
    payment: paymentReducer,
    order: orderReducer,
    error: errorReducer,
    myAccount: myAccountReducer,
    additionalCosts: additionalCostsReducer
});

var CallbackResultCode;
(function(CallbackResultCode) {
    CallbackResultCode["Authorised"] = 'authorised';
    CallbackResultCode["Cancelled"] = 'cancelled';
    CallbackResultCode["Refused"] = 'refused';
    CallbackResultCode["Pending"] = 'pending';
    CallbackResultCode["Received"] = 'received';
})(CallbackResultCode || (CallbackResultCode = {}));
const isUnknownObject = (x)=>x !== null && typeof x === 'object'
;
const isRedirectAdyenQuery = (query)=>isUnknownObject(query) && 'redirectResult' in query
;

function getPaymentIdFromOrder(order) {
    var ref;
    const payment = order === null || order === void 0 ? void 0 : (ref = order.paymentInfo) === null || ref === void 0 ? void 0 : ref.payments[0].obj;
    return (payment === null || payment === void 0 ? void 0 : payment.id) || '';
}
function getAdyenPaymentDataFromOrder(order) {
    var ref;
    const payment = order === null || order === void 0 ? void 0 : (ref = order.paymentInfo) === null || ref === void 0 ? void 0 : ref.payments[0].obj;
    return payment === null || payment === void 0 ? void 0 : payment.custom.fields.adyenPaymentData;
}
function* onParseAdyenCallback(action) {
    const { query  } = action.payload;
    const { orderData  } = query;
    if (orderData) {
        yield put(getOrderByToken({
            orderData
        }));
        yield race({
            creationResult: take(ORDER_GET_BY_TOKEN_SUCCESS),
            creationError: take(ORDER_GET_BY_TOKEN_FAILED),
            timeout: delay(30000)
        });
    }
    const { order  } = yield select(getOrder);
    if (!order || !order.paymentInfo || !order.paymentInfo.payments[0].obj) {
        throw new Error('No order or payment found to process adyen callback');
    }
    // All payment methods that enter this callback are Adyen redirect payments
    if (isRedirectAdyenQuery(query)) {
        yield put(completeAdyenRedirectPayment({
            query
        }));
    } else {
        yield put(parseCallbackFailed({
            code: 'unknown',
            message: 'Unable to parse adyen callback query: no redirectResult was found!'
        }));
    }
}
function* onCompleteAdyenRedirectPayment(action) {
    const apiConfig = yield select(ApiConfigSelectors.getApiConfig);
    const { order  } = yield select(getOrder);
    if (!apiConfig || !apiConfig.paymentsUrl) {
        throw new Error('No apiUrl and/or payment data provided for payments API!');
    }
    if (!order || !order.paymentInfo || !order.paymentInfo.payments[0].obj) {
        throw new Error('No order or payment found to complete adyen redirect payment');
    }
    const paymentData = getAdyenPaymentDataFromOrder(order);
    const paymentId = getPaymentIdFromOrder(order);
    const { query  } = action.payload;
    const response = yield call(Payments.Adyen.completeAdyenRedirectPayment, apiConfig.paymentsUrl, {
        paymentId,
        paymentData,
        details: {
            redirectResult: query.redirectResult
        }
    });
    if (!response || !response.resultCode) {
        yield put(parseCallbackFailed({
            code: 'unknown',
            message: 'Failed to complete adyen redirect payment: missing result code in response from API!'
        }));
        return;
    }
    yield call(handleResultCode, response.resultCode);
}
function* handleResultCode(resultCode) {
    // Remove cart because it's inactive now
    yield call(removeCartFromLocalStorage);
    switch(resultCode.toLowerCase()){
        case CallbackResultCode.Authorised:
        case CallbackResultCode.Pending:
        case CallbackResultCode.Received:
            yield put(parseCallbackSucess({
                resultCode
            }));
            break;
        case CallbackResultCode.Cancelled:
        case CallbackResultCode.Refused:
            yield put(parseCallbackFailed({
                code: resultCode,
                message: `Parsing payment callback failed with result code: ${resultCode}`
            }));
            break;
        default:
            yield put(parseCallbackFailed({
                code: resultCode,
                message: 'Parsing payment callback failed with unrecognized result code!'
            }));
    }
}
function* onParseCallbackSuccess(action) {
    yield put(goToStep({
        route: StepNames.Completed
    }));
}
function* replicateCartFromOrderId(orderId) {
    const apiConfig = yield select(ApiConfigSelectors.getApiConfig);
    if (!apiConfig) {
        throw new Error('Need API configuration to replicate cart.');
    }
    if (!orderId) {
        throw new Error('Need orderId in order to replicate cart from order');
    }
    const { id: cartId  } = yield call(Carts.replicateCart, apiConfig.cartsUrl, {
        reference: {
            typeId: 'order',
            id: orderId
        }
    });
    dispatchCartChangeEvent(cartId);
}
function* onParseCallbackFailed(action) {
    const order = yield select(getOrderResponse);
    if (order) {
        try {
            yield call(replicateCartFromOrderId, order.id);
            yield put(goToStep({
                route: StepNames.Payment
            }));
        } catch (error) {
            console.error('Unable to replicate cart', error);
            yield put(goToStep({
                route: StepNames.Shipping
            }));
        }
    } else {
        console.error('Failed to restore cart after failed callback parsing because no order is found!');
        yield put(goToStep({
            route: StepNames.Shipping
        }));
    }
}
var callbackSagas = [
    takeLatest(PARSE_ADYEN_CALLBACK, onParseAdyenCallback),
    takeLatest(PARSE_CALLBACK_SUCCESS, onParseCallbackSuccess),
    takeLatest(PARSE_CALLBACK_FAILED, onParseCallbackFailed),
    takeLatest(COMPLETE_ADYEN_REDIRECT_PAYMENT, onCompleteAdyenRedirectPayment), 
];

/**
 * Step navigation throughout the checkout
 */ function* onGoToStep(action) {
    const routes = yield select(getRoutes);
    if (!routes || !routes[action.payload.route]) {
        throw new Error('Need routes to redirect');
    }
    const historyWrapper = yield call(history);
    yield call(historyWrapper.push, {
        pathname: routes[action.payload.route].path
    });
}
/**
 * Restores a cart based on the order that was placed but not finished succesfully
 */ function* onRestoreCart(action) {
    const { orderId  } = action.payload;
    if (!orderId) {
        throw new Error('Unable to restore cart without a valid order ID and api URL!');
    }
    yield call(replicateCartFromOrderId, orderId);
}
/**
 * Create order with cart and payment details
 */ function* onCreateOrder(action) {
    const apiConfig = yield select(ApiConfigSelectors.getApiConfig);
    const paymentMethod = yield select(getSelectedPaymentMethod);
    if (!apiConfig || !paymentMethod) {
        throw new Error(`Need apiConfig and a payment method to create an order! Received: apiConfig: ${JSON.stringify(apiConfig)}, paymentMethod: ${JSON.stringify(paymentMethod)}`);
    }
    const { returnUrl , cartCentAmount  } = action.payload;
    const currency = yield select(IntlSelectors.getCurrency);
    const country = yield select(IntlSelectors.getCountry);
    const locale = yield select(IntlSelectors.getLocale);
    const isLoggedIn = yield select(Selectors.isLoggedIn);
    const cartId = cartIdVar();
    if (!cartId) {
        yield put(createOrderFailed(new Error(`Need a valid cart to create an order!`)));
        yield call(redirect, '/');
        return;
    }
    const paymentImplementation = yield call(getPaymentImplementation, paymentMethod.provider, paymentMethod.type);
    if (!paymentImplementation) {
        throw new Error(`Don't have implementation for '${paymentMethod.type}', provider: '${paymentMethod.provider}'`);
    }
    const createAccount = yield select(shouldCreateAccount);
    const changedOptIns = yield select(getChangedOptIns);
    const optins = changedOptIns && Utils.createOptInsUpdate(changedOptIns);
    const consents = yield select(getConsents);
    const mappedConsents = consents && mapConsentsToOrderModel(consents);
    let accessToken;
    // In case the user already has an account, he still has the option to change opt-ins during checkout
    if (isLoggedIn) {
        accessToken = yield call(getToken);
        yield put(Actions.OptInsActions.updateOptIns(changedOptIns));
    }
    let loginRedirectUrl;
    if (createAccount) {
        const { protocol , host  } = window.location;
        const { routing  } = yield select(Selectors.getAuth);
        loginRedirectUrl = `${protocol}//${host}/${routing.basePath}/callback`;
    }
    try {
        const analyticsId = yield call(GoogleAnalytics.getAnalyticsId);
        const paymentDetails = yield select(getSelectedPaymentDetails);
        const mappedPaymentMethod = {
            provider: getRestPaymentProviderName(paymentMethod.provider),
            type: getRestPaymentMethodName(paymentMethod.type)
        };
        const paymentDraftPayload = {
            cartCentAmount,
            returnUrl,
            currency,
            country,
            locale,
            paymentMethod: (paymentDetails === null || paymentDetails === void 0 ? void 0 : paymentDetails.type) ? swcHelpers.objectSpread({}, mappedPaymentMethod, {
                type: getRestPaymentMethodName(paymentDetails.type)
            }) : mappedPaymentMethod,
            paymentDetails: paymentDetails ? paymentDetails.data : {}
        };
        const paymentDraft = yield call(createPaymentDraft, paymentDraftPayload);
        const orderDraft = {
            cartId,
            paymentRequest: paymentDraft,
            addCartToPayment: paymentImplementation.addCartToPayment,
            analyticsId,
            shouldCreateAccount: createAccount,
            optins,
            loginRedirectUrl,
            consents: mappedConsents
        };
        const result = yield call(Orders.create, apiConfig.ordersUrl, orderDraft, accessToken);
        if (!result || result.errorId || !result.paymentResponse || !result.paymentResponse.result) {
            if ((result === null || result === void 0 ? void 0 : result.order) && (result === null || result === void 0 ? void 0 : result.order.id)) {
                yield call(replicateCartFromOrderId, result.order.id);
            }
            yield put(createOrderFailed(result));
            return;
        }
        const { status  } = result.paymentResponse.result;
        if (!status || status === PaymentTypes.PaymentResult.Failed) {
            if ((result === null || result === void 0 ? void 0 : result.order) && (result === null || result === void 0 ? void 0 : result.order.id)) {
                yield call(replicateCartFromOrderId, result.order.id);
            }
            yield put(createOrderFailed(result));
            return;
        }
        if (status === PaymentTypes.PaymentResult.Redirect && result.paymentResponse.redirect) {
            dispatchCartChangeEvent(cartId);
            yield put(setPaymentFlow({
                paymentFlow: PaymentFlow.REDIRECT
            }));
            yield put(createOrderSuccess({
                order: result
            }));
            switch(result.paymentResponse.redirect.method){
                case 'GET':
                    window.location.assign(result.paymentResponse.redirect.url);
                    break;
                case 'POST':
                    if (result.paymentResponse.redirect.data) {
                        yield put(postPaymentToPsp({
                            paymentData: result.paymentResponse.paymentData,
                            postUrl: result.paymentResponse.redirect.url,
                            postFields: result.paymentResponse.redirect.data
                        }));
                    }
                    break;
            }
        } else if (status === PaymentTypes.PaymentResult.Pending && result.paymentResponse.resultDetails && result.paymentResponse.resultDetails.type === 'qrCode') {
            yield put(setPaymentFlow({
                paymentFlow: PaymentFlow.QR_CODE
            }));
            yield put(setOrder({
                order: result
            }));
        } else if (status === PaymentTypes.PaymentResult.Success || status === PaymentTypes.PaymentResult.Pending) {
            yield put(setPaymentFlow({
                paymentFlow: PaymentFlow.ACTIONLESS
            }));
            yield call(removeCartFromLocalStorage) // Remove cart because it's Inactive now
            ;
            yield put(createOrderSuccess({
                order: result
            }));
            yield put(goToStep({
                route: StepNames.Completed
            }));
        } else {
            yield put(createOrderFailed(result));
        }
    } catch (error) {
        if (error.statusCode === 400) {
            yield put(createOrderFailed(new Error(`Need a valid cart to create an order!`)));
            yield call(redirect, '/');
            return;
        } else {
            console.error(error);
            yield put(createOrderFailed(error));
        }
    }
}
function* onClearOrder(action) {
    yield call(replicateCartFromOrderId, action.payload.orderId);
    return;
}
function createPaymentDraft(payload) {
    const { cartCentAmount , paymentMethod , returnUrl , currency , country , locale , paymentDetails ,  } = payload;
    const baseDraft = {
        amount: {
            currency,
            value: cartCentAmount,
            fractionDigits: 2
        },
        paymentMethod: paymentMethod.type,
        paymentServiceProvider: paymentMethod.provider,
        countryCode: country,
        returnUrl,
        locale
    };
    return swcHelpers.objectSpread({}, baseDraft, {
        paymentDetails
    });
}
function* onGetAdditionalCartCosts() {
    const apiConfig = yield select(ApiConfigSelectors.getApiConfig);
    if (!apiConfig) {
        throw new Error('Need API URL to get additional cart costs.');
    }
    try {
        const { results  } = yield call(Products.query, apiConfig.productsUrl, {
            // Main category is called additionalCartCosts, but the "products" are configured in additionalPaymentCost
            categoryType: 'additionalPaymentCost'
        });
        if (results) {
            yield put(getAdditionalCostsSuccess({
                result: results
            }));
        } else {
            yield put(getAdditionalCostsFailed({
                code: 404,
                message: 'No products found in "additionalPaymentCost" category'
            }));
        }
    } catch (error) {
        yield put(getAdditionalCostsFailed({
            code: 500,
            message: error.message
        }));
    }
}
function* onGetOrderDataByToken(action) {
    const apiConfig = yield select(ApiConfigSelectors.getApiConfig);
    const { orderData  } = action.payload;
    if (!apiConfig || !orderData) {
        throw new Error(`Need api config and order data token to get an order! Received: apiConfig: ${JSON.stringify(apiConfig)}, orderData: ${JSON.stringify(orderData)}`);
    }
    try {
        const orderDraft = {
            orderData
        };
        const result = yield call(Orders.getOrderByToken, apiConfig.ordersUrl, orderDraft);
        if (result.id) {
            yield put(getOrderByTokenSucces({
                order: result
            }));
        } else {
            yield put(getOrderByTokenFailed(result));
        }
    } catch (error) {
        console.error(error);
        yield put(getOrderByTokenFailed(error));
    }
}
function* onRefreshPaymentForOrder(action) {
    const { order  } = yield select(getOrder);
    const { returnUrl , cartCentAmount  } = action.payload;
    yield call(onRestoreCart, restoreCart({
        orderId: order.id
    }));
    yield put(createOrder({
        returnUrl,
        cartCentAmount
    }));
}
function* onPaymentSuccessForOrder() {
    const { orderDataToken  } = yield select(getOrder);
    yield call(onGetOrderDataByToken, getOrderByToken({
        orderData: orderDataToken
    }));
    yield put(clearPaymentFlow());
    yield call(removeCartFromLocalStorage);
    yield put(goToStep({
        route: StepNames.Completed
    }));
}
var rootSagas = [
    takeLatest(GO_TO_STEP, onGoToStep),
    takeLatest(CART_RESTORE, onRestoreCart),
    takeLatest(ORDER_CREATE, onCreateOrder),
    takeLatest(ORDER_CLEAR, onClearOrder),
    takeLatest(GET_ADDITIONAL_COSTS, onGetAdditionalCartCosts),
    takeLatest(ORDER_GET_BY_TOKEN, onGetOrderDataByToken),
    takeLatest(REFRESH_PAYMENT_FOR_ORDER, onRefreshPaymentForOrder),
    takeLatest(PAYMENT_SUCCESS_FOR_ORDER, onPaymentSuccessForOrder), 
];

function* onOrderCreateSuccess(action) {
    const paymentDetails = yield select(getPaymentDetails);
    const { paymentServiceProvider , paymentMethod , resultDetails ,  } = action.payload.order.paymentResponse;
    if (paymentDetails) {
        const methods = paymentDetails[paymentServiceProvider];
        const existing = methods && methods[paymentMethod];
        yield put(updatePaymentDetails(swcHelpers.objectSpread({
            provider: getGraphQLPaymentProviderName(paymentServiceProvider)
        }, existing || {
            data: {},
            isValid: true
        }, {
            type: getGraphQLPaymentMethodName(paymentMethod),
            result: resultDetails
        })));
    }
}
var paymentMethodsSagas = [
    takeLatest(ORDER_CREATE_SUCCESS, onOrderCreateSuccess)
];

const DEFAULT_STATE = {
    isValid: false,
    isEnabled: false,
    formData: {}
};
const DOB_OPTIONS = [
    'customerDateOfBirth',
    'customerDOB',
    'dateOfBirth'
];
const fieldsOverlapExists = (sourceFields, targetFields)=>sourceFields.filter((item)=>targetFields.includes(item)
    ).length
;
function* onTogglePrefill(action) {
    const { email , targetFormState , sourceFormName , targetFormName , source , addressId , validateForm ,  } = action.payload;
    if (!action.payload.data) {
        yield put(togglePrefillSuccess({
            source
        }));
        return;
    }
    const prefillData = action.payload.data[sourceFormName];
    const formizedData = Util.objectToFormState(action.payload.data);
    const checkoutForm = targetFormState || DEFAULT_STATE;
    const sourceForm = formizedData[sourceFormName];
    let newFieldValues = {};
    // When the checkoutForm contains an "email" field, we need to add it to the newFieldValues
    const checkoutFieldNames = Object.keys(checkoutForm.formData);
    const sourceFormFieldNames = sourceForm ? Object.keys(sourceForm === null || sourceForm === void 0 ? void 0 : sourceForm.formState) : [];
    if (sourceForm || checkoutFieldNames.includes('email')) {
        newFieldValues = checkoutFieldNames.reduce((fieldAcc, fieldName)=>{
            const checkoutFieldState = checkoutForm.formData[fieldName] || {
                name: fieldName,
                value: ''
            };
            let sourceFieldState = sourceForm === null || sourceForm === void 0 ? void 0 : sourceForm.formState[fieldName];
            /**
         *  Condition to handle case where key used to store
         *  dateOfBirth in personalDetails form is different than
         *  key used in customerDetails form of checkout
         */ if (DOB_OPTIONS.includes(fieldName) && fieldsOverlapExists(DOB_OPTIONS, sourceFormFieldNames) && !sourceFieldState) {
                sourceFieldState = (sourceForm === null || sourceForm === void 0 ? void 0 : sourceForm.formState.customerDateOfBirth) || (sourceForm === null || sourceForm === void 0 ? void 0 : sourceForm.formState.customerDOB) || (sourceForm === null || sourceForm === void 0 ? void 0 : sourceForm.formState.dateOfBirth);
            }
            const value = sourceFieldState && sourceFieldState.value ? sourceFieldState.value.toString() : checkoutFieldState.value;
            return swcHelpers.objectSpread({}, fieldAcc, {
                [fieldName]: swcHelpers.objectSpread({}, checkoutFieldState, {
                    value: fieldName === 'email' && email ? email : value,
                    isTouched: true
                })
            });
        }, {});
    } else {
        newFieldValues = checkoutForm.formData;
    }
    const shippingDetailsUpdate = {
        formName: targetFormName,
        formValid: targetFormState.isValid,
        formState: swcHelpers.objectSpread({}, checkoutForm.formData, newFieldValues)
    };
    try {
        /**
     * This action fills the form with the new updated data.
     */ yield put(updateShippingDetails({
            form: shippingDetailsUpdate,
            addressBookId: addressId
        }));
        const { updateShippingDetailsSuccess  } = yield race({
            updateShippingDetailsSuccess: take(UPDATE_SHIPPING_DETAILS),
            timeout: delay(10000)
        });
        /**
     * Wait for the UPDATE_SHIPPING_DETAILS action to be completed, before validating the updated form.
     */ if (updateShippingDetailsSuccess && validateForm) {
            yield call(validateForm, prefillData);
        }
        yield put(togglePrefillSuccess({
            source
        }));
    } catch (err) {
        yield put(togglePrefillFailed({
            source
        })) // for Redux logging purposes
        ;
    }
}
function* onTogglePrefillFailed(action) {
    const { reason  } = action.payload;
    if (action.payload.source === PrefillSources.AddressBook) {
        yield put(addressBookPrefillValidationFailed({
            reason: reason || 'error'
        }));
    }
}
function* listenForPrefill() {
    /**
   * After prefill of the address book data, the form that it gets prefilled into needs to
   * validate that data. Only after the (invisible) form has validated the data, we'll know
   * whether we want to show a summary (if all good) or a semi-prefilled form (if form is invalid).
   */ while(true){
        const result = yield take(TOGGLE_PREFILL_SUCCESS);
        if (result.payload.source === PrefillSources.AddressBook) {
            yield fork(handleAddressPrefill);
        }
    }
}
function* handleAddressPrefill() {
    while(true){
        const { updateShippingAction , timeout , end ,  } = yield race({
            updateShippingAction: take(UPDATE_SHIPPING_DETAILS),
            timeout: delay(10000),
            end: take(END.type)
        });
        if (end) {
            return;
        }
        if (timeout) {
            yield put(addressBookPrefillValidationFailed({
                reason: 'timeout'
            }));
            return;
        }
        if (updateShippingAction.payload.form.formName === ShippingObjectTypes.BillingAddress) {
            if (updateShippingAction.payload.form.formValid) {
                yield put(addressBookPrefillValidationSuccess());
            } else {
                yield put(addressBookPrefillValidationFailed({
                    reason: 'invalidData'
                }));
            }
            return;
        }
    }
}
// saga can be removed when setPreferredShippingMethod is moved to shipping package
function* onSelectShippingMethod(action) {
    const shippingMethod = action.payload.shippingMethod;
    if (shippingMethod.method) {
        // Store the last chosen shipping method as preferred method under shipping redux state key
        yield put(setPreferredShippingMethod({
            shippingMethodKey: shippingMethod.method
        }));
    }
}
var stepShippingSagas = [
    takeLatest(TOGGLE_PREFILL, onTogglePrefill),
    takeLatest(TOGGLE_PREFILL_FAILED, onTogglePrefillFailed),
    fork(listenForPrefill),
    takeLeading(SELECT_SHIPPING_METHOD, onSelectShippingMethod), 
];

/**
 * Checkout root saga
 */ function* sagas() {
    yield all([
        ...rootSagas,
        ...paymentMethodsSagas,
        ...stepShippingSagas,
        ...callbackSagas
    ]);
}

const AddressLookup$1 = ({ displayError , displayIsValid , errorMessage , inputFieldName , label , onResult , required =true , setIsTouched , streetName , updateForm  })=>/*#__PURE__*/ React__default.createElement("label", {
        className: "address-lookup form-control"
    }, /*#__PURE__*/ React__default.createElement("span", {
        className: "form-control__label"
    }, label, required && /*#__PURE__*/ React__default.createElement("span", {
        className: "form-control__asterisk"
    }, "*")), /*#__PURE__*/ React__default.createElement(AddressSearchForm, {
        inputFieldName: inputFieldName,
        isInvalid: displayError,
        isValid: displayIsValid,
        onResult: onResult,
        setIsTouched: setIsTouched,
        streetName: streetName,
        updateForm: updateForm
    }), displayError && /*#__PURE__*/ React__default.createElement("span", {
        id: "address-lookup",
        className: "form-control__error"
    }, errorMessage))
;

const mapDataToFormValues = (data, addressLookup)=>{
    const { city , postalCode , province , streetNumber  } = data;
    let { streetName  } = data;
    if ((addressLookup === null || addressLookup === void 0 ? void 0 : addressLookup.shouldCombineAddress) && streetNumber) {
        var ref;
        var _addressLineFormat;
        addressLookup.addressLineFormat = (_addressLineFormat = addressLookup.addressLineFormat) !== null && _addressLineFormat !== void 0 ? _addressLineFormat : AddressLineFormat.streetName_streetNumber;
        const addressKeysSequence = (ref = addressLookup.addressLineFormat) === null || ref === void 0 ? void 0 : ref.split('_');
        streetName = '';
        addressKeysSequence === null || addressKeysSequence === void 0 ? void 0 : addressKeysSequence.forEach((key)=>{
            streetName += `${data[key]} `;
        });
    }
    var ref1;
    return swcHelpers.objectSpread({
        streetName: (ref1 = streetName === null || streetName === void 0 ? void 0 : streetName.trim()) !== null && ref1 !== void 0 ? ref1 : ''
    }, optionalKey('streetNumber', streetNumber), optionalKey('city', city), optionalKey('postalCode', postalCode), optionalKey('region', province));
};

const validateInputField = (required, value, validations, maxLengthValue)=>{
    if (!required && value.length === 0) {
        return true;
    }
    if (required) {
        if (!Util.validations.isRequired(value)) {
            return false;
        }
    }
    if (maxLengthValue && !Util.validations.maxLength(maxLengthValue)(value)) {
        return false;
    }
    if (validations) {
        return validations.reduce((isValid, validator)=>validator(value) && isValid
        , true);
    }
    return true;
};

const AddressLookupContainer = ({ errorMessage , inputFieldName ='streetName' , label , maxLength , validations  })=>{
    const [isTouched, setIsTouched] = React__default.useState(false);
    const shippingDetails = useSelector(getShippingDetails);
    const deliveryAddress = useSelector(getDeliveryAddress);
    const billingAddress = useSelector(getBillingAddress);
    const { addressLookup  } = useCheckoutSettings();
    const { name , onChange , getInitialState , onBlur  } = useFormContext();
    const currentForm = name === ShippingObjectTypes.BillingAddress ? billingAddress : deliveryAddress;
    const initialState = getInitialState && getInitialState(inputFieldName);
    const dispatch = useDispatch();
    const validateForm = React__default.useCallback((prefillData)=>{
        prefillData && Object.entries(prefillData).forEach(([key, value])=>{
            onBlur === null || onBlur === void 0 ? void 0 : onBlur({
                name: key,
                value
            });
        });
    }, [
        onBlur
    ]);
    const updateStore = React__default.useCallback((prefillData)=>{
        const dynamicForm = name === ShippingObjectTypes.BillingAddress ? {
            billingAddress: ShippingObjectTypes.BillingAddress
        } : {
            deliveryAddress: ShippingObjectTypes.DeliveryAddress
        };
        Object.entries(dynamicForm).forEach(([sourceFormName, checkoutFormName])=>{
            dispatch(togglePrefill({
                source: PrefillSources.AutoComplete,
                data: {
                    [sourceFormName]: prefillData
                },
                targetFormState: shippingDetails && shippingDetails[checkoutFormName],
                sourceFormName,
                targetFormName: checkoutFormName,
                validateForm
            }));
        });
    }, [
        dispatch,
        name,
        shippingDetails,
        validateForm
    ]);
    const updateForm = React__default.useCallback((value, initialRender)=>{
        onChange && onChange({
            name: inputFieldName,
            value,
            isTouched: initialRender ? !!(initialState === null || initialState === void 0 ? void 0 : initialState.isTouched) : true,
            isValid: validateInputField(true, value, validations, maxLength)
        });
    }, [
        inputFieldName,
        maxLength,
        onChange,
        validations,
        initialState === null || initialState === void 0 ? void 0 : initialState.isTouched
    ]);
    const handleOnResult = React__default.useCallback((data)=>{
        const formattedData = mapDataToFormValues(data, addressLookup);
        const prefillData = swcHelpers.objectSpread({}, currentForm, formattedData);
        updateForm(prefillData.streetName);
        updateStore(prefillData);
    }, // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        currentForm === null || currentForm === void 0 ? void 0 : currentForm.firstName,
        currentForm === null || currentForm === void 0 ? void 0 : currentForm.lastName
    ]);
    const handleIsTouched = React__default.useCallback(()=>{
        setIsTouched(true);
    }, []);
    React__default.useEffect(()=>{
        if (!initialState) {
            return;
        }
        onChange && onChange({
            name: inputFieldName,
            value: initialState.value,
            isTouched: initialState.isTouched || isTouched || Boolean(initialState.value),
            isValid: validateInputField(true, initialState.value, validations, maxLength)
        });
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        updateForm,
        initialState === null || initialState === void 0 ? void 0 : initialState.isTouched,
        initialState === null || initialState === void 0 ? void 0 : initialState.isValid,
        initialState === null || initialState === void 0 ? void 0 : initialState.value,
        onChange,
        validations, 
    ]);
    React__default.useEffect(()=>{
        // Initializing the field in form context so it can be prefilled.
        !(currentForm === null || currentForm === void 0 ? void 0 : currentForm.streetName) && updateForm('', true);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return /*#__PURE__*/ React__default.createElement(AddressLookup$1, {
        displayError: !Boolean(initialState === null || initialState === void 0 ? void 0 : initialState.isValid) && (Boolean(initialState === null || initialState === void 0 ? void 0 : initialState.isTouched) || isTouched),
        displayIsValid: Boolean(initialState === null || initialState === void 0 ? void 0 : initialState.isValid) && (Boolean(initialState === null || initialState === void 0 ? void 0 : initialState.isTouched) || isTouched),
        errorMessage: errorMessage,
        inputFieldName: inputFieldName,
        label: label,
        setIsTouched: handleIsTouched,
        onResult: handleOnResult,
        streetName: (initialState === null || initialState === void 0 ? void 0 : initialState.value) || '',
        updateForm: updateForm
    });
};

const AddressLookup = (props)=>/*#__PURE__*/ React__default.createElement(AddressLookupContainer, swcHelpers.extends({}, props))
;

function ItemList({ getItemIdentifier , getItemLabel , idPrefix , items , onChange , selectedItems , shouldIndent =false , getItemErrorMessage , shouldItemValidate  }) {
    return /*#__PURE__*/ React.createElement("div", {
        className: classnames('checkout__consent', {
            'checkout__consent--indent': shouldIndent
        })
    }, /*#__PURE__*/ React.createElement(CheckboxList, {
        getItemIdentifier: getItemIdentifier,
        getItemErrorMessage: getItemErrorMessage,
        shouldItemValidate: shouldItemValidate,
        idPrefix: idPrefix,
        items: items,
        onChange: onChange,
        renderItem: (item)=>/*#__PURE__*/ React.createElement("span", null, getItemLabel(item))
        ,
        selectedItems: selectedItems
    }));
}

const ConsentsContainer = ()=>{
    const dispatch = useDispatch();
    const { consent: consentSettings  } = useCheckoutSettings();
    const consents = useSelector(getConsents);
    React.useEffect(()=>{
        const checkoutConsents = (consentSettings === null || consentSettings === void 0 ? void 0 : consentSettings.items) || [];
        if (checkoutConsents.length !== (consents === null || consents === void 0 ? void 0 : consents.length)) {
            const initialConsents = checkoutConsents.map((consent)=>swcHelpers.objectSpread({}, consent, {
                    isChecked: false
                })
            );
            dispatch(setConsents({
                consents: initialConsents
            }));
        }
    }, [
        consentSettings,
        consents,
        dispatch
    ]);
    const handleChange = React.useCallback((selectedConsents)=>dispatch(toggleConsent({
            consents: selectedConsents.map((c)=>c.value
            )
        }))
    , [
        dispatch
    ]);
    const selectedConsents1 = React.useMemo(()=>{
        return (consents === null || consents === void 0 ? void 0 : consents.filter((consent)=>consent.isChecked
        )) || [];
    }, [
        consents
    ]);
    const getItemLabel = React.useCallback((item)=>parseHtml(item.title)
    , []);
    const getItemIdentifier = React.useCallback((item)=>item.value
    , []);
    const getItemErrorMessage = React.useCallback((item)=>{
        return (item === null || item === void 0 ? void 0 : item.errorMessage) || '';
    }, []);
    const shouldItemValidate = React.useCallback((item)=>{
        return (item === null || item === void 0 ? void 0 : item.shouldValidate) || false;
    }, []);
    if (!(consents === null || consents === void 0 ? void 0 : consents.length)) {
        return null;
    }
    return /*#__PURE__*/ React.createElement(ItemList, {
        getItemIdentifier: getItemIdentifier,
        getItemLabel: getItemLabel,
        getItemErrorMessage: getItemErrorMessage,
        shouldItemValidate: shouldItemValidate,
        idPrefix: "consents__",
        items: consents,
        onChange: handleChange,
        selectedItems: selectedConsents1
    });
};

const CreateAccount = ({ checked , errorMessage , label , onChange  })=>/*#__PURE__*/ React.createElement("div", {
        className: "checkout__create-account"
    }, /*#__PURE__*/ React.createElement(CheckboxWithLabel, {
        className: "checkout__create-account--checkbox",
        id: "createAccountDuringCheckout",
        value: "createAccountDuringCheckout",
        checked: checked,
        onChange: onChange,
        label: label,
        error: !!errorMessage,
        errorMessage: errorMessage
    }))
;

function isFormValid(items) {
    return Object.values(items).every((item)=>{
        return Boolean(item === null || item === void 0 ? void 0 : item.isValid);
    });
}
var updateContactDetails = (isCreatingAccount, contactDetails)=>{
    const fullFormData = contactDetails === null || contactDetails === void 0 ? void 0 : contactDetails.formData;
    const rest = swcHelpers.objectWithoutProperties(fullFormData, [
        "dateOfBirth"
    ]);
    const formState = isCreatingAccount ? fullFormData : rest;
    return {
        formName: 'contactDetails',
        formState,
        formValid: isFormValid(formState)
    };
};

const CreateAccountContainer = ()=>{
    var ref;
    const dispatch = useDispatch();
    const { getLabel , getFormattedLabel  } = useIntl();
    const { account  } = useCheckoutSettings();
    const { isMyAccountEnabled  } = useFeatureToggles();
    const isLoggedIn = useSelector(Selectors.isLoggedIn);
    const shouldCreateAccountBoolean = useSelector(shouldCreateAccount);
    const shouldValidateMyAccountBoolean = useSelector(shouldValidateMyAccount);
    const contactDetails = (ref = useSelector(getShippingDetails)) === null || ref === void 0 ? void 0 : ref.contactDetails;
    const implicitAccountCreation = !!(account === null || account === void 0 ? void 0 : account.implicitAccountCreation);
    React.useEffect(()=>{
        if (implicitAccountCreation) {
            dispatch(toggleAccountCreation({
                shouldCreateAccount: true
            }));
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    const handleChange = ({ checked  })=>{
        // update the contact details form for validation purposes
        dispatch(updateShippingDetails({
            form: updateContactDetails(checked, contactDetails)
        }));
        dispatch(toggleAccountCreation({
            shouldCreateAccount: checked
        }));
        if (!checked) {
            // clear opt-ins when account creation is unchecked
            dispatch(setChangedOptIns({}));
        }
    };
    const labels = React.useMemo(()=>{
        return {
            text: getFormattedLabel((account === null || account === void 0 ? void 0 : account.createAccountRequired) ? 'checkout.createAccount.agreement' : 'account.createAccount.label', {
                parseLink: true
            }),
            agreementError: !shouldCreateAccountBoolean && shouldValidateMyAccountBoolean ? getLabel('checkout.createAccount.agreement.error') : undefined
        };
    }, [
        account === null || account === void 0 ? void 0 : account.createAccountRequired,
        getFormattedLabel,
        getLabel,
        shouldCreateAccountBoolean,
        shouldValidateMyAccountBoolean, 
    ]);
    if (!isMyAccountEnabled || isLoggedIn || implicitAccountCreation) {
        return null;
    }
    return /*#__PURE__*/ React.createElement(CreateAccount, {
        checked: shouldCreateAccountBoolean,
        errorMessage: labels.agreementError,
        label: labels.text,
        onChange: handleChange
    });
};

const toSavedOptIns = (rawOptIns)=>{
    if (!rawOptIns) return {};
    var _value;
    return rawOptIns.reduce((result, optIn)=>swcHelpers.objectSpread({}, result, {
            [optIn.id]: (_value = optIn.value) !== null && _value !== void 0 ? _value : false
        })
    , {});
};
const getShownOptIns = (allOptIns, savedOptIns)=>{
    if (!Object.keys(savedOptIns).length) {
        return allOptIns;
    }
    // previously selected opt ins
    const alreadySelectedOptIns = Object.keys(savedOptIns).filter((key)=>savedOptIns[key]
    );
    return allOptIns.filter((optIn)=>{
        if (!Types.isGroupedOptin(optIn)) return !alreadySelectedOptIns.includes(optIn.value);
        const ungroupedOptIns = Utils.ungroupOptIns([
            optIn
        ]);
        // filter through the nested optins to see if they are selected
        return ungroupedOptIns.some((o)=>!alreadySelectedOptIns.includes(o.value)
        );
    });
};
const createOptIn = (optIn, checked, getLabel)=>{
    return {
        [optIn.value]: {
            label: getLabel(optIn.titleKey) || optIn.value,
            checked
        }
    };
};
const toChangedOptIns = (optIns, savedOptIns, selectedOptIns, getLabel)=>{
    const ungroupOptIn = (optIn1, isSelected)=>{
        return Utils.ungroupOptIns([
            optIn1
        ]).filter((optIn)=>{
            const isPreviouslySaved = Object.keys(savedOptIns).includes(optIn.value);
            // do not save again if was previously selected and saved in the backend,
            // but has not additionally opted in the frontend. this is done to not reset previous MYA settings by overwriting them here
            if (isPreviouslySaved && savedOptIns[optIn.value] === true && isSelected === false) return false;
            // save optins that have been changed
            return savedOptIns[optIn.value] !== isSelected;
        }).map((optIn)=>{
            const isChecked = isSelected || savedOptIns[optIn.value] || false;
            return createOptIn(optIn, isChecked, getLabel);
        }).reduce((prev, curr)=>swcHelpers.objectSpread({}, prev, curr)
        , {});
    };
    const toChangedOptIn = (optIn)=>{
        const isSelected = Boolean(selectedOptIns.find((o)=>o.titleKey === optIn.titleKey
        ));
        if (Types.isGroupedOptin(optIn)) {
            return ungroupOptIn(optIn, isSelected);
        }
        const shownOptIns = getShownOptIns(optIns, savedOptIns);
        const isHidden = !Boolean(shownOptIns.find((s)=>s.titleKey === optIn.titleKey
        ));
        if (isHidden) {
            return;
        }
        const isPreviouslySaved = Object.keys(savedOptIns).includes(optIn.value);
        const changedFromPreviouslySaved = savedOptIns[optIn.value] !== isSelected;
        if (isPreviouslySaved && !changedFromPreviouslySaved) {
            // do not save previously saved, but unchanged items
            return;
        }
        const isChecked = isSelected || savedOptIns[optIn.value] || false;
        return createOptIn(optIn, isChecked, getLabel);
    };
    return optIns.reduce((result, optIn)=>{
        return swcHelpers.objectSpread({}, result, toChangedOptIn(optIn));
    }, {});
};

const OptInsContainer = ({ handleOptInsLoading  })=>{
    const dispatch = useDispatch();
    const { getLabel , getFormattedLabel  } = useIntl();
    const { account , consent  } = useCheckoutSettings();
    const { isMyAccountEnabled  } = useFeatureToggles();
    const isLoggedIn = useSelector(Selectors.isLoggedIn);
    const shouldCreateAccountBoolean = useSelector(shouldCreateAccount);
    const [selectedOptIns, setSelectedOptIns] = React.useState([]);
    const { optInsFromServer , isFetching  } = useOptIns();
    const { availableOptIns  } = useAvailableOptIns();
    const savedOptIns = React.useMemo(()=>toSavedOptIns(optInsFromServer)
    , [
        optInsFromServer
    ]);
    React.useEffect(()=>{
        /**
     *  Callback to notify the consumer of OptInsContainer
     *  about OptIns loading status from GQL query
     *  In checkout the user doesn't have to be logged in to proceed
     */ handleOptInsLoading === null || handleOptInsLoading === void 0 ? void 0 : handleOptInsLoading({
            isOptInsLoading: isFetching
        });
    }, [
        isFetching,
        handleOptInsLoading
    ]);
    // this includes the optins that have been previously selected by the customer
    // and are stored in the backend
    const allOptIns = (consent === null || consent === void 0 ? void 0 : consent.optIns) || availableOptIns.filter((item)=>item.isInSignup
    );
    // do not include the optins the customer already opted in for
    const shownOptIns = React.useMemo(()=>getShownOptIns(allOptIns, savedOptIns)
    , [
        allOptIns,
        savedOptIns, 
    ]);
    const handleChange = React.useCallback((selectedItems)=>{
        setSelectedOptIns(selectedItems);
        const changedOptIns = toChangedOptIns(allOptIns, savedOptIns, selectedItems, getLabel);
        // store ungrouped optins ready to be saved in the redux state
        dispatch(setChangedOptIns(changedOptIns));
    }, [
        dispatch,
        getLabel,
        allOptIns,
        savedOptIns,
        shownOptIns
    ]);
    const getItemLabel = React.useCallback((item)=>getFormattedLabel(item.titleKey, {
            parseHTML: true
        })
    , [
        getFormattedLabel
    ]);
    const shouldIndent = React.useMemo(()=>{
        return !isLoggedIn && shouldCreateAccountBoolean && !(account === null || account === void 0 ? void 0 : account.implicitAccountCreation);
    }, [
        account,
        isLoggedIn,
        shouldCreateAccountBoolean
    ]);
    const getItemIdentifier = React.useCallback((item)=>item.titleKey
    , []);
    /**
   * Do not display opt-ins on these conditions:
   * 1. My account disabled and no custom opt-ins provided from an opco
   * 2. Displayable opt-ins list is empty
   * 3. Customer is not logged in and the create account check mark is not checked
   */ if (!isMyAccountEnabled && !(consent === null || consent === void 0 ? void 0 : consent.optIns) || !shownOptIns.length || isMyAccountEnabled && !isLoggedIn && !shouldCreateAccountBoolean) {
        return null;
    }
    return /*#__PURE__*/ React.createElement(ItemList, {
        getItemIdentifier: getItemIdentifier,
        getItemLabel: getItemLabel,
        idPrefix: "opt-ins__",
        items: shownOptIns,
        onChange: handleChange,
        selectedItems: selectedOptIns,
        shouldIndent: shouldIndent
    });
};

const Consents = ({ handleOptInsLoading  })=>/*#__PURE__*/ React.createElement("div", {
        className: "checkout__checkboxes"
    }, /*#__PURE__*/ React.createElement(CreateAccountContainer, null), /*#__PURE__*/ React.createElement(OptInsContainer, {
        handleOptInsLoading: handleOptInsLoading
    }), /*#__PURE__*/ React.createElement(ConsentsContainer, null))
;

const [FormSlotsProvider, useBaseFormSlot] = createSlotsContext({
    displayName: 'FormSlotsContext'
});
const useFormSlot = ()=>{
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7;
    const dispatch = useDispatch();
    const { Slots  } = useBaseFormSlot();
    const shippingData = useSelector(getShippingDetails);
    const cartContext = useContext(Context.CartContext);
    const profileDateOfBirthValue = (ref = useSelector(ProfileSelectors.getFormData)) === null || ref === void 0 ? void 0 : (ref1 = ref.personalDetails) === null || ref1 === void 0 ? void 0 : ref1.dateOfBirth;
    const cartContainsContactLenses = cartContext === null || cartContext === void 0 ? void 0 : (ref2 = cartContext.cart) === null || ref2 === void 0 ? void 0 : ref2.contains.contactLenses;
    const cartContainsSolutions = cartContext === null || cartContext === void 0 ? void 0 : (ref3 = cartContext.cart) === null || ref3 === void 0 ? void 0 : ref3.contains.solutions;
    const cartContainsPrescriptionGlasses = cartContext === null || cartContext === void 0 ? void 0 : (ref4 = cartContext.cart) === null || ref4 === void 0 ? void 0 : ref4.contains.prescriptionGlasses;
    const cartContainsSunglasses = cartContext === null || cartContext === void 0 ? void 0 : (ref5 = cartContext.cart) === null || ref5 === void 0 ? void 0 : ref5.contains.sunglasses;
    const cartContainsSubscription = cartContext === null || cartContext === void 0 ? void 0 : (ref6 = cartContext.cart) === null || ref6 === void 0 ? void 0 : ref6.contains.subscription;
    const cartContainsContactLensesSubscription = cartContext === null || cartContext === void 0 ? void 0 : (ref7 = cartContext.cart) === null || ref7 === void 0 ? void 0 : ref7.contains.contactLensesSubscription;
    const handleChange = React__default.useCallback((formData)=>{
        dispatch(updateShippingDetails({
            form: formData
        }));
    }, [
        dispatch
    ]);
    const debouncedHandleChange = React__default.useMemo(()=>{
        return debounce(200, handleChange);
    }, []);
    React__default.useEffect(()=>{
        return ()=>debouncedHandleChange.cancel()
        ;
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    /**
   *  Iterate over all form components passed by opco
   *  Bind data to form component
   **/ const forms = Object.entries(Slots).reduce((formItem, [key, Slot])=>{
        let formData = shippingData && shippingData[key] ? shippingData[key].formData : {};
        /**
     *  Prefill express checkout DOB if the user has DOB data in "my account"
     **/ const expressCheckoutDOBKey = 'express-checkout-dob';
        const dobFormData = formData[expressCheckoutDOBKey];
        if (dobFormData && profileDateOfBirthValue) {
            formData = swcHelpers.objectSpread({}, formData, {
                [expressCheckoutDOBKey]: swcHelpers.objectSpread({}, dobFormData, {
                    value: dobFormData.value || profileDateOfBirthValue
                })
            });
        }
        formItem[key] = /*#__PURE__*/ React__default.createElement(Form, {
            name: key,
            "data-t": key,
            initialFormState: formData,
            onChange: debouncedHandleChange
        }, /*#__PURE__*/ React__default.createElement(Slot, {
            cartContainsContactLenses: cartContainsContactLenses,
            cartContainsSolutions: cartContainsSolutions,
            cartContainsSunglasses: cartContainsSunglasses,
            cartContainsSubscription: cartContainsSubscription,
            cartContainsPrescriptionGlasses: cartContainsPrescriptionGlasses,
            cartContainsContactLensesSubscription: cartContainsContactLensesSubscription
        }));
        return formItem;
    }, {});
    return forms;
};

const [SummarySlotsProvider, useBaseSummarySlot] = createSlotsContext({
    displayName: 'SummarySlotsContext'
});
const useSummariesSlot = (isEditable = false)=>{
    const dispatch = useDispatch();
    const { Slots  } = useBaseSummarySlot();
    const { isPaymentCallbackApiRouteEnabled  } = useFeatureToggles();
    const shippingData = useSelector(getShippingData);
    const orderShippingData = useSelector(getOrderShippingData);
    const isCheckoutCompleted = useSelector(isCompleted);
    const slotShippingData = (isPaymentCallbackApiRouteEnabled || isCheckoutCompleted) && orderShippingData ? orderShippingData : shippingData;
    const onEdit = React__default.useCallback(()=>{
        dispatch(goToStep({
            route: StepNames.Shipping
        }));
    }, []);
    /**
   *  Iterate over all summary components passed by opco
   *  Bind data to summary component
   **/ const actions = {
        onEdit
    };
    const summaries = Object.entries(Slots).reduce((summmaryItem, [key, Slot])=>{
        let summaryData = slotShippingData && slotShippingData[key];
        if (shippingData && key === ShippingObjectTypes.ContactDetails) {
            const { firstName , lastName  } = shippingData[ShippingObjectTypes.BillingAddress];
            summaryData = swcHelpers.objectSpread({
                firstName,
                lastName
            }, summaryData);
        }
        // If DeliveryAddress has no summaryData, which means DeliveryAddress is the same as BillingAddress
        // Set summaryData for DeliveryAddress to summaryData of BillingAddress
        if (key === ShippingObjectTypes.DeliveryAddress && !summaryData) {
            summaryData = slotShippingData === null || slotShippingData === void 0 ? void 0 : slotShippingData.billingAddress;
        }
        summmaryItem[key] = /*#__PURE__*/ React__default.createElement("div", {
            "data-t": `${key}Summary`
        }, /*#__PURE__*/ React__default.createElement(Slot, {
            actions: isEditable ? actions : undefined,
            values: summaryData
        }));
        return summmaryItem;
    }, {});
    return summaries;
};

const TitleWithIcon = ({ label , icon , hideIcon =false , hideAsteriskSign =true  })=>/*#__PURE__*/ React.createElement("div", {
        className: "checkout-step-title"
    }, !hideIcon && /*#__PURE__*/ React.createElement("div", {
        className: "checkout-step-title__icon"
    }, /*#__PURE__*/ React.createElement(Icon, {
        name: icon
    })), /*#__PURE__*/ React.createElement(Heading, {
        variant: "smallest",
        component: "h2",
        className: !hideIcon ? 'checkout-step-title__heading checkout-step-title__heading--icon' : 'checkout-step-title__heading'
    }, label, !hideAsteriskSign && /*#__PURE__*/ React.createElement("span", {
        className: "checkout-step-title__asterisk"
    }, "*")))
;

const ImplicitTermsAndConditionsContainer = ()=>{
    const { consent  } = useCheckoutSettings();
    const { getFormattedLabel  } = useIntl();
    const labels = React.useMemo(()=>({
            disclaimerCondition: getFormattedLabel('checkout.disclaimer.conditions', {
                parseLink: true,
                openLinksInNewTab: true
            })
        })
    , [
        getFormattedLabel
    ]);
    if (!(consent === null || consent === void 0 ? void 0 : consent.implicitTermsAndConditions)) {
        return null;
    }
    return /*#__PURE__*/ React.createElement(Text, {
        className: "checkout-step__terms-and-conditions"
    }, labels.disclaimerCondition);
};

const LocationInfo$1 = ({ isStore , isStorePickupPhoneEnabled , location , message , onEdit , showOpeningHours =true  })=>{
    const { getLabel  } = useIntl();
    return /*#__PURE__*/ React.createElement(Card, {
        className: "checkout-location-info",
        "data-t": "locationInfoSummary"
    }, /*#__PURE__*/ React.createElement(Card.Content, null, onEdit && /*#__PURE__*/ React.createElement(Card.Actions, null, /*#__PURE__*/ React.createElement(Card.Button, {
        onClick: onEdit,
        children: getLabel('common.actions.edit')
    })), /*#__PURE__*/ React.createElement(Card.Section, null, /*#__PURE__*/ React.createElement(Card.Text, {
        variant: "body-head"
    }, location.name), /*#__PURE__*/ React.createElement(Card.Text, null, location.streetName, location.streetNumber && ` ${location.streetNumber}`, location.additionalStreetInfo && ` ${location.additionalStreetInfo}`), /*#__PURE__*/ React.createElement(Card.Text, null, location.postalCode, " ", location.town)), isStorePickupPhoneEnabled && isStore(location) && /*#__PURE__*/ React.createElement(Card.Section, null, /*#__PURE__*/ React.createElement(Card.Text, null, /*#__PURE__*/ React.createElement("a", {
        href: `tel:${location.phone}`
    }, location.phone))), message, showOpeningHours && isStore(location) && /*#__PURE__*/ React.createElement(Card.Text, null, /*#__PURE__*/ React.createElement(OpeningHours, {
        openingHours: location.openingHours
    }))));
};

const LocationInfoContainer = ({ location: location1 , onEdit , showMessage =true , showOpeningHours  })=>{
    const { isStorePickupPhoneEnabled  } = useFeatureToggles();
    const { getLabel  } = useIntl();
    const labels = React.useMemo(()=>({
            message: getLabel('checkout.locationInfo.message', {
                hideLabelKey: true
            })
        })
    , [
        getLabel
    ]);
    const isStore = React.useCallback((location)=>'phone' in location
    , []);
    const message = labels.message && showMessage ? /*#__PURE__*/ React.createElement(Alert, {
        icon: "information-circle",
        message: labels.message
    }) : null;
    return /*#__PURE__*/ React.createElement(LocationInfo$1, {
        isStorePickupPhoneEnabled: isStorePickupPhoneEnabled,
        location: location1,
        message: message,
        onEdit: onEdit,
        showOpeningHours: showOpeningHours,
        isStore: isStore
    });
};

const LocationInfo = (props)=>/*#__PURE__*/ React.createElement(LocationInfoContainer, swcHelpers.extends({}, props))
;

const PickupLocationInformation = ({ title , location , onPickupModalShow  })=>/*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(Heading, {
        variant: "smallest",
        component: "h2",
        className: "checkout-step__title"
    }, title), /*#__PURE__*/ React.createElement("div", {
        className: "checkout-pickup"
    }, /*#__PURE__*/ React.createElement(LocationInfo, {
        location: location,
        onEdit: onPickupModalShow
    })))
;

const PickupWarningMessage = ({ labels , onPickupModalShow  })=>/*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement("p", {
        className: "checkout-pickup__no-selection"
    }, labels.noSelection), /*#__PURE__*/ React.createElement("button", {
        className: "checkout-pickup__no-selection-link",
        onClick: onPickupModalShow
    }, labels.noSelectionLink))
;

const ShippingMethodsList = ({ handleChange , hasValidationError , selectedShippingMethod , shippingMethodItems  })=>{
    return /*#__PURE__*/ React.createElement("div", {
        className: "shippingMethods"
    }, /*#__PURE__*/ React.createElement(RadioButtonGroup, {
        scope: "shippingMethod",
        items: shippingMethodItems,
        value: selectedShippingMethod,
        onChange: handleChange,
        hasError: hasValidationError
    }));
};

const loadModule$2 = function() {
    var _ref = swcHelpers.asyncToGenerator(function*() {
        const { PickupPointsFinder  } = yield import(/* webpackChunkName: 'grandvisionhq-pickup-points' */ '@grandvisionhq/pickup-points');
        return PickupPointsFinder;
    });
    return function loadModule() {
        return _ref.apply(this, arguments);
    };
}();
const usePickupPointsModule = ()=>useDynamicModule(loadModule$2, '@grandvisionhq/pickup-points', [])
;
const PickupPointsFinderContainer = ({ errorMessage , onPickupPointSelect , itemsToBeShipped  })=>{
    const [PickupPointsFinder, loading, error] = usePickupPointsModule();
    const { featureConfigs  } = useFeatureToggles();
    const { pickupPoints  } = useCheckoutSettings();
    if (loading) {
        return /*#__PURE__*/ React__default.createElement(Loader, null);
    }
    if (error || !PickupPointsFinder) {
        return /*#__PURE__*/ React__default.createElement(Alert, {
            type: "error",
            notifyScreenReader: false,
            message: errorMessage
        });
    }
    return /*#__PURE__*/ React__default.createElement(PickupPointsFinder, {
        view: "modal",
        onPickupPointSelect: onPickupPointSelect,
        itemsToBeShipped: itemsToBeShipped,
        showCityField: !!(pickupPoints === null || pickupPoints === void 0 ? void 0 : pickupPoints.showCityField),
        mapOptions: {
            mapId: featureConfigs === null || featureConfigs === void 0 ? void 0 : featureConfigs.googleDynamicMapsMapId
        }
    });
};

const PickupPointsContainer = ()=>{
    const { getLabel  } = useIntl();
    const { itemsToBeShipped  } = useCheckoutSettings();
    const [modalIsOpen, setModalIsOpen] = React.useState(false);
    const dispatch = useDispatch();
    const selectedPickupPoint = useSelector(getSelectedPickupPoint);
    const onPickupPointSelect = (pickupPoint)=>{
        if (!pickupPoint) {
            return;
        }
        dispatch(selectPickupPoint({
            pickupPoint
        }));
        setModalIsOpen(false);
    };
    const onPickupModalClose = ()=>{
        setModalIsOpen(false);
    };
    const onPickupModalShow = (event)=>{
        setModalIsOpen(true);
        event && event.preventDefault();
    };
    React.useEffect(()=>{
        if (!selectedPickupPoint) {
            setModalIsOpen(true);
        }
    }, []);
    const labels = React.useMemo(()=>({
            error: getLabel('checkout.pickupPoints.error'),
            noSelection: getLabel('checkout.pickupPoints.selectPoint.message'),
            noSelectionLink: getLabel('checkout.pickupPoints.selectPoint.link'),
            title: getLabel('checkout.pickupPoints.title')
        })
    , [
        getLabel
    ]);
    if (modalIsOpen) {
        return /*#__PURE__*/ React.createElement(Modal, {
            className: "checkout-step--shipping__modal",
            showIcon: true,
            iconClassName: "checkout-step--shipping__modal__close",
            isOpen: modalIsOpen,
            onModalClose: onPickupModalClose
        }, /*#__PURE__*/ React.createElement(PickupPointsFinderContainer, {
            onPickupPointSelect: onPickupPointSelect,
            errorMessage: labels.error,
            itemsToBeShipped: itemsToBeShipped
        }));
    }
    if (!selectedPickupPoint) {
        return /*#__PURE__*/ React.createElement(PickupWarningMessage, {
            labels: labels,
            onPickupModalShow: onPickupModalShow
        });
    }
    return /*#__PURE__*/ React.createElement(PickupLocationInformation, {
        title: labels.title,
        location: selectedPickupPoint,
        onPickupModalShow: onPickupModalShow
    });
};

const loadModule$1 = function() {
    var _ref = swcHelpers.asyncToGenerator(function*() {
        const storeModule = yield import(/* webpackChunkName: 'grandvisionhq-stores-v2' */ '@grandvisionhq/stores-v2');
        return storeModule;
    });
    return function loadModule() {
        return _ref.apply(this, arguments);
    };
}();
const usePickupStoresModule$1 = ()=>useDynamicModule(loadModule$1, '@grandvisionhq/stores-v2', [])
;
const StoresFinderContainer = ({ onPickupStoreSelect  })=>{
    const features = useFeatureToggles();
    const [module, loading, error] = usePickupStoresModule$1();
    const { getLabel  } = useIntl();
    const onStoreSelect = React__default.useCallback((store)=>{
        onPickupStoreSelect(store);
    }, [
        onPickupStoreSelect
    ]);
    if (loading) {
        return /*#__PURE__*/ React__default.createElement(Loader, null);
    }
    if (error || !module) {
        return /*#__PURE__*/ React__default.createElement(Alert, {
            type: "error",
            notifyScreenReader: false,
            message: getLabel('checkout.pickupStores.error')
        });
    }
    const { Containers , Components , StoreFinderProvider , Util , Types  } = module;
    const { StoreFinder , PickUpButtons , withPickUpButtonsConfig  } = Containers;
    const { StoreListTopContent  } = Components;
    const storeFilter = (store)=>Util.areServicesAvailable(store, [
            Types$1.ServicesNotAvailable.PICK_UP_IN_STORE
        ])
    ;
    return /*#__PURE__*/ React__default.createElement(StoreFinderProvider, {
        googleMapsId: "google-maps-container",
        hidePhone: !features.isStorePickupPhoneEnabled,
        hideEmail: !features.isStorePickupEmailEnabled,
        storeFilter: storeFilter
    }, /*#__PURE__*/ React__default.createElement(StoreFinder, {
        isInsideModal: true,
        listTopContent: /*#__PURE__*/ React__default.createElement(StoreListTopContent, {
            title: getLabel('checkout.component.storeListTopContent.title'),
            description: getLabel('checkout.component.storeListTopContent.description')
        }),
        buttonsComponent: withPickUpButtonsConfig(PickUpButtons, {
            onStoreSelect
        })
    }));
};

const useShippingMethodSelection = ({ onError , shippingMethodList  })=>{
    const { refetch  } = Context.useCart();
    /**
   *  Error callback for setShippingMethod mutation
   */ const onShippingMethodError = React__default.useCallback(()=>{
        onError && onError();
    }, [
        onError
    ]);
    /**
   *  Success callback for setShippingMethod mutation
   */ const onShippingMethodUpdated = React__default.useCallback(()=>{
        // To set last selected shipping method as proffered shipping method
        refetch();
    }, [
        refetch
    ]);
    const { setShippingMethod , setSelectedShippingMethod  } = useSetShippingMethod({
        onCompleted: onShippingMethodUpdated,
        onError: onShippingMethodError
    });
    /**
   * Shipping method selection handler
   * @augments method: string
   */ const handleChange = React__default.useCallback((method)=>{
        if (!shippingMethodList || shippingMethodList.length < 0) {
            throw new Error('No shipping methods available!');
        }
        const shippingMethod = shippingMethodList.find((item)=>item.key === method
        );
        if (!shippingMethod) {
            console.warn('Partially unsupported shipping method selected, attempting to select it');
        } else {
            setShippingMethod(shippingMethod === null || shippingMethod === void 0 ? void 0 : shippingMethod.id);
            /**
         *  Update redux after successful update
         *  cart shipping method
         */ setSelectedShippingMethod && setSelectedShippingMethod(method);
        }
    }, [
        shippingMethodList,
        setShippingMethod,
        setSelectedShippingMethod
    ]);
    return {
        handleOnShippingMethodSelected: handleChange
    };
};

const useShippingMethodsList = ()=>{
    const dispatch = useDispatch();
    const { cart  } = Context.useCart();
    const store = useStore();
    /**
   *  Error handler for shippingMethodForCart query operation
   */ const onShippingMethodsLoadError = React__default.useCallback((errorResponse)=>{
        dispatch(shippingMethodsFailed({
            message: 'Unable to load shipping methods'
        }));
        console.error(`query:[shippingMethodForCart]: unable to load shipping methods`, errorResponse);
    }, [
        dispatch
    ]);
    /**
   *  Success handler for shippingMethodForCart query operation
   */ const onShippingMethodsLoadCompleted = React__default.useCallback((shippingMethodList)=>{
        const selectedShippingMethod = getSelectedShippingMethod(store.getState());
        if (cart && (cart === null || cart === void 0 ? void 0 : cart.shippingMethod.key) !== (selectedShippingMethod === null || selectedShippingMethod === void 0 ? void 0 : selectedShippingMethod.method)) {
            if (cart === null || cart === void 0 ? void 0 : cart.shippingMethod.key) {
                dispatch(selectShippingMethod({
                    shippingMethod: {
                        method: cart === null || cart === void 0 ? void 0 : cart.shippingMethod.key,
                        isValid: true,
                        isTouched: false
                    }
                }));
            } else {
                // Cart has no shipping method information, try to use the actual default value
                // This happens when a feature toggle in cart-service (ADD_SHIPPING_METHOD_TO_CART) is disabled
                const defaultShippingMethod = shippingMethodList.find((method)=>method.isDefault
                );
                if (defaultShippingMethod) {
                    dispatch(selectShippingMethod({
                        shippingMethod: {
                            method: defaultShippingMethod.key,
                            isValid: true,
                            isTouched: false
                        }
                    }));
                }
            }
        }
        dispatch(shippingMethodsSuccess({
            result: shippingMethodList
        }));
    }, [
        cart,
        dispatch,
        store
    ]);
    const [loadShippingMethods, { called , data: shippingMethodList1  }] = useGetShippingMethods({
        onError: onShippingMethodsLoadError,
        onCompleted: onShippingMethodsLoadCompleted
    });
    /**
   *  Load shipping methods cart id updated
   */ React__default.useEffect(()=>{
        if ((cart === null || cart === void 0 ? void 0 : cart.id) && !called) {
            loadShippingMethods(cart === null || cart === void 0 ? void 0 : cart.id, cart === null || cart === void 0 ? void 0 : cart.prices.totalPrice);
        }
    }, [
        loadShippingMethods,
        called,
        cart
    ]);
    const reloadShippingMethods = React__default.useCallback(()=>{
        if ((cart === null || cart === void 0 ? void 0 : cart.id) && !called) {
            loadShippingMethods(cart === null || cart === void 0 ? void 0 : cart.id, cart === null || cart === void 0 ? void 0 : cart.prices.totalPrice);
        }
    }, [
        called,
        cart === null || cart === void 0 ? void 0 : cart.id,
        cart === null || cart === void 0 ? void 0 : cart.prices.totalPrice,
        loadShippingMethods
    ]);
    return {
        shippingMethodList: shippingMethodList1,
        reloadShippingMethods
    };
};

const getShippingMethods = createSelector(getCheckout, (checkout)=>checkout && !isUninitialized(checkout) && checkout.shippingMethods ? checkout.shippingMethods : undefined
);

const ShippingMethodsListContainer = ({ asides  })=>{
    const { getLabel , locale , currency  } = useIntl();
    const dispatch = useDispatch();
    const { shipping , shippingMethodsLogos  } = useCheckoutSettings();
    const labels = React.useMemo(()=>({
            errorTitle: getLabel('checkout.errors.general.title'),
            errorMessage: getLabel('checkout.errors.general.message'),
            free: getLabel('common.free'),
            required: getLabel('common.form.field.requiredError')
        })
    , [
        getLabel
    ]);
    const shippingMethodInfo = React.useCallback(({ price , logo , isFree  })=>/*#__PURE__*/ React.createElement(React.Fragment, null, logo, !isFree && !isNil(price) && /*#__PURE__*/ React.createElement(Price, {
            value: price,
            centAmount: true,
            currency: currency,
            className: "checkout-shipping-methods__price"
        }), isFree && /*#__PURE__*/ React.createElement(Text, {
            className: "checkout-shipping-methods__label"
        }, labels.free))
    , [
        currency,
        labels
    ]);
    const { shippingMethodList , reloadShippingMethods  } = useShippingMethodsList();
    const onError = React.useCallback(()=>{
        reloadShippingMethods();
    }, [
        reloadShippingMethods
    ]);
    const { handleOnShippingMethodSelected  } = useShippingMethodSelection({
        shippingMethodList,
        onError
    });
    const shippingMethods = useSelector(getShippingMethods);
    const selectedShippingMethod = useSelector(getSelectedShippingMethod);
    const { isLoading , hasError , items  } = mapShippingMethods({
        asides,
        logos: shippingMethodsLogos,
        locale,
        shippingMethods,
        shippingMethodInfo
    });
    // If settings require explicit shipping method selection, invalidate and deselect shipping method on load
    React.useEffect(()=>{
        if (!(selectedShippingMethod === null || selectedShippingMethod === void 0 ? void 0 : selectedShippingMethod.isTouched) && (selectedShippingMethod === null || selectedShippingMethod === void 0 ? void 0 : selectedShippingMethod.isValid) && (shipping === null || shipping === void 0 ? void 0 : shipping.explicitShippingMethod)) {
            dispatch(selectShippingMethod({
                shippingMethod: {
                    method: undefined,
                    isValid: false,
                    isTouched: false
                }
            }));
        }
    }, [
        dispatch,
        selectedShippingMethod === null || selectedShippingMethod === void 0 ? void 0 : selectedShippingMethod.isTouched,
        selectedShippingMethod === null || selectedShippingMethod === void 0 ? void 0 : selectedShippingMethod.isValid,
        shipping === null || shipping === void 0 ? void 0 : shipping.explicitShippingMethod, 
    ]);
    if (isLoading) {
        return /*#__PURE__*/ React.createElement(Loader, null);
    }
    if (hasError) {
        return /*#__PURE__*/ React.createElement(Alert, {
            type: "error",
            title: labels.errorTitle,
            message: labels.errorMessage
        });
    }
    const hasValidationError = !(selectedShippingMethod === null || selectedShippingMethod === void 0 ? void 0 : selectedShippingMethod.isValid) && (selectedShippingMethod === null || selectedShippingMethod === void 0 ? void 0 : selectedShippingMethod.isTouched);
    return /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(ShippingMethodsList, {
        handleChange: handleOnShippingMethodSelected,
        shippingMethodItems: items,
        selectedShippingMethod: (selectedShippingMethod === null || selectedShippingMethod === void 0 ? void 0 : selectedShippingMethod.method) ? selectedShippingMethod === null || selectedShippingMethod === void 0 ? void 0 : selectedShippingMethod.method : '',
        hasValidationError: hasValidationError
    }), hasValidationError && /*#__PURE__*/ React.createElement(Text, {
        className: "form-control__error"
    }, labels.required));
};

const PickupStoresContainer = ()=>{
    const { getLabel  } = useIntl();
    const [modalIsOpen, setModalIsOpen] = React.useState(false);
    const dispatch = useDispatch();
    const selectedStore = useSelector(getSelectedStore);
    React.useEffect(()=>{
        if (!selectedStore) {
            setModalIsOpen(true);
        }
    }, []);
    const onStoreSelect = (store)=>{
        if (!store) {
            return;
        }
        const serviceStore = {
            code: store.code,
            name: store.name,
            streetName: store.streetName,
            streetNumber: store.streetNumber,
            town: store.town
        };
        dispatch(selectStore({
            store
        }));
        dispatch(selectServiceStore({
            serviceStore
        }));
        setModalIsOpen(false);
    };
    const onPickupModalClose = ()=>{
        setModalIsOpen(false);
    };
    const onPickupModalShow = (event)=>{
        setModalIsOpen(true);
        event && event.preventDefault();
    };
    const labels = React.useMemo(()=>({
            storeFinderAction: getLabel('checkout.storeFinder.action'),
            noSelection: getLabel('checkout.store.selectStore.message'),
            noSelectionLink: getLabel('checkout.store.selectStore.link'),
            title: getLabel('checkout.store.title')
        })
    , [
        getLabel
    ]);
    if (modalIsOpen) {
        return /*#__PURE__*/ React.createElement(Modal, {
            className: "checkout-step--shipping__modal",
            showIcon: true,
            iconClassName: "checkout-step--shipping__modal__close",
            isOpen: modalIsOpen,
            onModalClose: onPickupModalClose
        }, /*#__PURE__*/ React.createElement(StoresFinderContainer, {
            onPickupStoreSelect: onStoreSelect
        }));
    }
    if (!selectedStore) {
        return /*#__PURE__*/ React.createElement(PickupWarningMessage, {
            labels: labels,
            onPickupModalShow: onPickupModalShow
        });
    }
    return /*#__PURE__*/ React.createElement(PickupLocationInformation, {
        title: labels.title,
        location: selectedStore,
        onPickupModalShow: onPickupModalShow
    });
};

const SelectedShippingMethodContainer = ()=>{
    var ref;
    const selectedShippingMethod = (ref = useSelector(getSelectedShippingMethod)) === null || ref === void 0 ? void 0 : ref.method;
    switch(selectedShippingMethod){
        case ShippingMethod.Pickup:
            return /*#__PURE__*/ React.createElement(PickupStoresContainer, null);
        case ShippingMethod.PickupPoint:
            return /*#__PURE__*/ React.createElement(PickupPointsContainer, null);
        default:
            return null;
    }
};

const ShippingMethods = ({ shippingMethodsAsides , title , hideTitleIcon =false  })=>{
    const { getLabel  } = useIntl();
    const labels = React.useMemo(()=>({
            shipmentMethodTitle: getLabel('checkout.shipment.method.title')
        })
    , [
        getLabel
    ]);
    return /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(TitleWithIcon, {
        icon: "orders",
        label: title || labels.shipmentMethodTitle,
        hideIcon: hideTitleIcon
    }), /*#__PURE__*/ React.createElement("div", {
        className: "checkout-shipping-methods"
    }, /*#__PURE__*/ React.createElement(ShippingMethodsListContainer, {
        asides: shippingMethodsAsides
    })), /*#__PURE__*/ React.createElement(SelectedShippingMethodContainer, null));
};

const ActionButtonContainer = ({ onClick , isLoading , isValid  })=>{
    const { getLabel  } = useIntl();
    const labels = React.useMemo(()=>({
            caption: getLabel('checkout.serviceStore.actionButton')
        })
    , [
        getLabel
    ]);
    return /*#__PURE__*/ React.createElement(Button, {
        isLoading: isLoading,
        onClick: onClick,
        caption: labels.caption,
        variant: "outline",
        className: "service-store__button",
        "data-t": "service-store-action-button",
        "aria-invalid": !isValid
    });
};

/**
 * In order to retrieve a store closest to a given address, we need to execute a few steps:
 * 1. Get a Google Maps Place ID from the query
 * 2. Get detailed information from this ID that includes latitudes and longitudes
 * 3. Get the nearest store from the API based on the latitudes and longitudes
 * 4. Return the store code
 */ const useNearestStore = (query, isEnabled)=>{
    const [loading, setLoading] = useState(false);
    const [getPlacePredictions, placePredictions] = usePlacePredictions({
        variables: {
            name: query
        },
        errorPolicy: 'all',
        fetchPolicy: 'no-cache'
    });
    const [getPlaceById, placeById] = Hooks$2.usePlaceById({
        id: ''
    });
    const [getStoresByDistance, storesByDistance] = Hooks$2.useStoresByDistance({
        searchGeoLocation: {
            lat: '',
            lon: ''
        }
    });
    const handleOnSearch = useCallback(()=>{
        if (query.length && isEnabled) {
            setLoading(true);
            getPlacePredictions({
                variables: {
                    name: query
                }
            });
        }
    }, [
        query,
        isEnabled,
        getPlacePredictions
    ]);
    useDebouncedEffect(()=>{
        handleOnSearch();
    }, 500, [
        query
    ]);
    useEffect(()=>{
        if (!placeById.data) {
            setLoading(false);
            return;
        }
        const { coordinates: { lat , lon  } ,  } = placeById.data;
        getStoresByDistance({
            variables: {
                // TODO: Check if need to filter based on ServicesNotAvailable enum?
                maxResults: 1,
                searchGeoLocation: {
                    lat,
                    lon
                }
            }
        });
    }, [
        placeById.data,
        getStoresByDistance
    ]);
    useEffect(()=>{
        const predictions = placePredictions.data;
        if (!predictions || !predictions.length) {
            setLoading(false);
            return;
        }
        getPlaceById({
            variables: {
                id: predictions[0].id
            }
        });
    }, [
        placePredictions.data,
        getPlaceById
    ]);
    const storeCode = useMemo(()=>{
        const stores = storesByDistance.data;
        setLoading(false);
        if (!stores || !stores.length) {
            return;
        }
        return stores[0].code;
    }, [
        storesByDistance.data
    ]);
    useEffect(()=>{
        const error = placePredictions.error || placeById.error || storesByDistance.error;
        if (error) {
            setLoading(false);
            console.error(error.message);
            toast.warning('checkout.errors.serviceStoreNotFound');
        }
    }, [
        placePredictions.error,
        placeById.error,
        storesByDistance.error
    ]);
    return [
        storeCode,
        loading
    ];
};

const { StoreFinderItem  } = Components;
var StoreFinderItemContainer = (_param)=>{
    var { onClick , variant , store  } = _param, rest = swcHelpers.objectWithoutProperties(_param, [
        "onClick",
        "variant",
        "store"
    ]);
    const { setHoveredStore  } = useStoreFinderContext();
    const { additionalStreetInfo , streetName , streetNumber , postalCode , town , province  } = store !== null && store !== void 0 ? store : {};
    const addressData = React.useMemo(()=>({
            additionalStreetInfo,
            streetName,
            streetNumber,
            postalCode,
            town,
            province
        })
    , [
        additionalStreetInfo,
        streetName,
        streetNumber,
        postalCode,
        town,
        province
    ]);
    const onClickHandler = React.useCallback(()=>{
        store && onClick(store);
    }, [
        store,
        onClick
    ]);
    const onMouseEnterHandler = React.useCallback(()=>{
        store && setHoveredStore(store);
    }, [
        setHoveredStore,
        store
    ]);
    const onMouseLeaveHandler = React.useCallback(()=>{
        setHoveredStore(null);
    }, [
        setHoveredStore
    ]);
    if (!store) {
        return null;
    }
    return /*#__PURE__*/ React.createElement(StoreFinderItem, swcHelpers.extends({}, rest, {
        addressData: addressData,
        addressSize: "MINIMAL",
        className: "service-store__list-item",
        onClick: onClickHandler,
        onMouseEnter: onMouseEnterHandler,
        onMouseLeave: onMouseLeaveHandler,
        title: store.shortName,
        variant: variant
    }));
};

const StoreSummary = ({ name , streetName , streetNumber , actions  })=>{
    const { getLabel  } = useIntl();
    return /*#__PURE__*/ React.createElement(Card, {
        "data-t": "service-store-summary"
    }, /*#__PURE__*/ React.createElement(Card.Content, null, (actions === null || actions === void 0 ? void 0 : actions.onEdit) && /*#__PURE__*/ React.createElement(Card.Actions, null, /*#__PURE__*/ React.createElement(Card.Button, {
        onClick: actions.onEdit,
        children: getLabel('common.actions.edit')
    })), /*#__PURE__*/ React.createElement(Card.Text, {
        variant: "body-head"
    }, name), /*#__PURE__*/ React.createElement(Card.Text, null, streetName, " ", streetNumber)));
};

const StoreSummaryContainer = ({ storeCode , actions , resetServiceStore  })=>{
    const dispatch = useDispatch();
    const [getStoreByCode, storeByCode] = Hooks$2.useStoreByCode();
    const serviceStore = useSelector(getServiceStore);
    React.useEffect(()=>{
        if (storeCode && (serviceStore === null || serviceStore === void 0 ? void 0 : serviceStore.code) !== storeCode) {
            getStoreByCode({
                variables: {
                    code: storeCode
                }
            });
        }
    }, [
        storeCode,
        getStoreByCode,
        serviceStore
    ]);
    React.useEffect(()=>{
        if (storeByCode.error) {
            dispatch(selectServiceStore({
                serviceStore: null
            }));
            resetServiceStore && resetServiceStore();
            return;
        }
        if (storeByCode.data && storeByCode.data.code !== (serviceStore === null || serviceStore === void 0 ? void 0 : serviceStore.code)) {
            const { code , name , streetName , streetNumber , town  } = storeByCode.data;
            const newServiceStore = {
                code,
                name,
                streetName,
                streetNumber,
                town
            };
            dispatch(selectServiceStore({
                serviceStore: newServiceStore
            }));
        }
    }, [
        dispatch,
        resetServiceStore,
        serviceStore === null || serviceStore === void 0 ? void 0 : serviceStore.code,
        storeByCode.data,
        storeByCode.error
    ]);
    if (!serviceStore) {
        return null;
    }
    return /*#__PURE__*/ React.createElement(StoreSummary, {
        name: serviceStore.name,
        streetName: serviceStore.streetName,
        streetNumber: serviceStore.streetNumber,
        actions: actions
    });
};

const loadModule = function() {
    var _ref = swcHelpers.asyncToGenerator(function*() {
        const storesModule = yield import(/* webpackChunkName: 'grandvisionhq-stores-v2' */ '@grandvisionhq/stores-v2');
        return storesModule;
    });
    return function loadModule() {
        return _ref.apply(this, arguments);
    };
}();
const usePickupStoresModule = ()=>useDynamicModule(loadModule, '@grandvisionhq/stores-v2', [])
;
const ServiceStoreContainer = ({ hideTitleIcon , hasTitleAsteriskSign =false , title , subtitle  })=>{
    var ref;
    const [showModal, setShowModal] = React.useState(false);
    const [serviceStoreCode, setServiceStoreCode] = React.useState();
    const { setStore  } = useSetStore();
    const { serviceStore: serviceStoreConfig = {}  } = useCheckoutSettings();
    const selectedShippingMethod = useSelector(getSelectedShippingMethod);
    const preferredServiceStoreCode = (ref = useSelector(ProfileSelectors.getFormData).preferredStore) === null || ref === void 0 ? void 0 : ref.code;
    const serviceStore = useSelector(getServiceStore);
    const validateServiceStore = useSelector(shouldValidateServiceStore);
    const address = useSelector(getBillingAddress);
    const details = useSelector(getShippingDetails);
    const isPickupStoreSelected = isPickupStore(selectedShippingMethod === null || selectedShippingMethod === void 0 ? void 0 : selectedShippingMethod.method);
    const serviceStoreIsInValid = validateServiceStore && !serviceStore;
    const nearestStoreQuery = React.useMemo(()=>{
        if (details === null || details === void 0 ? void 0 : details.billingAddress.isValid) {
            const postalCode = (address === null || address === void 0 ? void 0 : address.postalCode) || '';
            const streetName = (address === null || address === void 0 ? void 0 : address.streetName) || '';
            const streetNumber = (address === null || address === void 0 ? void 0 : address.streetNumber) || '';
            const city = (address === null || address === void 0 ? void 0 : address.city) || '';
            return `${postalCode} ${streetName} ${streetNumber} ${city}`.replace(/\s{2,}/g, ' ').trim();
        }
        return '';
    }, [
        address,
        details
    ]);
    // Only attempt a service store preselect when the feature is enabled and there isn't already code selected.
    const [code, isLoading] = useNearestStore(nearestStoreQuery, !!serviceStoreConfig.preselectFromShippingData && !serviceStore);
    React.useEffect(()=>{
        if (code && !serviceStoreCode) {
            setServiceStoreCode(code);
        }
    }, [
        serviceStoreCode,
        code,
        isPickupStoreSelected
    ]);
    const [module, loading, error] = usePickupStoresModule();
    const { features  } = useCheckoutSettings();
    const featuresToggles = useFeatureToggles();
    const { getLabel  } = useIntl();
    const labels = React.useMemo(()=>({
            title: getLabel('checkout.serviceStore.title'),
            subtitle: getLabel('checkout.serviceStore.subtitle'),
            errorMessage: getLabel('checkout.serviceStore.error')
        })
    , [
        getLabel
    ]);
    const onStoreSelect = React.useCallback((store)=>{
        setShowModal(false);
        setServiceStoreCode(store === null || store === void 0 ? void 0 : store.code);
    }, []);
    const onEdit = React.useCallback(()=>{
        setShowModal(true);
    }, []);
    const onCloseModal = React.useCallback(()=>{
        setShowModal(false);
    }, []);
    const resetServiceStore = React.useCallback(()=>{
        setServiceStoreCode(null);
    }, []);
    React.useEffect(()=>{
        if (serviceStore) {
            setServiceStoreCode(serviceStore.code);
            setStore(serviceStore.code);
            return;
        }
        if (preferredServiceStoreCode && isNotNull(serviceStore)) {
            setServiceStoreCode(parseInt(preferredServiceStoreCode));
            setStore(parseInt(preferredServiceStoreCode));
        }
    }, [
        preferredServiceStoreCode,
        serviceStore,
        setStore
    ]);
    if (!(features === null || features === void 0 ? void 0 : features.isServiceStoreEnabled) || isPickupStoreSelected) {
        return null;
    }
    if (loading) {
        return /*#__PURE__*/ React.createElement(Loader, null);
    }
    if (error || !module) {
        return /*#__PURE__*/ React.createElement(Alert, {
            type: "error",
            notifyScreenReader: false,
            message: labels.errorMessage
        });
    }
    const { Components , Containers , StoreFinderProvider  } = module;
    const { StoreFinder , PickUpButtons , withPickUpButtonsConfig  } = Containers;
    const { StoreListTopContent  } = Components;
    return /*#__PURE__*/ React.createElement("div", {
        className: "service-store"
    }, /*#__PURE__*/ React.createElement(TitleWithIcon, {
        icon: "store",
        label: title || labels.title,
        hideIcon: hideTitleIcon,
        hideAsteriskSign: !hasTitleAsteriskSign
    }), /*#__PURE__*/ React.createElement(Text, {
        component: "p",
        className: "checkout-step__subtitle"
    }, subtitle || labels.subtitle, !hasTitleAsteriskSign && /*#__PURE__*/ React.createElement("span", {
        className: "service-store__asterisk"
    }, "*")), serviceStoreIsInValid && /*#__PURE__*/ React.createElement(Alert, {
        icon: "info",
        type: "error",
        notifyScreenReader: false,
        message: labels.errorMessage
    }), serviceStoreCode ? /*#__PURE__*/ React.createElement(StoreSummaryContainer, {
        storeCode: serviceStoreCode,
        actions: {
            onEdit
        },
        resetServiceStore: resetServiceStore
    }) : /*#__PURE__*/ React.createElement(ActionButtonContainer, {
        onClick: onEdit,
        isLoading: isLoading,
        isValid: !serviceStoreIsInValid
    }), /*#__PURE__*/ React.createElement(Modal, {
        className: "service-store__modal",
        showIcon: true,
        iconClassName: "service-store__modal__close",
        isOpen: showModal,
        onModalClose: onCloseModal
    }, /*#__PURE__*/ React.createElement(StoreFinderProvider, {
        googleMapsId: "google-maps-service-store",
        hidePhone: !featuresToggles.isStorePickupPhoneEnabled,
        hideEmail: !featuresToggles.isStorePickupEmailEnabled
    }, /*#__PURE__*/ React.createElement(StoreFinder, {
        isInsideModal: true,
        listTopContent: /*#__PURE__*/ React.createElement(StoreListTopContent, {
            title: labels.title,
            description: labels.subtitle
        }),
        listItemComponent: (props)=>/*#__PURE__*/ React.createElement(StoreFinderItemContainer, swcHelpers.extends({}, props, {
                variant: "map-item",
                onClick: onStoreSelect
            }))
        ,
        buttonsComponent: withPickUpButtonsConfig(PickUpButtons, {
            onStoreSelect
        })
    }))));
};

const ServiceStore = /*#__PURE__*/ React.memo((props)=>/*#__PURE__*/ React.createElement(ServiceStoreContainer, swcHelpers.extends({}, props))
);

const ServiceStoreSummary = (props)=>/*#__PURE__*/ React.createElement(StoreSummaryContainer, swcHelpers.extends({}, props))
;

const ExpressCheckoutCartSlider = ({ title , cart , children  })=>{
    const [isOpen, setIsOpen] = React.useState(false);
    const scrollHeight = React.useRef(0);
    const { currency  } = useIntl();
    const cartPrice = cart ? cart.prices.totalPrice : 0;
    var ref;
    const itemCount = (ref = cart === null || cart === void 0 ? void 0 : cart.numberOfItems) !== null && ref !== void 0 ? ref : 0;
    const handleButtonClick = ()=>{
        if (isOpen) {
            const distance = scrollHeight.current;
            const scrollTo = distance > window.pageYOffset ? window.pageYOffset : distance;
            window.scrollTo(0, Math.floor(scrollTo));
        } else {
            scrollHeight.current = window.pageYOffset;
        }
        setIsOpen(!isOpen);
    };
    return /*#__PURE__*/ React.createElement(Card, {
        className: "express-checkout-cart-slider"
    }, /*#__PURE__*/ React.createElement(motion.div, {
        className: classnames('express-checkout-cart-slider', {
            'express-checkout-cart-slider--open': isOpen
        }),
        animate: isOpen ? 'open' : 'close',
        initial: "close",
        "data-t": "express-checkout-cart-slider"
    }, /*#__PURE__*/ React.createElement("button", {
        className: "express-checkout-cart-slider__button",
        onClick: handleButtonClick,
        name: title
    }, /*#__PURE__*/ React.createElement("span", {
        className: "express-checkout-cart-slider__shopping-bag"
    }, /*#__PURE__*/ React.createElement(Icon, {
        name: "shopping-bag"
    })), /*#__PURE__*/ React.createElement("span", {
        className: "express-checkout-cart-slider__cart-label"
    }, title, " (", itemCount, ")"), /*#__PURE__*/ React.createElement(motion.span, {
        className: "express-checkout-cart-slider__button-price"
    }, /*#__PURE__*/ React.createElement(Price, {
        value: cartPrice,
        currency: currency
    })), /*#__PURE__*/ React.createElement(motion.span, {
        variants: posedIcon,
        className: "express-checkout-cart-slider__icon",
        transition: {
            duration: itemCount
        }
    }, /*#__PURE__*/ React.createElement(Icon, {
        width: 16,
        height: 16,
        strokeWidth: 1,
        stroke: "#2b2e31",
        name: "chevron-down",
        className: classnames('express-checkout-cart-slider__chevron', {
            'express-checkout-cart-slider__chevron--rotated': isOpen
        })
    }))), /*#__PURE__*/ React.createElement(motion.div, {
        className: "express-checkout-cart-slider__content",
        variants: posedContent,
        transition: {
            duration: itemCount
        }
    }, /*#__PURE__*/ React.createElement("div", {
        className: "express-checkout-cart-slider__content-inner"
    }, children))));
};
const transition = {
    duration: 0.4,
    ease: [
        0.33,
        1,
        0.68,
        1
    ]
};
const posedContent = {
    close: {
        height: 0,
        display: 'none',
        transition
    },
    open: {
        height: 'auto',
        display: 'block',
        transition
    }
};
const posedIcon = {
    close: {
        rotate: 0,
        transition
    },
    open: {
        rotate: 180,
        transition
    }
};

const ExpressCheckoutCartSliderContainer = ({ children  })=>{
    const { getLabel  } = useIntl();
    const { cart  } = Context.useCart();
    return /*#__PURE__*/ React.createElement(ExpressCheckoutCartSlider, {
        cart: cart,
        title: getLabel('cart.title')
    }, children);
};

const ExpressCheckoutFormContainer = ()=>{
    const { expressCheckout  } = useFormSlot();
    if (!expressCheckout) {
        console.error('No ExpressCheckout FormSlot found');
        return null;
    }
    return /*#__PURE__*/ React__default.createElement("div", {
        className: "express-checkout-form-container"
    }, expressCheckout);
};

const ExpressCheckoutUI = ({ shippingMethodsAsides , isNearestPickup ,  })=>{
    const { getLabel  } = useIntl();
    const labels = React__default.useMemo(()=>({
            expressShipmentMethodTitle: getLabel('checkout.express.shipment.method.title'),
            expressServiceStoreTitle: getLabel('checkout.express.serviceStore.title'),
            expressServiceStoreSubtitle: getLabel('checkout.express.serviceStore.subtitle')
        })
    , [
        getLabel
    ]);
    return /*#__PURE__*/ React__default.createElement("div", {
        className: "express-checkout-ui"
    }, /*#__PURE__*/ React__default.createElement(ExpressCheckoutCartSliderContainer, null, /*#__PURE__*/ React__default.createElement(Cart, null)), /*#__PURE__*/ React__default.createElement(ShippingMethods, {
        shippingMethodsAsides: shippingMethodsAsides,
        hideTitleIcon: true,
        title: labels.expressShipmentMethodTitle
    }), isNearestPickup && /*#__PURE__*/ React__default.createElement(Alert, {
        icon: "info",
        message: getLabel('checkout.summary.shipment.nearestPickup.message')
    }), /*#__PURE__*/ React__default.createElement(ExpressCheckoutFormContainer, null), /*#__PURE__*/ React__default.createElement(ServiceStore, {
        title: labels.expressServiceStoreTitle,
        subtitle: labels.expressServiceStoreSubtitle,
        hideTitleIcon: true,
        hasTitleAsteriskSign: true
    }), /*#__PURE__*/ React__default.createElement(Consents, null), /*#__PURE__*/ React__default.createElement(ImplicitTermsAndConditionsContainer, null));
};

const Header = ({ backButton , title  })=>{
    const { getLabel  } = useIntl();
    return /*#__PURE__*/ React__default.createElement("header", {
        className: "express-checkout-header",
        "data-t": "express-checkout-header"
    }, /*#__PURE__*/ React__default.createElement(Link, {
        className: "express-checkout-header__button",
        url: backButton === null || backButton === void 0 ? void 0 : backButton.href,
        onClick: backButton === null || backButton === void 0 ? void 0 : backButton.onClick
    }, /*#__PURE__*/ React__default.createElement(Icon, {
        name: "chevron-left",
        className: "express-checkout-header__icon",
        width: 24,
        height: 24
    }), /*#__PURE__*/ React__default.createElement("span", {
        className: "express-checkout-header__button--label"
    }, getLabel('checkout.actions.previousStep'))), /*#__PURE__*/ React__default.createElement(Heading, {
        variant: "subheading2",
        align: "center",
        component: "h1",
        className: "express-checkout-header__heading"
    }, title));
};

const ExpressCheckoutContainer = ({ type =ExpressPaymentMethod.APPLE_PAY , backButton , shippingMethodsAsides , selfUrl ,  })=>{
    var ref3, ref1, ref2;
    const dispatch = useDispatch();
    const { routes  } = useCheckoutSettings();
    const checkoutState = useSelector(getCheckout);
    const { getTitle  } = useExpressCheckoutLabels();
    const { cart , error , called , loading  } = Context.useCart();
    const { routes: pageRoutes  } = useBloomreachPageRoutes();
    const [payCartWithApplePay] = useApplePay();
    const checkoutSettings = useCheckoutSettings();
    const selectedServiceStore = useSelector(getServiceStore);
    const isLoggedIn = useSelector(Selectors.isLoggedIn);
    const shouldCreateAccountBoolean = useSelector(shouldCreateAccount);
    const isExpressCheckoutValidBoolean = useSelector(isExpressCheckoutValid);
    const isNearestPickup = (cart === null || cart === void 0 ? void 0 : cart.shippingMethod.key) === ShippingMethod.NearestPickup;
    const { isApplePayActive  } = Hooks$1.useIsApplePayActive();
    const isCreateAccountRequired = Boolean(((ref3 = checkoutSettings.account) === null || ref3 === void 0 ? void 0 : ref3.implicitAccountCreation) || ((ref1 = checkoutSettings.account) === null || ref1 === void 0 ? void 0 : ref1.createAccountRequired));
    const isServiceStoreEnabled = (ref2 = checkoutSettings.features) === null || ref2 === void 0 ? void 0 : ref2.isServiceStoreEnabled;
    React__default.useEffect(()=>{
        if (!isInitialized({
            checkout: checkoutState
        })) {
            // Initialize checkout state
            dispatch(init({
                routes,
                selfUrl
            }));
            dispatch(initOrder());
        }
    }, [
        dispatch,
        checkoutState,
        routes,
        selfUrl
    ]);
    React__default.useEffect(()=>{
        // Shipping Method is not allowed to be prefilled and has to be overwritten with the default.
        // Otherwise the setShippingMethod is not triggered correctly.
        // TO DO: design a sturdy cart and MyAccount based prefill mechanism.
        dispatch(selectShippingMethod({
            shippingMethod: {
                method: ShippingMethod.Delivery,
                isValid: true,
                isTouched: true
            }
        }));
        dispatch(toggleAccountCreation({
            shouldCreateAccount: false
        }));
    }, [
        dispatch
    ]);
    const isStepValid = React__default.useCallback(()=>{
        return isExpressCheckoutValidBoolean && (!isServiceStoreEnabled || !!selectedServiceStore) && (isLoggedIn || !isCreateAccountRequired || shouldCreateAccountBoolean);
    }, [
        isExpressCheckoutValidBoolean,
        isServiceStoreEnabled,
        selectedServiceStore,
        isLoggedIn,
        isCreateAccountRequired,
        shouldCreateAccountBoolean, 
    ]);
    const redirectToCartPage = React__default.useCallback(()=>{
        window.location.assign(pageRoutes.cart || '/');
        return;
    }, [
        pageRoutes
    ]);
    const onCheckoutClick = React__default.useCallback(()=>{
        if (isStepValid()) {
            payCartWithApplePay === null || payCartWithApplePay === void 0 ? void 0 : payCartWithApplePay();
        } else {
            dispatch(markFieldsTouched());
            if (isCreateAccountRequired && !shouldCreateAccountBoolean) {
                dispatch(setMyAccountValidation());
            }
            if (isServiceStoreEnabled) {
                dispatch(setServiceStoreValidation());
            }
            toast.failed('checkout.errors.form.general');
            Util.focusToTopErrorField();
        }
    }, [
        dispatch,
        isCreateAccountRequired,
        isServiceStoreEnabled,
        isStepValid,
        payCartWithApplePay,
        shouldCreateAccountBoolean, 
    ]);
    React__default.useEffect(()=>{
        if (!isApplePayActive) {
            console.error(`ApplePay is not suported or not enabled`);
            redirectToCartPage();
        }
    }, [
        isApplePayActive,
        redirectToCartPage
    ]);
    React__default.useEffect(()=>{
        var ref;
        // - a valid cart with products is needed to enter the express-checkout
        if (!(cart === null || cart === void 0 ? void 0 : (ref = cart.lineItems) === null || ref === void 0 ? void 0 : ref.length) && !loading && called) {
            console.error(`Need a valid cart in localstorage or a cart with products.`);
            redirectToCartPage();
        }
    }, [
        cart,
        called,
        loading,
        redirectToCartPage
    ]);
    return /*#__PURE__*/ React__default.createElement("div", {
        className: "express-checkout-container"
    }, /*#__PURE__*/ React__default.createElement(Header, {
        title: getTitle(type),
        backButton: backButton
    }), /*#__PURE__*/ React__default.createElement("section", {
        className: "express-checkout-container__inner"
    }, /*#__PURE__*/ React__default.createElement("main", {
        className: "express-checkout-container__main"
    }, (loading || error) && /*#__PURE__*/ React__default.createElement("section", {
        className: "express-checkout-container__loader"
    }, /*#__PURE__*/ React__default.createElement(Loader, null)), cart && /*#__PURE__*/ React__default.createElement(ExpressCheckoutUI, {
        shippingMethodsAsides: shippingMethodsAsides,
        isNearestPickup: isNearestPickup
    })), /*#__PURE__*/ React__default.createElement("footer", {
        className: "express-checkout-container__footer"
    }, cart && type === 'APPLE_PAY' && /*#__PURE__*/ React__default.createElement(ApplePayCheckoutButton, {
        type: "express-checkout",
        onClick: onCheckoutClick
    }))));
};
const ExpressCheckoutContainerWithUserData = WithUserData(ExpressCheckoutContainer);
const ExpressCheckoutContainerWithMyAccount = (_param)=>{
    var props = swcHelpers.extends({}, _param);
    const { isMyAccountEnabled  } = useFeatureToggles();
    return /*#__PURE__*/ React__default.createElement(ExpressCheckoutContainerWithUserData, swcHelpers.extends({}, props, {
        isMyAccountEnabled: isMyAccountEnabled
    }));
};

const Navigation = ({ classNames , step , route , handleClick , index , isLoggedIn  })=>/*#__PURE__*/ React.createElement("button", {
        className: classNames,
        key: route.label.toLowerCase(),
        onClick: ()=>handleClick(step)
    }, /*#__PURE__*/ React.createElement(Icon, {
        name: "checkmark",
        className: "checkout-nav-step__icon"
    }), /*#__PURE__*/ React.createElement("span", {
        className: "checkout-nav-step__number"
    }, index + 1), /*#__PURE__*/ React.createElement("span", {
        className: "checkout-nav-step__name"
    }, route.loggedInLabel && isLoggedIn ? route.loggedInLabel : route.label))
;

const NavigationContainer = ({ currentStep , disabledSteps , isLoggedIn , onNavigate  })=>{
    const checkoutSettings = useCheckoutSettings();
    var _routes;
    const routes = (_routes = checkoutSettings.routes) !== null && _routes !== void 0 ? _routes : {};
    const handleClick = React.useCallback((route)=>{
        onNavigate && onNavigate(route);
    }, [
        onNavigate
    ]);
    const navigationRoutes = Object.entries(routes).filter(([key])=>key !== 'callback' && key !== 'completed'
    );
    return /*#__PURE__*/ React.createElement("nav", {
        className: "checkout-nav"
    }, navigationRoutes.map(([step, route], index)=>{
        const currentStepIndex = Object.keys(routes).indexOf(currentStep);
        const isDisabled = index > currentStepIndex || disabledSteps && disabledSteps.includes(step);
        const classNames = classnames('checkout-nav-step', {
            'checkout-nav-step--active': step === currentStep,
            'checkout-nav-step--disabled': isDisabled,
            'checkout-nav-step--completed': index < currentStepIndex && !isDisabled
        });
        return /*#__PURE__*/ React.createElement(Navigation, {
            classNames: classNames,
            handleClick: handleClick,
            index: index,
            isLoggedIn: isLoggedIn,
            key: step,
            step: step,
            route: route
        });
    }));
};

const OrderCallToAction$1 = ({ labels , isSticky , routes  })=>{
    const Buttons = /*#__PURE__*/ React.createElement("div", {
        className: "order-call-to-action"
    }, routes.visitMyAccount && /*#__PURE__*/ React.createElement(Button, {
        className: "order-call-to-action__button",
        variant: "outline",
        caption: labels.visitMyAccount,
        "aria-label": labels.visitMyAccount,
        href: routes.visitMyAccount
    }), /*#__PURE__*/ React.createElement(Button, {
        className: "order-call-to-action__button",
        caption: labels.continueShopping,
        "aria-label": labels.continueShopping,
        href: routes.continueShopping
    }));
    if (isSticky) {
        return /*#__PURE__*/ React.createElement(StickyCallToAction, {
            button: Buttons
        });
    }
    return Buttons;
};

const OrderCallToActionContainer = ()=>{
    const { getLabel  } = useIntl();
    const myAccountRoutes = useSelector(Selectors.getFormattedRoutes);
    const { routes: bloomreachRoutes  } = useBloomreachPageRoutes();
    const { isMyAccountEnabled  } = useFeatureToggles();
    const labels = React.useMemo(()=>({
            continueShopping: getLabel('cart.actions.goBack'),
            visitMyAccount: getLabel('account.menu.myAccount')
        })
    , [
        getLabel
    ]);
    const shouldRenderStickyCallToAction = MediaQuery.useIsBelow(MediaQuery.BreakpointName.TABLET_LANDSCAPE);
    const routes = React.useMemo(()=>{
        return {
            continueShopping: bloomreachRoutes.root,
            visitMyAccount: isMyAccountEnabled ? myAccountRoutes === null || myAccountRoutes === void 0 ? void 0 : myAccountRoutes.orders : undefined
        };
    }, [
        bloomreachRoutes.root,
        isMyAccountEnabled,
        myAccountRoutes === null || myAccountRoutes === void 0 ? void 0 : myAccountRoutes.orders
    ]);
    return /*#__PURE__*/ React.createElement(OrderCallToAction$1, {
        labels: labels,
        isSticky: shouldRenderStickyCallToAction,
        routes: routes
    });
};

const OrderCallToAction = ()=>/*#__PURE__*/ React.createElement(OrderCallToActionContainer, null)
;

const PaymentInfo = ({ selectedPaymentMethod , selectedPaymentDetails , totalPrice , summary  })=>{
    const { currency , getLabel  } = useIntl();
    const paymentMethodLabelsMap = usePaymentMethodLabelsMap();
    return /*#__PURE__*/ React.createElement(Card, null, /*#__PURE__*/ React.createElement(Card.Content, null, /*#__PURE__*/ React.createElement("div", {
        className: "checkout-payment-info"
    }, /*#__PURE__*/ React.createElement(Card.Text, {
        color: "text-secondary",
        className: "checkout-payment-info__value"
    }, getLabel('checkout.payment.method.title')), /*#__PURE__*/ React.createElement(Card.Text, {
        className: "checkout-payment-info__value"
    }, paymentMethodLabelsMap[selectedPaymentMethod.type]), /*#__PURE__*/ React.createElement(Card.Text, {
        color: "text-secondary",
        className: "checkout-payment-info__value"
    }, getLabel('checkout.completed.paymentDetails.totalValue')), /*#__PURE__*/ React.createElement(Card.Text, {
        className: "checkout-payment-info__value"
    }, totalPrice && totalPrice.centAmount && /*#__PURE__*/ React.createElement(Price, {
        value: totalPrice.centAmount,
        currency: currency
    })), summary && selectedPaymentDetails && /*#__PURE__*/ React.createElement(summary, {
        details: selectedPaymentDetails.data,
        info: selectedPaymentDetails.info,
        result: selectedPaymentDetails.result
    }))));
};

const CheckoutCart = ({ isFinishedCheckout , order , paymentFlow , pageRouteRoot , orderData ,  })=>{
    var ref1;
    const { cart  } = Context.useCart();
    const isSmallScreen = MediaQuery.useIsBelow(MediaQuery.BreakpointName.TABLET_LANDSCAPE);
    // In order to enter the checkout we need at least
    // - a valid cart in --localStorage-- apollo client
    // - a cart that contains products
    // - not be in a finished checkout
    React.useEffect(()=>{
        var ref;
        if (cart && !((ref = cart.lineItems) === null || ref === void 0 ? void 0 : ref.length) && !isFinishedCheckout && paymentFlow !== PaymentFlow.QR_CODE) {
            console.error(`Cart went empty during checkout, returning to homepage`);
            window.location.assign(pageRouteRoot);
        }
    }, [
        cart,
        cart === null || cart === void 0 ? void 0 : (ref1 = cart.lineItems) === null || ref1 === void 0 ? void 0 : ref1.length,
        isFinishedCheckout,
        pageRouteRoot,
        paymentFlow
    ]);
    if (!order && !orderData && isFinishedCheckout) return null;
    const Wrapper = isSmallScreen ? CartSlider : React.Fragment;
    return /*#__PURE__*/ React.createElement(Wrapper, null, /*#__PURE__*/ React.createElement(Cart, null));
};

function withCartManager(Component) {
    const wrappedName = Component.displayName || Component.name || 'Component';
    const WithCartManager = (props)=>{
        const { routes  } = useCheckoutSettings();
        const [{ cartId  }] = Hooks.useCartStorage();
        const { cart , called , loading , error  } = Context.useCart();
        const { fetchByCartId  } = Hooks.useGetCart();
        // This is needed temporarily until we can use graphql to replicate the cart
        // After this can and should be deleted.
        useCartChangeListener((e)=>{
            var ref;
            if (e === null || e === void 0 ? void 0 : (ref = e.detail) === null || ref === void 0 ? void 0 : ref.cartId) {
                var ref1;
                fetchByCartId(e === null || e === void 0 ? void 0 : (ref1 = e.detail) === null || ref1 === void 0 ? void 0 : ref1.cartId);
            }
        });
        // When a client gets redirect back into the application a scenaria can occure where there is no cart information and only a completed order
        // If this happens we just want to render the callback component or complete page and ignore all cart logic from this HoC.
        if (props.initialRoute === routes.callback.path || props.initialRoute === routes.completed.path) {
            return /*#__PURE__*/ React.createElement(Component, swcHelpers.extends({}, props));
        }
        // After the first query the `called` flag will remain true.
        // Keeping the loading state below this return means the UI stays intact and only updates on new data
        if (called && cart) {
            return /*#__PURE__*/ React.createElement(Component, swcHelpers.extends({}, props));
        }
        if (loading) {
            return /*#__PURE__*/ React.createElement(LoaderScreen, null);
        }
        if (!cartId || error) {
            // Explictly make use of window.location.assign as this forces a new HTTP request
            // This is needed when a customer has only loaded the checkout (entered via external url) so it still has to load other pages
            window.location.assign(props.pageRoutes ? props.pageRoutes.root : '/');
        }
        return null;
    };
    WithCartManager.displayName = `WithCartManager(${wrappedName})`;
    return WithCartManager;
}

const AdyenCallbackContainer = ({ query  })=>{
    const dispatch = useDispatch();
    const parseCallback = React.useCallback(()=>{
        dispatch(parseAdyenCallback({
            query
        }));
    }, [
        dispatch,
        query
    ]);
    React.useEffect(()=>{
        parseCallback();
    // Run parseCallback only a single time
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return /*#__PURE__*/ React.createElement("div", {
        className: "checkout-section checkout-section--main"
    }, /*#__PURE__*/ React.createElement(Loader, null));
};

const CallbackContainer = ()=>{
    const dispatch = useDispatch();
    const query = React.useMemo(()=>QueryString.parse(window.location.search.substring(1))
    , []);
    const invalidateQuery = React.useCallback(()=>{
        dispatch(parseCallbackFailed({
            message: 'No matching callback found while parsing query string'
        }));
    }, [
        dispatch
    ]);
    if (isRedirectAdyenQuery(query)) {
        return /*#__PURE__*/ React.createElement(AdyenCallbackContainer, {
            query: query
        });
    }
    // Only fail callback after query is parsed.
    if (typeof query !== null) {
        invalidateQuery();
    }
    return null;
};

const StepFallback = ()=>/*#__PURE__*/ React.createElement("div", {
        className: "checkout-section__fallback"
    }, /*#__PURE__*/ React.createElement(Loader, {
        className: "checkout-section__fallback-loader"
    }))
;
const StepCompleted = /*#__PURE__*/ React.lazy(()=>import('./index-b826995d.js')
);
const StepLogin = /*#__PURE__*/ React.lazy(()=>import('./index-b604b963.js')
);
const StepOverview = /*#__PURE__*/ React.lazy(()=>import('./index-950a31d0.js')
);
const StepPayment = /*#__PURE__*/ React.lazy(()=>import('./index-edc52c7b.js')
);
const StepShipping = /*#__PURE__*/ React.lazy(()=>import('./index-336271e6.js')
);
const StepComponent = ({ currentStep , shippingMethodsAsides , selfUrl , isShippingStepValid , isLoggedIn  })=>{
    var ref1;
    const { getLabel  } = useIntl();
    const { routes  } = useCheckoutSettings();
    const history$1 = history();
    const goToLoginStep = React.useCallback(()=>{
        var ref;
        return history$1.push({
            pathname: (ref = routes.login) === null || ref === void 0 ? void 0 : ref.path
        });
    }, [
        history$1,
        (ref1 = routes.login) === null || ref1 === void 0 ? void 0 : ref1.path, 
    ]);
    const goToShippingStep = React.useCallback(()=>history$1.push({
            pathname: routes.shipping.path
        })
    , [
        history$1,
        routes.shipping.path
    ]);
    const goToOverviewStep = React.useCallback(()=>history$1.push({
            pathname: routes.overview.path
        })
    , [
        history$1,
        routes.overview.path
    ]);
    const goToPaymentStep = React.useCallback(()=>history$1.push({
            pathname: routes.payment.path
        })
    , [
        history$1,
        routes.payment.path, 
    ]);
    React.useEffect(()=>{
        // Directly go to shipping step if user is logged in on first checkout page load.
        if (isLoggedIn) goToShippingStep();
    }, [
        goToShippingStep,
        isLoggedIn
    ]);
    if ((currentStep === StepNames.Overview || currentStep === StepNames.Payment) && !isShippingStepValid) {
        goToShippingStep();
        return null;
    }
    switch(currentStep){
        case StepNames.Login:
            return /*#__PURE__*/ React.createElement(React.Suspense, {
                fallback: /*#__PURE__*/ React.createElement(StepFallback, null)
            }, /*#__PURE__*/ React.createElement(StepLogin, {
                onContinueClick: goToShippingStep,
                continueNoteLabel: getLabel('checkout.actions.continueGuestNote'),
                continueButtonLabel: getLabel('checkout.actions.continueCheckout')
            }));
        case StepNames.Shipping:
            return /*#__PURE__*/ React.createElement(React.Suspense, {
                fallback: /*#__PURE__*/ React.createElement(StepFallback, null)
            }, /*#__PURE__*/ React.createElement(StepShipping, {
                onNextStep: goToOverviewStep,
                onPrevStep: routes.login && goToLoginStep,
                shippingMethodsAsides: shippingMethodsAsides
            }));
        case StepNames.Overview:
            return /*#__PURE__*/ React.createElement(React.Suspense, {
                fallback: /*#__PURE__*/ React.createElement(StepFallback, null)
            }, /*#__PURE__*/ React.createElement(StepOverview, {
                shippingMethodsAsides: shippingMethodsAsides,
                onPrevStep: goToShippingStep,
                onNextStep: goToPaymentStep
            }));
        case StepNames.Payment:
            return /*#__PURE__*/ React.createElement(React.Suspense, {
                fallback: /*#__PURE__*/ React.createElement(StepFallback, null)
            }, /*#__PURE__*/ React.createElement(StepPayment, {
                selfUrl: selfUrl,
                onPrevStep: goToOverviewStep
            }));
        case StepNames.Completed:
            return /*#__PURE__*/ React.createElement(React.Suspense, {
                fallback: /*#__PURE__*/ React.createElement(StepFallback, null)
            }, /*#__PURE__*/ React.createElement(StepCompleted, {
                shippingMethodsAsides: shippingMethodsAsides
            }));
        default:
            routes.login ? goToLoginStep() : goToShippingStep();
            return null;
    }
};

const CheckoutUI = ({ currentStep , shippingMethodsAsides , logo , pageRouteRoot , isLoggedIn , onNavigationClick , isFailedCheckout , isFinishedCheckout , isShippingStepValid , isUninitialized , selfUrl , children  })=>{
    const { getLabel  } = useIntl();
    const headerRef = React.useRef(null);
    const currentBreakpoint = MediaQuery.useBreakpoint();
    const isMobile = currentBreakpoint === MediaQuery.BreakpointName.TABLET_PORTRAIT || currentBreakpoint === MediaQuery.BreakpointName.PHONE;
    React.useEffect(()=>{
        headerRef.current && headerRef.current.scrollIntoView();
    }, []);
    if (isUninitialized) {
        return /*#__PURE__*/ React.createElement("div", {
            className: "checkout-section checkout-section--main"
        }, /*#__PURE__*/ React.createElement(Loader, null));
    }
    if (currentStep === StepNames.Callback) {
        return /*#__PURE__*/ React.createElement(CallbackContainer, null);
    }
    return /*#__PURE__*/ React.createElement(SplitPane, {
        main: /*#__PURE__*/ React.createElement("div", {
            className: "checkout-section checkout-section--main"
        }, /*#__PURE__*/ React.createElement("div", {
            className: "checkout-section__header",
            ref: headerRef
        }, /*#__PURE__*/ React.createElement(Logo, {
            url: pageRouteRoot,
            image: logo
        }), !isFinishedCheckout && /*#__PURE__*/ React.createElement(NavigationContainer, {
            currentStep: currentStep,
            isLoggedIn: isLoggedIn,
            onNavigate: onNavigationClick
        })), isMobile && /*#__PURE__*/ React.createElement("div", {
            className: "checkout-section__cart"
        }, children), /*#__PURE__*/ React.createElement("div", {
            className: "checkout-section__body"
        }, isFailedCheckout && /*#__PURE__*/ React.createElement(Alert, {
            className: "checkout-section__alert",
            type: "error",
            title: getLabel('checkout.errors.general.title'),
            message: getLabel('checkout.errors.general.message')
        }), /*#__PURE__*/ React.createElement(StepComponent, {
            isLoggedIn: isLoggedIn,
            isShippingStepValid: isShippingStepValid,
            currentStep: currentStep,
            shippingMethodsAsides: shippingMethodsAsides,
            selfUrl: selfUrl
        }))),
        aside: /*#__PURE__*/ React.createElement("div", {
            className: "checkout-section checkout-section--aside"
        }, !isMobile && /*#__PURE__*/ React.createElement("div", {
            className: "checkout-section__cart"
        }, children), /*#__PURE__*/ React.createElement("div", {
            className: "checkout-section__support-footer"
        }, /*#__PURE__*/ React.createElement(SupportFooter, {
            message: getLabel('support.title'),
            phoneNumber: getLabel('support.phoneNumber', {
                hideLabelKey: true
            }) || undefined,
            email: getLabel('support.emailAddress', {
                hideLabelKey: true
            }) || undefined
        })))
    });
};

var CheckoutSteps;
(function(CheckoutSteps) {
    CheckoutSteps["Login"] = 'login';
    CheckoutSteps["Shipping"] = 'shipping';
    CheckoutSteps["Overview"] = 'overview';
    CheckoutSteps["Payment"] = 'payment';
})(CheckoutSteps || (CheckoutSteps = {}));
const getCheckoutStep = (currentStep)=>{
    switch(currentStep){
        case CheckoutSteps.Login:
            return 1;
        case CheckoutSteps.Shipping:
            return 2;
        case CheckoutSteps.Overview:
            return 3;
        case CheckoutSteps.Payment:
            return 4;
        default:
            return undefined;
    }
};
const pushCheckoutEventToDataLayer = (cart, currentStep, currency)=>{
    DataLayer.pushEvent({
        event: 'gvCheckout',
        atfEcommerce: {
            ecommerce: {
                currencyCode: currency,
                cart: {
                    id: cart.id
                },
                checkout: {
                    actionField: {
                        step: getCheckoutStep(currentStep)
                    },
                    products: cart.lineItems.map((lineItem)=>Mappers.mapClientModelToProductObject(lineItem)
                    )
                }
            }
        }
    });
};
const pushPurchaseEventToDataLayer = (order, currency, cartId)=>{
    var ref1;
    const { lineItems , prescriptionGlassesLineItems =[] , orderNumber , totalPrice , shippingInfo , taxedPrice ,  } = order;
    const originalTotal = [
        ...lineItems,
        ...prescriptionGlassesLineItems
    ].reduce((total, currentValue)=>total += currentValue.price.value.centAmount * currentValue.quantity
    , 0);
    const shippingCost = shippingInfo && shippingInfo.price ? shippingInfo.price.centAmount : 0;
    const discountTotal = originalTotal - totalPrice.centAmount + shippingCost;
    const taxAmount = (ref1 = taxedPrice === null || taxedPrice === void 0 ? void 0 : taxedPrice.taxPortions.find((taxPortion)=>taxPortion.amount.centAmount
    )) === null || ref1 === void 0 ? void 0 : ref1.amount.centAmount;
    const discountCodes = order.discountCodes.map((code)=>{
        var ref;
        return (ref = code.discountCode.obj) === null || ref === void 0 ? void 0 : ref.code;
    }).join();
    DataLayer.pushEcommerceEvent({
        event: 'gvPurchase',
        atfEcommerce: {
            ecommerce: {
                currencyCode: currency,
                cart: {
                    id: cartId !== null && cartId !== void 0 ? cartId : ''
                },
                purchase: {
                    actionField: swcHelpers.objectSpread({
                        id: orderNumber,
                        revenue: calcPrice(totalPrice.centAmount),
                        tax: taxAmount && calcPrice(taxAmount),
                        shipping: calcPrice(shippingCost),
                        revenue_includes_tax: 'true',
                        original_revenue: calcPrice(originalTotal),
                        discount_revenue: calcPrice(discountTotal)
                    }, optionalKey('coupon', discountCodes)),
                    products: DataLayer.DataLayerUtils.mapLineItemToDataLayerProductObjects(lineItems, prescriptionGlassesLineItems)
                }
            }
        }
    });
};

const PostForm = ({ onSubmit , postFields , postUrl  })=>{
    const formRef = React.useRef(null);
    const [isFormSubmitted, setIsFormSubmitted] = React.useState(false);
    React.useEffect(()=>{
        if (formRef.current && !isFormSubmitted) {
            formRef.current.submit();
        }
    }, [
        formRef,
        isFormSubmitted
    ]);
    const onHandleSubmit = React.useCallback(()=>{
        onSubmit && onSubmit();
        setIsFormSubmitted(true);
    }, [
        onSubmit
    ]);
    return /*#__PURE__*/ React.createElement("form", {
        title: "postForm",
        method: "POST",
        action: postUrl,
        onSubmit: onHandleSubmit,
        ref: formRef
    }, Object.entries(postFields).map((postField)=>/*#__PURE__*/ React.createElement("input", {
            key: postField[0],
            type: "hidden",
            name: postField[0],
            value: postField[1]
        })
    ));
};

class CheckoutRoot extends React.Component {
    componentDidMount() {
        var ref;
        const { checkoutSettings , checkoutState , selfUrl , order  } = this.props;
        const { currentStep  } = this.state;
        const { routes  } = checkoutSettings;
        const cart = (ref = this.context) === null || ref === void 0 ? void 0 : ref.cart;
        if (!this.props.isPaymentCallbackApiRouteEnabled && currentStep === StepNames.Payment && cart && order && order.order.id) {
            this.props.restoreCart({
                orderId: order.order.id
            });
        }
        if (isUninitialized(checkoutState)) {
            this.props.init({
                routes,
                selfUrl
            });
            (cart === null || cart === void 0 ? void 0 : cart.id) && pushCheckoutEventToDataLayer(cart, currentStep, this.props.intl.currency);
            DataLayer.pushPageTypeToDataLayer(`checkout ${currentStep}`);
        }
    }
    render() {
        const { checkoutState , pageRoutes , isShippingStepValid: isShippingStepValid1 , postPaymentToPsp , isLoggedIn ,  } = this.props;
        const { currentStep  } = this.state;
        if (currentStep === StepNames.Payment && postPaymentToPsp) {
            return /*#__PURE__*/ React.createElement(PostForm, {
                postUrl: postPaymentToPsp.postUrl,
                postFields: postPaymentToPsp.postFields
            });
        }
        return /*#__PURE__*/ React.createElement(CheckoutUI, {
            currentStep: currentStep,
            pageRouteRoot: pageRoutes ? pageRoutes.root : '/',
            isLoggedIn: isLoggedIn || false,
            isFinishedCheckout: isFinishedCheckout(currentStep),
            isFailedCheckout: isFailed$1(checkoutState),
            isUninitialized: isUninitialized(checkoutState),
            isShippingStepValid: isShippingStepValid1,
            selfUrl: this.props.selfUrl,
            logo: this.props.logo,
            shippingMethodsAsides: this.props.shippingMethodsAsides,
            onNavigationClick: this.onNavigationClick
        }, /*#__PURE__*/ React.createElement(CheckoutCart, {
            pageRouteRoot: pageRoutes ? pageRoutes.root : '/',
            isFinishedCheckout: isFinishedCheckout(currentStep),
            paymentFlow: this.props.paymentFlow,
            order: this.props.order
        }));
    }
    componentWillUnmount() {
        this.unregisterHistory();
    }
    constructor(props){
        super(props);
        this.onNavigationClick = (path)=>{
            var ref;
            const { routes  } = this.props.checkoutSettings;
            const routePath = (ref = routes[path]) === null || ref === void 0 ? void 0 : ref.path;
            if (routePath) {
                this.history.push(routePath);
            }
        };
        this.onNavigate = (location)=>{
            const newRoute = location.pathname;
            if (!newRoute || !this.reverseRouteLookup) {
                return;
            }
            if (newRoute in this.reverseRouteLookup) {
                var ref, ref1, ref2, ref3;
                const currentStep = this.reverseRouteLookup[newRoute];
                this.setState({
                    currentStep
                });
                const { checkoutState , selfUrl , order , checkoutSettings  } = this.props;
                const { routes  } = checkoutSettings;
                // If the user has navigated between steps in failed state,
                // re-init the checkout and hide the error message
                if (isFailed$1(checkoutState) && currentStep !== StepNames.Payment) {
                    this.props.init({
                        routes,
                        selfUrl
                    });
                }
                const cart = (ref = this.context) === null || ref === void 0 ? void 0 : ref.cart;
                const cartId = cart === null || cart === void 0 ? void 0 : cart.id;
                if (currentStep === StepNames.Shipping && order !== null) {
                    this.props.initOrder();
                }
                if (currentStep === StepNames.Completed && isCompleted$1(checkoutState) && ((ref3 = order === null || order === void 0 ? void 0 : (ref1 = order.order) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.paymentInfo) === null || ref2 === void 0 ? void 0 : ref2.payments[0]) === null || ref3 === void 0 ? void 0 : ref3.obj)) {
                    pushPurchaseEventToDataLayer(order.order, this.props.intl.currency, cartId);
                } else {
                    cartId && pushCheckoutEventToDataLayer(cart, currentStep, this.props.intl.currency);
                    DataLayer.pushPageTypeToDataLayer(`checkout ${currentStep}`);
                }
                // Notify checkout parent that the route/step has changed
                this.props.onStepChange && this.props.onStepChange(newRoute);
            }
        };
        this.history = history();
        this.reverseRouteLookup = createReverseRouteLookup(this.props.checkoutSettings.routes);
        this.unregisterHistory = this.history.listen(this.onNavigate);
        this.state = {
            currentStep: this.reverseRouteLookup[this.props.initialRoute]
        };
    }
}
const mapStateToProps = (state)=>({
        order: getOrder(state),
        postPaymentToPsp: getPostPaymentToPsp(state),
        checkoutState: getCheckout(state),
        isShippingStepValid: isShippingStepValid(state),
        isLoggedIn: Selectors.isLoggedIn(state),
        paymentFlow: getPaymentFlow(state)
    })
;
const mapDispatchToProps = {
    init: init,
    initOrder: initOrder,
    myAccountInit: Actions.init,
    restoreCart: restoreCart
};
const CheckoutRootFunctional = (props)=>{
    const { isPaymentCallbackApiRouteEnabled  } = useFeatureToggles();
    return /*#__PURE__*/ React.createElement(CheckoutRoot, swcHelpers.extends({
        isPaymentCallbackApiRouteEnabled: isPaymentCallbackApiRouteEnabled
    }, props));
};
CheckoutRoot.contextType = Context.CartContext;
var CheckoutRoot$1 = withCheckoutSettings(withCartManager(connect(mapStateToProps, mapDispatchToProps)(withIntl(CheckoutRootFunctional))));

const useGetOrderData = (orderData)=>{
    const [isLoading, setIsLoading] = useState(true);
    const [error1, setError] = useState();
    const [orderResponse1, setOrderResponse] = useState();
    const routes = useApiConfig();
    const dispatch = useDispatch();
    const { refetch  } = Hooks.useGetCart();
    useEffect(()=>{
        orderData && handleGetOrderData();
        refetch();
    }, []);
    const handleGetOrderData = useCallback(swcHelpers.asyncToGenerator(function*() {
        if (!orderData) {
            console.error('No order data found');
            window.location.assign('/');
            return;
        }
        try {
            const orderResponse = yield Orders.getOrderByToken(routes.ordersUrl, {
                orderData
            });
            if (orderResponse.id) {
                setIsLoading(false);
                setOrderResponse(orderResponse);
                dispatch(getOrderByTokenSucces({
                    order: orderResponse
                }));
                removeCartFromLocalStorage();
            } else {
                dispatch(getOrderByTokenFailed(orderResponse));
            }
        } catch (error) {
            console.error(error);
            if (error instanceof ResponseError && error.statusCode === 404) {
                setError(errorsMapping.ORDER_NOT_FOUND);
            } else {
                setError(errorsMapping.SOMETHING_WENT_WRONG);
            }
            dispatch(getOrderByTokenFailed(error));
        }
    }), [
        orderData,
        routes.ordersUrl,
        dispatch
    ]);
    return [
        orderResponse1,
        isLoading,
        error1
    ];
};

const productMessageKeys = [
    'cartContainsContactLenses',
    'cartContainsPrescriptionGlasses',
    'cartContainsSolutions',
    'cartContainsSunglasses',
    'cartContainsSubscription', 
];
var OrderConfirm = (_param)=>{
    var { summaries , selectedPaymentDetails , selectedStore , serviceStore , selectedPickupPoint , invoice , order , callbackResultCode , shippingMethodsAsides , labels  } = _param, rest = swcHelpers.objectWithoutProperties(_param, [
        "summaries",
        "selectedPaymentDetails",
        "selectedStore",
        "serviceStore",
        "selectedPickupPoint",
        "invoice",
        "order",
        "callbackResultCode",
        "shippingMethodsAsides",
        "labels"
    ]);
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8;
    const { company: CompanySummary , billingAddress: BillingAddressSummary , deliveryAddress: DeliveryAddressSummary , contactDetails: ContactDetailsSummary , invoice: InvoiceSummary ,  } = summaries;
    const paymentProvider = ((ref1 = order === null || order === void 0 ? void 0 : (ref = order.paymentInfo) === null || ref === void 0 ? void 0 : ref.payments[0]) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.obj) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.paymentMethodInfo) === null || ref3 === void 0 ? void 0 : ref3.paymentInterface) || undefined;
    const paymentType = ((ref5 = order === null || order === void 0 ? void 0 : (ref4 = order.paymentInfo) === null || ref4 === void 0 ? void 0 : ref4.payments[0]) === null || ref5 === void 0 ? void 0 : (ref6 = ref5.obj) === null || ref6 === void 0 ? void 0 : ref6.paymentMethodInfo.method) || undefined;
    const selectedPaymentMethod = {
        provider: getGraphQLPaymentProviderName(paymentProvider),
        type: getGraphQLPaymentMethodName(paymentType)
    };
    const { features  } = useCheckoutSettings();
    const paymentImplementation = selectedPaymentMethod && getPaymentImplementation(selectedPaymentMethod.provider, selectedPaymentMethod.type);
    const paymentInfo = {
        selectedPaymentDetails,
        selectedPaymentMethod,
        totalPrice: order === null || order === void 0 ? void 0 : order.totalPrice,
        summary: paymentImplementation === null || paymentImplementation === void 0 ? void 0 : paymentImplementation.summary
    };
    const orderNumber = order === null || order === void 0 ? void 0 : order.orderNumber;
    const shippingMethod = order === null || order === void 0 ? void 0 : (ref7 = order.shippingInfo) === null || ref7 === void 0 ? void 0 : ref7.shippingMethodName;
    const shippingMethodInfo = getShippingMethodInfo(labels.summary, shippingMethod, shippingMethodsAsides);
    const isBigScreen = MediaQuery.useIsAbove(MediaQuery.BreakpointName.TABLET_PORTRAIT);
    return /*#__PURE__*/ React.createElement("div", {
        className: "checkout-step checkout-step--completed"
    }, /*#__PURE__*/ React.createElement("div", {
        className: "checkout-step__heading"
    }, /*#__PURE__*/ React.createElement(Heading, {
        variant: "small",
        component: "h1"
    }, labels.title), /*#__PURE__*/ React.createElement("p", null, callbackResultCode && callbackResultCode.toLowerCase() !== PaymentTypes.CallbackResultCode.Authorised ? labels.callbackResult[callbackResultCode] : labels.completed, orderNumber && /*#__PURE__*/ React.createElement("strong", null, " ", orderNumber)), labels.additionalMessage && /*#__PURE__*/ React.createElement("p", null, labels.additionalMessage), productMessageKeys.map((key)=>{
        const selectorResult = rest[key];
        return selectorResult === true && /*#__PURE__*/ React.createElement("p", {
            key: key,
            className: "checkout-step__product-specific-message"
        }, /*#__PURE__*/ React.createElement("strong", null, labels[key]));
    })), order ? /*#__PURE__*/ React.createElement("div", {
        className: "checkout-step__order"
    }, isBigScreen && /*#__PURE__*/ React.createElement(OrderCallToAction, null), /*#__PURE__*/ React.createElement(TitleWithIcon, {
        icon: "credit-card",
        label: labels.paymentDetailsTitle
    }), /*#__PURE__*/ React.createElement(PaymentInfo, swcHelpers.extends({}, paymentInfo)), /*#__PURE__*/ React.createElement(TitleWithIcon, {
        icon: "address-book",
        label: labels.contactDetailsTitle
    }), ContactDetailsSummary, /*#__PURE__*/ React.createElement(TitleWithIcon, {
        icon: "orders",
        label: labels.shipmentDetailsTitle
    }), /*#__PURE__*/ React.createElement(Summary, null, /*#__PURE__*/ React.createElement("div", {
        className: "checkout-summary--shipping-method"
    }, /*#__PURE__*/ React.createElement("span", null, shippingMethodInfo.label, " "), shippingMethodInfo.aside && shippingMethodInfo.aside)), isPickupStore(shippingMethod) && selectedStore && /*#__PURE__*/ React.createElement(LocationInfo, {
        location: selectedStore
    }), isPickupPoint(shippingMethod) && selectedPickupPoint && /*#__PURE__*/ React.createElement(LocationInfo, {
        location: selectedPickupPoint
    }), (isDelivery(shippingMethod) || isDeliveryExpress(shippingMethod)) && /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(TitleWithIcon, {
        icon: "location-pin",
        label: labels.shippingAddress
    }), order.shippingAddress ? DeliveryAddressSummary : BillingAddressSummary), order.billingAddress && /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(TitleWithIcon, {
        icon: "billing",
        label: labels.billingAddress
    }), isNearestPickup(shippingMethod) && /*#__PURE__*/ React.createElement(Alert, {
        icon: "info",
        message: labels.nearestPickupMessage
    }), BillingAddressSummary), invoice && optionalFormContainsData(invoice) && /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(TitleWithIcon, {
        icon: "newsletter",
        label: labels.invoiceLabel
    }), InvoiceSummary), ((ref8 = order.billingAddress) === null || ref8 === void 0 ? void 0 : ref8.company) && /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(TitleWithIcon, {
        icon: "company",
        label: labels.company
    }), CompanySummary), (features === null || features === void 0 ? void 0 : features.isServiceStoreEnabled) && serviceStore && /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(TitleWithIcon, {
        icon: "store",
        label: labels.serviceStore
    }), /*#__PURE__*/ React.createElement(ServiceStoreSummary, null))) : null, /*#__PURE__*/ React.createElement(OrderCallToAction, null));
};

const OrderConfirmContainer = ({ orderData , shippingMethodsAsides , status , cartId , cart , logo  })=>{
    var ref, ref1, ref2, ref3, ref4;
    const { getLabel , currency  } = useIntl();
    const [orderResponse, isLoading] = useGetOrderData(orderData);
    const labels = React.useMemo(()=>({
            title: getLabel('checkout.completed.title'),
            callbackResult: {
                authorised: getLabel('checkout.authorised.message', {
                    hideLabelKey: true
                }),
                cancelled: getLabel('checkout.cancelled.message', {
                    hideLabelKey: true
                }),
                refused: getLabel('checkout.refused.message', {
                    hideLabelKey: true
                }),
                pending: getLabel('checkout.pending.message', {
                    hideLabelKey: true
                }),
                received: getLabel('checkout.received.message', {
                    hideLabelKey: true
                })
            },
            completed: getLabel('checkout.completed.message'),
            additionalMessage: getLabel('checkout.completed.additionalMessage', {
                hideLabelKey: true
            }),
            cartContainsContactLenses: getLabel('checkout.completed.cartContainsContactLenses'),
            cartContainsPrescriptionGlasses: getLabel('checkout.completed.cartContainsPrescriptionGlasses'),
            cartContainsSolutions: getLabel('checkout.completed.cartContainsSolutions'),
            cartContainsSunglasses: getLabel('checkout.completed.cartContainsSunglasses'),
            cartContainsSubscription: getLabel('checkout.completed.cartContainsSubscription'),
            paymentDetailsTitle: getLabel('checkout.completed.paymentDetails.title'),
            contactDetailsTitle: getLabel('checkout.completed.contactDetails.title'),
            shipmentDetailsTitle: getLabel('checkout.completed.shipmentDetails.title'),
            shippingAddress: getLabel('checkout.shipment.address'),
            billingAddress: getLabel('checkout.billingAddress'),
            invoiceLabel: getLabel('checkout.invoice.label'),
            company: getLabel('checkout.orderType.company'),
            serviceStore: getLabel('checkout.serviceStore.title'),
            backToStore: getLabel('checkout.actions.backToStore'),
            summary: {
                delivery: getLabel('checkout.summary.shipment.delivery'),
                deliveryExpress: getLabel('checkout.summary.shipment.deliveryExpress'),
                pickupStore: getLabel('checkout.summary.shipment.pickup'),
                pickupPoint: getLabel('checkout.summary.shipment.pickupPoint'),
                nearestPickup: getLabel('checkout.summary.shipment.nearestPickup')
            },
            nearestPickupMessage: getLabel('checkout.summary.shipment.nearestPickup.message')
        })
    , [
        getLabel
    ]);
    const currentBreakpoint = MediaQuery.useBreakpoint();
    const isMobile = currentBreakpoint === MediaQuery.BreakpointName.PHONE || currentBreakpoint === MediaQuery.BreakpointName.TABLET_PORTRAIT;
    const cartContext = React.useContext(Context.CartContext);
    const callBackResultCode = PaymentTypes.CallbackResultCode[status];
    const cartContainsContactLenses = cartContext === null || cartContext === void 0 ? void 0 : (ref = cartContext.cart) === null || ref === void 0 ? void 0 : ref.contains.contactLenses;
    const cartContainsPrescriptionGlasses = cartContext === null || cartContext === void 0 ? void 0 : (ref1 = cartContext.cart) === null || ref1 === void 0 ? void 0 : ref1.contains.prescriptionGlasses;
    const cartContainsSolutions = cartContext === null || cartContext === void 0 ? void 0 : (ref2 = cartContext.cart) === null || ref2 === void 0 ? void 0 : ref2.contains.solutions;
    const cartContainsSunglasses = cartContext === null || cartContext === void 0 ? void 0 : (ref3 = cartContext.cart) === null || ref3 === void 0 ? void 0 : ref3.contains.sunglasses;
    const cartContainsSubscription = cartContext === null || cartContext === void 0 ? void 0 : (ref4 = cartContext.cart) === null || ref4 === void 0 ? void 0 : ref4.contains.subscription;
    const invoice = useSelector(getInvoice);
    const order = orderResponse;
    const selectedPaymentDetails = useSelector(getSelectedPaymentDetails);
    const selectedStore = useSelector(getSelectedStore);
    const serviceStore = useSelector(getServiceStore);
    const selectedPickupPoint = useSelector(getSelectedPickupPoint);
    const isCheckoutFailed = useSelector(isFailed);
    const summaries = useSummariesSlot(false);
    React.useEffect(()=>{
        order && pushPurchaseEventToDataLayer(order, currency, cartId);
    }, [
        cartId,
        currency,
        order
    ]);
    const renderSupportFooter = ()=>{
        const supportPhoneNumber = getLabel('support.phoneNumber', {
            hideLabelKey: true
        });
        const supportEmail = getLabel('support.emailAddress', {
            hideLabelKey: true
        });
        return /*#__PURE__*/ React.createElement(SupportFooter, {
            message: getLabel('support.title'),
            phoneNumber: supportPhoneNumber || undefined,
            email: supportEmail || undefined
        });
    };
    if (!order && isLoading) {
        return /*#__PURE__*/ React.createElement(Loader, null);
    }
    return /*#__PURE__*/ React.createElement(SplitPane, {
        main: /*#__PURE__*/ React.createElement("div", {
            className: "checkout-section checkout-section--main"
        }, /*#__PURE__*/ React.createElement("div", {
            className: "checkout-section__header"
        }, logo && /*#__PURE__*/ React.createElement(Logo, {
            url: "/",
            image: logo
        })), isMobile && /*#__PURE__*/ React.createElement("div", {
            className: "checkout-section__cart"
        }, cart ? cart : null), /*#__PURE__*/ React.createElement("div", {
            className: "checkout-section__body"
        }, isCheckoutFailed && /*#__PURE__*/ React.createElement(Alert, {
            className: "checkout-section__alert",
            type: "error",
            title: getLabel('checkout.errors.general.title'),
            message: getLabel('checkout.errors.general.message')
        }), /*#__PURE__*/ React.createElement(OrderConfirm, {
            callbackResultCode: callBackResultCode,
            cartContainsContactLenses: cartContainsContactLenses,
            cartContainsPrescriptionGlasses: cartContainsPrescriptionGlasses,
            cartContainsSolutions: cartContainsSolutions,
            cartContainsSubscription: cartContainsSubscription,
            cartContainsSunglasses: cartContainsSunglasses,
            invoice: invoice,
            labels: labels,
            order: order,
            selectedPaymentDetails: selectedPaymentDetails,
            selectedPickupPoint: selectedPickupPoint,
            selectedStore: selectedStore,
            serviceStore: serviceStore,
            shippingMethodsAsides: shippingMethodsAsides,
            summaries: summaries
        }))),
        aside: /*#__PURE__*/ React.createElement("div", {
            className: "checkout-section checkout-section--aside"
        }, !isMobile && /*#__PURE__*/ React.createElement("div", {
            className: "checkout-section__cart"
        }, cart ? cart : null), /*#__PURE__*/ React.createElement("div", {
            className: "checkout-section__support-footer"
        }, renderSupportFooter()))
    });
};

ReducersRegistry.register('checkout', reducer);
SagaRegistry.register('checkout', sagas);

export { toggleInvoice as $, getCompany as A, goToStep as B, CallbackResultCode as C, usePaymentState as D, useQrPaymentState as E, usePaymentMethodLabelsMap as F, getCheckout as G, getSelectedPaymentMethod as H, useAddAdditionalCosts as I, isFailed$1 as J, clearError as K, LocationInfo as L, selectPaymentMethod as M, getRestPaymentMethodName as N, OrderCallToAction as O, PaymentInfo as P, getAdditionalCartCosts as Q, createOrderFailed as R, ServiceStoreSummary as S, TitleWithIcon as T, getRoutes as U, getPaymentFlow as V, PaymentFlow as W, updatePaymentDetails as X, createOrder as Y, getPaymentMethodSettings as Z, useFormSlot as _, getGraphQLPaymentMethodName as a, getShippingDetails as a0, isUserDataPrefilled as a1, ShippingObjectTypes as a2, togglePrefill as a3, PrefillSources as a4, getAddressBookPrefillValidationResult as a5, togglePrefillFailed as a6, useBaseFormSlot as a7, useBaseSummarySlot as a8, ShippingMethods as a9, ServiceStore as aa, Consents as ab, ImplicitTermsAndConditionsContainer as ac, isShippingStepValid as ad, shouldCreateAccount as ae, toggleDeliveryAddress as af, toggleIsCompany as ag, markFieldsTouched as ah, setMyAccountValidation as ai, setServiceStoreValidation as aj, index$1 as ak, index as al, selectors as am, AddressLookup as an, ExpressCheckoutContainerWithMyAccount as ao, ExpressCheckoutUI as ap, CheckoutCart as aq, CheckoutRoot$1 as ar, OrderConfirmContainer as as, isQuotationLocation as at, AddressLineFormat as au, FormSlotsProvider as av, SummarySlotsProvider as aw, getPaymentImplementation as b, getShippingMethodInfo as c, isPickupPoint as d, isDelivery as e, isDeliveryExpress as f, getGraphQLPaymentProviderName as g, isNearestPickup as h, isPickupStore as i, getCallbackResultCode as j, getInvoice as k, getOrderResponse as l, getSelectedPaymentDetails as m, getSelectedStore as n, optionalFormContainsData as o, getServiceStore as p, getSelectedPickupPoint as q, useSummariesSlot as r, getShippingData as s, getSelectedShippingMethod as t, useCheckoutSettings as u, getCustomerDetailsPayload as v, StepNames as w, useSetCustomerDetails as x, getBillingAddress as y, getDeliveryAddress as z };
//# sourceMappingURL=index-e044af39.js.map
